import { get, Array, trim, RuleKind, empty, RulesConfigProp, WidgetsList, RuleConfigCondition, parseUrlParameter, RetargetingPage, URL, AgentActionKind, Date, EvaluationFrequency, TriggerKind as TriggerKind$1, Device, findMountElement, CredentialsRealm, isString, stringify, RuleConfigAbstractVariableRelationalOperation, uniq, isNumeric, emptyRecursive, RuleConfigRelationalOperation, notEmpty, isUndefined, isNumericGtZero, daysBetween, has, ReferenceTimezone, isBoolean, collectionClone, lt, gt, eq, isThnDate, gte, SocialDomain, merge, Scope, NostromoAvailabilityType, CountdownKind as CountdownKind$1, RightToLeftLanguageCode, DiscountCodeKind as DiscountCodeKind$1, CurrencyCode, OraculoSemanticLayer, NostromoPage, UriSchema, DayName, Day, setup, isIframed, reset, Promise$1, WidgetMode, PageName, stringCapitalize, bookingDatalayerModel, isPlainObject, bookingDetailsModel, bookingDetailsItemModel, datalayerEventBookingModel, WidgetTypeId, cancellable, generateCallbackQueue, AnalyticsEventName, pick, camelCase, PriceStatus, Map, comparisonStandardModel, identity, Recorder, isFunction, AbortablePromise, comparisonSseModel, ulid, set, omit, DEFAULT_PROPERTY_DESCRIPTOR, stringSnakeCase, invoke, debounce, ActivityKind as ActivityKind$1, AbortError, isUrl, trigger, datalayerEventSearchModel, comparisonPagesModel, isArray, flattenObject, toCamelCase$1, ary, isVisible, appendUrlParams, isEmail, openLink, PriceNightConfig } from './main.js';
import { md5 } from '@thehotelsnetwork/md5';

var ConditionKind = /*@__PURE__*/(function (ConditionKind = {}) {
    ConditionKind["Exclude"] = "exclude";
    ConditionKind["Include"] = "include";
    return ConditionKind;
})(ConditionKind);
var Operator = /*@__PURE__*/(function (Operator = {}) {
    Operator["Any"] = "any";
    Operator["Is"] = "is";
    Operator["Are"] = "are";
    Operator["IsBetween"] = "isBetween";
    Operator["AreBetween"] = "areBetween";
    Operator["IsLower"] = "isLower";
    Operator["AreLower"] = "areLower";
    Operator["IsHigher"] = "isHigher";
    Operator["IsGreater"] = "isGreater";
    Operator["AreGreater"] = "areGreater";
    Operator["IsBefore"] = "isBefore";
    Operator["AreBefore"] = "areBefore";
    Operator["IsAfter"] = "isAfter";
    Operator["AreAfter"] = "areAfter";
    Operator["Contain"] = "contain";
    return Operator;
})(Operator);
var DataVariableRuleOperator = /*@__PURE__*/(function (DataVariableRuleOperator = {}) {
    DataVariableRuleOperator["Is"] = "is";
    DataVariableRuleOperator["IsNot"] = "isNot";
    DataVariableRuleOperator["AnyValue"] = "anyValue";
    DataVariableRuleOperator["NotAnyValue"] = "notAnyValue";
    DataVariableRuleOperator["Lower"] = "lower";
    DataVariableRuleOperator["Greater"] = "greater";
    DataVariableRuleOperator["Contains"] = "contains";
    DataVariableRuleOperator["NotContains"] = "notContains";
    return DataVariableRuleOperator;
})(DataVariableRuleOperator);
/**
 * The visitor registration status in the website own credentials system.
 */
var VisitorStatus = /*@__PURE__*/(function (VisitorStatus = {}) {
    /**
     * @alias VisitorStatus.RegisteredAndLogged
     * @deprecated
     */
    VisitorStatus["Registered"] = "registered";
    /**
     * @alias VisitorStatus.NotLogged
     * @deprecated
     */
    VisitorStatus["NonRegistered"] = "non_registered";
    /**
     * The visitor is currently logged-in. Implicitly the visitor needs to be registered,
     * however there should be no strict check about registration status on implementations.
     */
    VisitorStatus["RegisteredAndLogged"] = "registered";
    /**
     * The visitor is not registered. This implicitly means the visitor is also
     * NOT currently logged-in, as being logged-in would imply registration.
     */
    VisitorStatus["NotRegisteredAndNotLogged"] = "non_registered_nor_logged";
    /**
     * The visitor is registered. If the visitor were to be currently logged-in that (too)
     * would imply It is registered.
     */
    VisitorStatus["RegisteredOrLogged"] = "registered_all";
    /**
     * The visitor is registered AND is not currently logged-in.
     */
    VisitorStatus["RegisteredAndNotLogged"] = "registered_non_logged";
    /**
     * The visitor is currently not logged-in, disregarding registration status.
     */
    VisitorStatus["NotLogged"] = "non_registered";
    return VisitorStatus;
})(VisitorStatus);

var FontType = /*@__PURE__*/(function (FontType = {}) {
    FontType["Google"] = "google";
    FontType["File"] = "file";
    FontType["Regular"] = "regular";
    return FontType;
})(FontType);

var ActivityKind = /*@__PURE__*/(function (ActivityKind = {}) {
    ActivityKind["NowViewing"] = "nowViewing";
    ActivityKind["TodayViewed"] = "todayViewed";
    ActivityKind["BookedToday"] = "bookedToday";
    ActivityKind["LastReservation"] = "lastReservation";
    ActivityKind["DiscountToday"] = "discountToday";
    ActivityKind["TodaySpecialOffer"] = "todaySpecialOffer";
    return ActivityKind;
})(ActivityKind);

var ButtonActionKind = /*@__PURE__*/(function (ButtonActionKind = {}) {
    ButtonActionKind["ApplyPromoCode"] = "apply_promo_code";
    ButtonActionKind["OpenUrl"] = "open_url";
    ButtonActionKind["OpenMailClient"] = "open_mail_client";
    ButtonActionKind["CallPhoneNumber"] = "call_phone_number";
    ButtonActionKind["CloseTool"] = "close_tool";
    ButtonActionKind["EmailCapture"] = "email_capture";
    ButtonActionKind["SavedSearch"] = "saved_search";
    ButtonActionKind["GoMainStep"] = "go_main_step";
    ButtonActionKind["SendForm"] = "form";
    ButtonActionKind["OpenBookingEngine"] = "send_to_be";
    ButtonActionKind["Submit"] = "submit";
    ButtonActionKind["LastSearch"] = "send_to_last_search";
    return ButtonActionKind;
})(ButtonActionKind);
var DiscountCodeKind = /*@__PURE__*/(function (DiscountCodeKind = {}) {
    DiscountCodeKind["Default"] = "default";
    DiscountCodeKind["Coupon"] = "coupon";
    DiscountCodeKind["Rate"] = "rate";
    DiscountCodeKind["Corporative"] = "corpo";
    DiscountCodeKind["Group"] = "group";
    return DiscountCodeKind;
})(DiscountCodeKind);

var ToolModuleKind = /*@__PURE__*/(function (ToolModuleKind = {}) {
    ToolModuleKind["Activity"] = "activity";
    ToolModuleKind["Button"] = "button";
    ToolModuleKind["Countdown"] = "countdown";
    ToolModuleKind["EmailCapture"] = "emailCapture";
    ToolModuleKind["Form"] = "form";
    ToolModuleKind["Heading"] = "heading";
    ToolModuleKind["ImageWithBehaviour"] = "imageWithBehaviour";
    ToolModuleKind["Icon"] = "icon";
    ToolModuleKind["Paragraph"] = "paragraph";
    ToolModuleKind["Perks"] = "perks";
    ToolModuleKind["SavedSearch"] = "savedSearch";
    ToolModuleKind["Spacer"] = "spacer";
    ToolModuleKind["Login"] = "login";
    ToolModuleKind["EmbeddedVideo"] = "video";
    return ToolModuleKind;
})(ToolModuleKind);

var CountdownKind = /*@__PURE__*/(function (CountdownKind = {}) {
    CountdownKind["Date"] = "date";
    CountdownKind["Time"] = "time";
    return CountdownKind;
})(CountdownKind);
var CountdownTimezone = /*@__PURE__*/(function (CountdownTimezone = {}) {
    CountdownTimezone["Visitor"] = "visitor";
    CountdownTimezone["Hotel"] = "hotel";
    return CountdownTimezone;
})(CountdownTimezone);

var DeviceKind = /*@__PURE__*/(function (DeviceKind = {}) {
    DeviceKind["Mobile"] = "mobile";
    DeviceKind["Desktop"] = "desktop";
    DeviceKind["Native"] = "native";
    return DeviceKind;
})(DeviceKind);

var TimingFrequency = /*@__PURE__*/(function (TimingFrequency = {}) {
    TimingFrequency["EveryPage"] = "on_every_page";
    TimingFrequency["OncePerVisit"] = "once_per_visit";
    TimingFrequency["OncePerVisitor"] = "once_per_visitor";
    TimingFrequency["OncePerProperty"] = "once_per_property";
    TimingFrequency["OncePerBrand"] = "once_per_brand";
    return TimingFrequency;
})(TimingFrequency);

var TriggerKind = /*@__PURE__*/(function (TriggerKind = {}) {
    TriggerKind["Load"] = "load";
    TriggerKind["Scroll"] = "scroll";
    TriggerKind["Idle"] = "idle";
    return TriggerKind;
})(TriggerKind);

var LocaleImageKind = /*@__PURE__*/(function (LocaleImageKind = {}) {
    LocaleImageKind["Single"] = "single";
    LocaleImageKind["Multi"] = "multi";
    return LocaleImageKind;
})(LocaleImageKind);
var ToolLayoutKind = /*@__PURE__*/(function (ToolLayoutKind = {}) {
    ToolLayoutKind["Bar"] = "bar";
    ToolLayoutKind["Circular"] = "circular";
    ToolLayoutKind["CustomImage"] = "custom-image";
    ToolLayoutKind["Fullscreen"] = "full-screen";
    ToolLayoutKind["FullscreenMini"] = "full-screen-mini";
    ToolLayoutKind["LowerNotification"] = "lower-notification";
    ToolLayoutKind["NotificationTab"] = "notification-tab";
    ToolLayoutKind["Sidebar"] = "sidebar";
    ToolLayoutKind["SideGradient"] = "side-gradient";
    ToolLayoutKind["SlideIn"] = "slide-in";
    ToolLayoutKind["Square"] = "square";
    ToolLayoutKind["SquareImage"] = "square-image";
    ToolLayoutKind["Sticky"] = "sticky";
    ToolLayoutKind["StickyImage"] = "sticky-image";
    return ToolLayoutKind;
})(ToolLayoutKind);

const RULES_FAIL_ICON$1 = '✖';
const RULES_FAIL_TEXT$1 = 'fail';
const RULES_FAIL_MSG$1 = `${RULES_FAIL_ICON$1} ${RULES_FAIL_TEXT$1}`;
const RULES_PASS_ICON$1 = '✔';
const RULES_PASS_TEXT$1 = 'pass';
const RULES_PASS_MSG$1 = `${RULES_PASS_ICON$1} ${RULES_PASS_TEXT$1}`;
const RULES_EMPTY_MSG = '<none>';

class RulesEvaluator {
    rules;
    container;
    constructor(rules, container) {
        this.rules = rules;
        this.container = container;
    }
    async evaluate(obj, lazy = true) {
        const output = {
            pass: true,
            logs: [],
            failedRules: [],
            errors: [],
        };
        for (const rule of this.rules) {
            const isDisjunction = !('match' in rule);
            const { pass, logs, errors } = await (isDisjunction
                ? this.evaluateDisjunctiveRules(rule, obj, lazy)
                : this.evaluateRule(rule, obj));
            if (errors.length) {
                output.errors.push(...errors);
            }
            if (isDisjunction) {
                output.logs.push(logs);
            }
            else {
                output.logs.push(...logs);
            }
            output.pass = output.pass && pass;
            if (!pass) {
                output.failedRules.push(rule);
                if (lazy) {
                    break;
                }
            }
        }
        return output;
    }
    async evaluateDisjunctiveRules(rules, obj, lazy) {
        const output = {
            pass: false,
            logs: [],
            errors: [],
        };
        for (const rule of rules) {
            const { pass, logs, errors } = await this.evaluateRule(rule, obj);
            if (errors.length) {
                output.errors.push(...errors);
            }
            output.logs.push(...logs);
            output.pass = output.pass || pass;
            if (pass && lazy) {
                break;
            }
        }
        return output;
    }
    async evaluateRule(rule, obj) {
        try {
            const providedDeps = await this.provideDeps(rule.deps ?? []);
            if (providedDeps === null) {
                throw new Error(`Unable to provide deps ${JSON.stringify(rule.deps)} for rule "${rule.id}"`);
            }
            await this.container?.scheduler.yield();
            const { pass, logs } = await rule.match(obj, providedDeps);
            return {
                errors: [],
                logs: [{
                        rule,
                        pass,
                        logs,
                    }],
                pass,
            };
        }
        catch (error) {
            return {
                errors: [error],
                logs: [],
                pass: false,
            };
        }
    }
    async provideDeps(deps) {
        let uncheckedProvidedDeps = [];
        try {
            uncheckedProvidedDeps = deps.map((depName) => get(this.container || {}, depName));
            // eslint-disable-next-line no-empty
        }
        catch (_) { }
        const providedDeps = uncheckedProvidedDeps.filter((depValue) => depValue !== undefined);
        if (providedDeps.length !== deps.length) {
            throw new Error(`Number of providedDeps and deps don't match, providedDeps: ${providedDeps.length}, deps: "${deps.length}"`);
        }
        return providedDeps;
    }
    static formatLogs(ruleLogs, label) {
        return ruleLogs.flatMap(ruleLogEntry => {
            const normalizedRuleLogs = Array.isArray(ruleLogEntry) ? ruleLogEntry : [ruleLogEntry];
            const labelDelimiters = Array.isArray(ruleLogEntry) ? ['[', ']'] : ['(', ')'];
            return normalizedRuleLogs.flatMap(ruleLog => {
                const logSubtreeLength = ruleLog.logs.length;
                const ruleLogHeader = `${labelDelimiters[0]}${label}${labelDelimiters[1]}   ${ruleLog.rule.description}: ${ruleLog.pass ? RULES_PASS_MSG$1 : RULES_FAIL_MSG$1}`;
                const logLines = logSubtreeLength
                    ? ruleLog.logs.map((line, index) => `               ${index === logSubtreeLength - 1 ? '└──' : '├──'} ${line}`)
                    : [];
                return [ruleLogHeader, ...logLines, ''];
            });
        });
    }
    static formatFailedLogs(ruleLogs) {
        const failedLog = ruleLogs.flatMap(logGroup => {
            if (Array.isArray(logGroup)) {
                // Return the last log if all disjunctive failed, otherwise empty
                return logGroup.every(log => !log.pass) ? logGroup.slice(-1) : [];
            }
            // Return log if failed, otherwise empty
            return !logGroup.pass ? logGroup : [];
        })[0];
        if (!failedLog) {
            return '';
        }
        const logTitle = failedLog.rule.description || '';
        const logDetails = failedLog.logs.slice(-1)[0] || '';
        return trim(`${logTitle} | ${logDetails}`, '|\\s\\uFEFF\\xA0');
    }
}

const buildDebugString = (pass, config, data) => {
    const actualConfig = config ?? RULES_EMPTY_MSG;
    const actualData = data ?? RULES_EMPTY_MSG;
    const configStr = isString(actualConfig) ? actualConfig : stringify(actualConfig);
    const dataStr = isString(actualData) ? actualData : stringify(actualData);
    const debugParts = [
        `config: ${configStr}`,
        `data: ${dataStr}`,
        `result: ${pass ? RULES_PASS_TEXT$1 : RULES_FAIL_TEXT$1}`,
    ];
    return debugParts.join(' ∕ ');
};

function getActualValue(source, constraint) {
    // Normalize actual raw value if undefined|null to undefined
    const actualRaw = source.get(constraint.key) ?? undefined;
    // Stringify complex values
    if (constraint.operation === RuleConfigAbstractVariableRelationalOperation.ValueDoesContain
        || constraint.operation === RuleConfigAbstractVariableRelationalOperation.ValueDoesNotContain) {
        let actualStr = '';
        if (actualRaw === undefined || actualRaw === null) {
            return actualRaw;
        }
        if (isString(actualRaw)) {
            actualStr = actualRaw.toLowerCase();
        }
        else if (typeof actualRaw === 'object') {
            actualStr = JSON.stringify(actualRaw).toLowerCase();
        }
        else if (isBoolean(actualRaw)) {
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            actualStr = `${actualRaw}`;
        }
        return actualStr;
    }
    // check if the parameter is more than once, if it is, take the last value
    const actual = Array.isArray(actualRaw)
        ? actualRaw[actualRaw.length - 1]
        : actualRaw;
    if (isString(actual)) {
        return actual.toLowerCase();
    }
    if (isBoolean(actual)) {
        return String(actual);
    }
    return actual;
}
function getExpectedValue({ value }) {
    return isString(value) ? value.toLowerCase() : value;
}
function getValues(source, constraint) {
    return {
        actual: getActualValue(source, constraint),
        expected: getExpectedValue(constraint),
    };
}
function flattenConstraints(ruleConfigSectionContents) {
    return ruleConfigSectionContents.flatMap((ruleConfigSectionItem) => (ruleConfigSectionItem.constraints.map((constraint) => ({ value: '', ...constraint, key: ruleConfigSectionItem.key }))));
}
function checkKeyValueConstraints(source, structuredConstraints) {
    const constraints = flattenConstraints(structuredConstraints);
    const logs = [];
    // Takes
    const stuffToAppear = constraints.filter(({ operation }) => (operation === RuleConfigAbstractVariableRelationalOperation.ValueIsEqual
        || operation === RuleConfigAbstractVariableRelationalOperation.ValueIsNotEmpty));
    // Make the array of variable names unique
    // so that if 2 variables to appear share the same name
    // only with the presence of one we pass the rule
    const stuffToApperKeys = uniq(stuffToAppear.map(({ key }) => key));
    // Does not take
    const stuffNotToAppear = constraints.filter(({ operation }) => (operation === RuleConfigAbstractVariableRelationalOperation.ValueIsNotEqual
        || operation === RuleConfigAbstractVariableRelationalOperation.ValueIsEmpty));
    const stuffToAppearThatMatches = stuffToAppear.filter((constraint) => {
        const { actual, expected, } = getValues(source, constraint);
        // eslint-disable-next-line eqeqeq
        if (actual !== undefined && (constraint.operation === RuleConfigAbstractVariableRelationalOperation.ValueIsNotEmpty || actual == expected)) {
            logs.push(buildDebugString(true, constraint, actual));
            return true;
        }
        logs.push(buildDebugString(false, constraint, actual));
        return false;
    });
    const stuffToAppearThatMatchesKeys = uniq(stuffToAppearThatMatches.map(({ key }) => key));
    const stuffNotToAppearThatMatches = stuffNotToAppear.filter((constraint) => {
        const { actual, expected, } = getValues(source, constraint);
        // eslint-disable-next-line eqeqeq
        if (actual !== undefined && (constraint.operation === RuleConfigAbstractVariableRelationalOperation.ValueIsEmpty || actual == expected) && actual !== '') { // "actual" can't be empty 'cause this is considered as "variable non-present"
            logs.push(buildDebugString(false, constraint, actual));
            return true;
        }
        logs.push(buildDebugString(true, constraint, actual));
        return false;
    });
    // Less than
    const stuffToBeLessThan = constraints.filter(({ operation }) => (operation === RuleConfigAbstractVariableRelationalOperation.ValueIsLowerThan));
    const stuffToBeLessThanThatMatches = stuffToBeLessThan.filter((constraint) => {
        const { actual, expected, } = getValues(source, constraint);
        if (isNumeric(actual) && isNumeric(expected) && Number(actual) < Number(expected)) {
            logs.push(buildDebugString(true, constraint, actual));
            return true;
        }
        logs.push(buildDebugString(false, constraint, actual));
        return false;
    });
    // Greater than
    const stuffToBeGreaterThan = constraints.filter(({ operation }) => (operation === RuleConfigAbstractVariableRelationalOperation.ValueIsGreaterThan));
    const stuffToBeGreaterThanThatMatches = stuffToBeGreaterThan.filter((constraint) => {
        const { actual, expected, } = getValues(source, constraint);
        if (isNumeric(actual) && isNumeric(expected) && Number(actual) > Number(expected)) {
            logs.push(buildDebugString(true, constraint, actual));
            return true;
        }
        logs.push(buildDebugString(false, constraint, actual));
        return false;
    });
    // Contain
    const stuffToBeContained = constraints.filter(({ operation }) => (operation === RuleConfigAbstractVariableRelationalOperation.ValueDoesContain));
    // Make the array of variable names unique
    // so that if 2 or more variables_contain share the same name
    // only with the presence of one we pass the rule
    const stuffToBeContainedKeys = uniq(stuffToBeContained.map(({ key }) => key));
    const stuffToBeContainedThatMatches = stuffToBeContained.filter((constraint) => {
        const { actual, expected, } = getValues(source, constraint);
        if (isString(actual) && isString(expected) && actual.includes(expected)) {
            logs.push(buildDebugString(true, constraint, actual));
            return true;
        }
        logs.push(buildDebugString(false, constraint, actual));
        return false;
    });
    const stuffToBeContainedThatMatchesKeys = uniq(stuffToBeContainedThatMatches.map(({ key }) => key));
    // Does not contain
    const stuffNotToBeContained = constraints.filter(({ operation }) => (operation === RuleConfigAbstractVariableRelationalOperation.ValueDoesNotContain));
    const stuffNotToBeContainedThatMatches = stuffNotToBeContained.filter((constraint) => {
        const { actual, expected, } = getValues(source, constraint);
        if (actual === undefined || (isString(actual) && isString(expected) && !actual.includes(expected))) {
            logs.push(buildDebugString(true, constraint, actual));
            return true;
        }
        logs.push(buildDebugString(false, constraint, actual));
        return false;
    });
    // All of the constraints to appear must be present
    const stuffToAppearPass = stuffToApperKeys.length === stuffToAppearThatMatchesKeys.length;
    // None of the constraints not to appear must be present
    const stuffNotToAppearPass = stuffNotToAppearThatMatches.length === 0;
    // All constraints with lesser than rule must be less
    const stuffToBeLessThanPass = stuffToBeLessThan.length === stuffToBeLessThanThatMatches.length;
    // All constraints with greater than rule must be greater
    const stuffToBeGreaterThanPass = stuffToBeGreaterThan.length === stuffToBeGreaterThanThatMatches.length;
    // All of the constraints contain must be present
    const stuffToBeContainedPass = stuffToBeContainedKeys.length === stuffToBeContainedThatMatchesKeys.length;
    // All of the constraints to not contain must be present
    const stuffNotToBeContainedPass = stuffNotToBeContained.length === stuffNotToBeContainedThatMatches.length;
    const pass = stuffToAppearPass
        && stuffNotToAppearPass
        && stuffToBeLessThanPass
        && stuffToBeGreaterThanPass
        && stuffToBeContainedPass
        && stuffNotToBeContainedPass;
    return {
        pass,
        logs,
    };
}

const id$T = 'datalayer_variables';
const kind$k = RuleKind.Targeting;
const description$T = 'Google Data Layer variables';
const deps$L = ['dataLayerHelper'];
const match$T = async (obj, [dataLayerHelper]) => {
    const { datalayerVariables } = obj.getRulesConfig();
    if (empty(datalayerVariables)) {
        return {
            pass: true,
            logs: [buildDebugString(true, datalayerVariables)],
        };
    }
    return checkKeyValueConstraints(dataLayerHelper, datalayerVariables);
};
const datalayerVariables = {
    id: id$T,
    kind: kind$k,
    description: description$T,
    deps: deps$L,
    match: match$T,
};

/**
 * Format range object for rule evaluation
 */
function formatDaysSinceLastVisit(comparator, range, services) {
    const { moment } = services;
    const formattedRange = collectionClone(range);
    (comparator.requiredKeys).forEach((key) => {
        // We inverse from and to, as we need to go from the furthest day of the range to the closest
        if (key === 'valueFrom') {
            formattedRange.to = moment().subtract(formattedRange[key], 'days');
        }
        else if (key === 'valueTo') {
            formattedRange.from = moment().subtract(formattedRange[key], 'days');
        }
        else if (key === 'valueSingle') {
            formattedRange.single = moment().subtract(formattedRange[key], 'days').startOf('day');
        }
    });
    return formattedRange;
}

function buildResultWithDebug(comparisonResult, rangeToCompare, input) {
    const rangeToCompareCopy = collectionClone(rangeToCompare);
    delete rangeToCompareCopy.single;
    delete rangeToCompareCopy.from;
    delete rangeToCompareCopy.to;
    const comparisonResultCopy = { ...comparisonResult };
    if ((comparisonResult.result && rangeToCompare.outcome === RuleConfigCondition.ShouldInclude) || (!comparisonResult.result && rangeToCompareCopy.outcome === RuleConfigCondition.ShouldExclude)) {
        comparisonResultCopy.evaluatedString = buildDebugString(true, rangeToCompareCopy, input);
    }
    else if ((!comparisonResult.result && rangeToCompare.outcome === RuleConfigCondition.ShouldInclude) || (comparisonResult.result && rangeToCompareCopy.outcome === RuleConfigCondition.ShouldExclude)) {
        comparisonResultCopy.evaluatedString = buildDebugString(false, rangeToCompareCopy, input);
    }
    else if (!rangeToCompare.outcome) {
        comparisonResultCopy.evaluatedString = comparisonResult.result ? buildDebugString(true, rangeToCompareCopy, input) : buildDebugString(false, rangeToCompareCopy, input);
    }
    return comparisonResultCopy;
}

function compareTimerangesNow(comparator, dataToCompare, rangeToCompare) {
    let value;
    if (rangeToCompare.referenceTimezone) {
        if ('valueToCompareByReferenceTimezone' in dataToCompare) {
            value = dataToCompare.valueToCompareByReferenceTimezone[rangeToCompare.referenceTimezone];
        }
    }
    else if ('valueToCompare' in dataToCompare) {
        value = dataToCompare.valueToCompare;
    }
    const comparatorResult = { result: false };
    if (value === undefined) {
        return buildResultWithDebug(comparatorResult, rangeToCompare, '<none>');
    }
    if (comparator.requiredKeys.length === 1) {
        comparatorResult.result = value[comparator.method](rangeToCompare.single, dataToCompare.granularity);
    }
    else {
        // https://momentjs.com/docs/#/query/is-between/
        const optionParameter = dataToCompare.granularity === 'hour' ? '[)' : '[]';
        comparatorResult.result = value[comparator.method](rangeToCompare.from, rangeToCompare.to, dataToCompare.granularity, optionParameter);
    }
    return buildResultWithDebug(comparatorResult, rangeToCompare, value[dataToCompare.debugMethod]());
}

/**
 * Returns an array of rules objects that match a given comparator ('less_than', 'greater_than', 'equal', etc)
 * @ignore
 * @param rules_array
 * @param  expected_comparator
 */
function getRangesByComparator(rulesArray, expectedComparator) {
    return rulesArray.filter((rule) => rule.operation === expectedComparator);
}

function isInArrayOfRanges(dataToCompare, ranges, callbacks, comparators, services) {
    const result = {
        expected: {},
        evaluated: {},
        matched: {},
        passed: true,
    };
    // Get expected ranges to evaluate
    comparators.forEach((comparator) => {
        // Sort expected rules to be evaluated by comparator type
        result.expected[comparator.type] = getRangesByComparator(ranges, (comparator.type)).filter((range) => has(range, comparator.requiredKeys));
    });
    // Remove empty ranges
    Object.keys(result.expected).forEach((expectedKey) => {
        if (!result.expected[expectedKey].length) {
            delete result.expected[expectedKey];
        }
    });
    // If no valid rules, pass
    if (empty(result.expected)) {
        return result;
    }
    // Evaluate each rule by comparator type
    comparators.forEach((comparator) => {
        if (result.expected[comparator.type]) {
            result.evaluated[comparator.type] = result.expected[comparator.type]
                // Format time ranges for comparison if format callback function is present
                .map((range) => {
                if (callbacks.formatRanges) {
                    return callbacks.formatRanges(comparator, range, services);
                }
                return range;
            })
                // Evaluate each occupancy range
                .map((range) => callbacks.compareRanges(comparator, dataToCompare, range));
            // Evaluate each occupancy range
            result.matched[comparator.type] = result.evaluated[comparator.type].filter((range) => range.result);
        }
    });
    // Some expected rules must have returned true for us to return true
    result.passed = comparators.some((comparator) => result.matched[comparator.type] && result.matched[comparator.type].length);
    return result;
}

/**
 * Checks if `n` is between `start` and up to, including, `end`. If
 * `end` is not specified, it's set to `start` with `start` then set to `0`.
 * If `start` is greater than `end` the params are swapped to support
 * negative ranges.
 *
 * @param number The number to check.
 * @param [start=0] The start of the range.
 * @param end The end of the range.
 * @returns Returns `true` if `number` is in the range, else `false`.
 */
// eslint-disable-next-line default-param-last
function inRange(number, end, start = 0) {
    if (!end) {
        return gte(number, 0) && gte(start, number);
    }
    if (gt(start, end)) {
        return gte(number, end) && gte(start, number);
    }
    return gte(number, start) && gte(end, number);
}

const comparatorTypes = {
    // Uses moment's query methods
    selectMoment: [
        {
            type: RuleConfigRelationalOperation.LessThan,
            requiredKeys: ['valueSingle'],
            method: 'isBefore',
        },
        {
            type: RuleConfigRelationalOperation.GreaterThan,
            requiredKeys: ['valueSingle'],
            method: 'isAfter',
        },
        {
            type: RuleConfigRelationalOperation.Equal,
            requiredKeys: ['valueSingle'],
            method: 'isSame',
        },
        {
            type: RuleConfigRelationalOperation.Between,
            requiredKeys: ['valueTo', 'valueFrom'],
            method: 'isBetween',
        },
    ],
    searchSelect: [
        {
            type: RuleConfigRelationalOperation.LessThan,
            requiredKeys: ['valueSingle'],
            method: lt,
        },
        {
            type: RuleConfigRelationalOperation.GreaterThan,
            requiredKeys: ['valueSingle'],
            method: gt,
        },
        {
            type: RuleConfigRelationalOperation.Equal,
            requiredKeys: ['valueTo', 'valueFrom'],
            method: eq,
        },
        {
            type: RuleConfigRelationalOperation.Between,
            requiredKeys: ['valueTo', 'valueFrom'],
            method: inRange,
        },
        {
            type: RuleConfigRelationalOperation.Contain,
            requiredKeys: ['valueSingle'],
            method: inRange,
        },
    ],
    // Uses moment's query methods
    dateMoment: [
        {
            type: RuleConfigRelationalOperation.LessThan,
            requiredKeys: ['valueSingle'],
            method: 'isBefore',
        },
        {
            type: RuleConfigRelationalOperation.GreaterThan,
            requiredKeys: ['valueSingle'],
            method: 'isAfter',
        },
        {
            type: RuleConfigRelationalOperation.Equal,
            requiredKeys: ['valueSingle'],
            method: 'isSame',
        },
        {
            type: RuleConfigRelationalOperation.Between,
            requiredKeys: ['valueTo', 'valueFrom'],
            method: 'isBetween',
        },
    ],
    // Uses moment's query methods
    searchDateMoment: [
        {
            type: RuleConfigRelationalOperation.LessThan,
            requiredKeys: ['valueSingle'],
            method: 'isBefore',
        },
        {
            type: RuleConfigRelationalOperation.GreaterThan,
            requiredKeys: ['valueSingle'],
            method: 'isAfter',
        },
        {
            type: RuleConfigRelationalOperation.Equal,
            requiredKeys: ['valueTo', 'valueFrom'],
            method: 'isSame',
        },
        {
            type: RuleConfigRelationalOperation.Between,
            requiredKeys: ['valueTo', 'valueFrom'],
            method: 'isBetween',
        },
        {
            type: RuleConfigRelationalOperation.Contain,
            requiredKeys: ['valueSingle'],
            method: 'isBetween',
        },
    ],
    // Uses moment's query methods
    retargetingMoment: [
        {
            type: RuleConfigRelationalOperation.LessThan,
            requiredKeys: ['valueSingle'],
            method: 'isAfter',
        },
        {
            type: RuleConfigRelationalOperation.GreaterThan,
            requiredKeys: ['valueSingle'],
            method: 'isBefore',
        },
        {
            type: RuleConfigRelationalOperation.Equal,
            requiredKeys: ['valueSingle'],
            method: 'isSame',
        },
        {
            type: RuleConfigRelationalOperation.Between,
            requiredKeys: ['valueTo', 'valueFrom'],
            method: 'isBetween',
        },
    ],
    input: [
        {
            type: RuleConfigRelationalOperation.LessThan,
            requiredKeys: ['valueSingle'],
            method: lt,
        },
        {
            type: RuleConfigRelationalOperation.GreaterThan,
            requiredKeys: ['valueSingle'],
            method: gt,
        },
        {
            type: RuleConfigRelationalOperation.Equal,
            requiredKeys: ['valueSingle'],
            method: eq,
        },
        {
            type: RuleConfigRelationalOperation.Between,
            requiredKeys: ['valueTo', 'valueFrom'],
            method: inRange,
        },
    ],
    bestAvailableRate: {
        [RuleConfigRelationalOperation.LessThan]: lt,
        [RuleConfigRelationalOperation.GreaterThan]: gt,
        [RuleConfigRelationalOperation.Equal]: eq,
        [RuleConfigRelationalOperation.Between]: inRange,
    },
};
const comparators = {
    [RulesConfigProp.VisitDates]: comparatorTypes.dateMoment,
    [RulesConfigProp.VisitDays]: comparatorTypes.selectMoment,
    [RulesConfigProp.VisitHours]: comparatorTypes.selectMoment,
    [RulesConfigProp.VisitorDaysSincePreviousVisit]: comparatorTypes.retargetingMoment,
    [RulesConfigProp.StayOccupancyAdults]: comparatorTypes.input,
    [RulesConfigProp.StayOccupancyChildren]: comparatorTypes.input,
    [RulesConfigProp.StayOccupancyRooms]: comparatorTypes.input,
    [RulesConfigProp.StayDates]: comparatorTypes.searchDateMoment,
    [RulesConfigProp.StayDays]: comparatorTypes.searchSelect,
    [RulesConfigProp.StayDaysUntilCheckIn]: comparatorTypes.input,
    [RulesConfigProp.StayLength]: comparatorTypes.input,
    [RulesConfigProp.StayTotalCost]: comparatorTypes.bestAvailableRate,
    [RulesConfigProp.VisitorPreviousVisitsCount]: comparatorTypes.input,
};

function evaluateMultipleRanges(dataToCompare, callbacks, rulesConfigSection, tool, services) {
    const outcomes = {
        [RuleConfigCondition.ShouldInclude]: [],
        [RuleConfigCondition.ShouldExclude]: [],
    };
    [RuleConfigCondition.ShouldInclude, RuleConfigCondition.ShouldExclude].forEach((outcome) => {
        const rulesConfigSectionContent = tool.getRulesConfig()[rulesConfigSection];
        outcomes[outcome] = rulesConfigSectionContent?.filter((rangeItem) => (rangeItem.outcome) === outcome);
    });
    const resultInclude = isInArrayOfRanges(dataToCompare, outcomes.include, callbacks, comparators[rulesConfigSection], services);
    const resultExclude = isInArrayOfRanges(dataToCompare, outcomes.exclude, callbacks, comparators[rulesConfigSection], services);
    let evaluatedStrings = [];
    [resultInclude.evaluated, resultExclude.evaluated].forEach((resultObject) => {
        if (resultObject) {
            Object.keys(resultObject).forEach((operator) => {
                evaluatedStrings = [...evaluatedStrings, ...resultObject[operator].map((range) => range.evaluatedString)];
            });
        }
    });
    return {
        pass: !!(emptyRecursive(outcomes.include) || resultInclude.passed) && (emptyRecursive(outcomes.exclude) || !resultExclude.passed),
        logs: evaluatedStrings,
    };
}

/**
 * Used to evaluate all rooms with type "timing" (scheduled_xxx, search_xxx)
 */
function commonTimingRules(obj, callbacks, rulesConfigSection, services) {
    const rulesConfigSectionContent = obj.getRulesConfig()[rulesConfigSection];
    const { getTimeData } = services;
    // early exit in case no rulegroup or timing rules
    if (empty(rulesConfigSectionContent)) {
        return {
            pass: true,
            logs: [buildDebugString(true)],
        };
    }
    const timeData = getTimeData(rulesConfigSection, services);
    function timeDataIsEmpty() {
        const rulesNumeric = [RulesConfigProp.StayDaysUntilCheckIn, RulesConfigProp.StayLength];
        if (empty(timeData)) {
            return true;
        }
        if (rulesNumeric.includes(rulesConfigSection)) {
            const requiredReferenceTimezones = {
                [ReferenceTimezone.Site]: rulesConfigSectionContent?.some((def) => def.referenceTimezone === ReferenceTimezone.Site),
                [ReferenceTimezone.Visitor]: rulesConfigSectionContent?.some((def) => def.referenceTimezone === ReferenceTimezone.Visitor),
            };
            if (requiredReferenceTimezones[ReferenceTimezone.Site]
                && 'valueToCompareByReferenceTimezone' in timeData
                && !isNumeric(timeData.valueToCompareByReferenceTimezone[ReferenceTimezone.Site])) {
                return true;
            }
            if (requiredReferenceTimezones[ReferenceTimezone.Visitor]
                && 'valueToCompareByReferenceTimezone' in timeData
                && !isNumeric(timeData.valueToCompareByReferenceTimezone[ReferenceTimezone.Visitor])) {
                return true;
            }
            if ('valueToCompare' in timeData && !isNumeric(timeData.valueToCompare)) {
                return true;
            }
        }
        return false;
    }
    // early exit in case no time data to compare
    if (timeDataIsEmpty()) {
        return {
            pass: false,
            logs: [buildDebugString(false, rulesConfigSectionContent)],
        };
    }
    return evaluateMultipleRanges(timeData, callbacks, rulesConfigSection, obj, { moment: services.moment });
}

function formatPwSearchDate(date, moment) {
    if (isThnDate(date)) {
        return date.replace(/\//g, '-');
    }
    if (isNumeric(date) && moment) {
        return moment.unix(date).format('YYYY-MM-DD');
    }
    return undefined;
}

/**
 * Used to get now with moment JS with the user's computer and the site timezone.
 *
 * @returns {object|undefined}
 */
function getMomentNow(moment, siteTimezone) {
    if (!moment) {
        return undefined;
    }
    const result = {
        [ReferenceTimezone.Visitor]: moment(),
    };
    if (siteTimezone) {
        result[ReferenceTimezone.Site] = moment().tz(siteTimezone);
    }
    return result;
}

/**
 * Get time data moment objects for each type of timing rule.
 * timeToCompare will be different based on the type of rule.
 */
function getTimeData(ruleKind, services) {
    const { moment, getVisitorLastComparison, globalState } = services;
    // RULE COMPARING WITH VISITOR'S LAST VISIT DATE
    if (ruleKind === RulesConfigProp.VisitorDaysSincePreviousVisit) {
        let valueToCompare;
        if (moment) {
            // When no previousSessionLastVisitDate exists
            // build a moment out of range straight to 1970
            const previousSessionLastVisitDate = globalState.visitor?.tracker?.previousSessionLastVisitDate;
            valueToCompare = empty(previousSessionLastVisitDate)
                ? moment.unix(0)
                : moment.unix(previousSessionLastVisitDate);
        }
        return {
            valueToCompare,
            granularity: 'day',
            debugMethod: 'utc',
        };
    }
    // Get now using moment if moment is available
    const momentNow = getMomentNow(moment, globalState.timezone);
    // RULES COMPARING WITH NOW (property's timezone or user timezone)
    if (ruleKind === RulesConfigProp.VisitHours && momentNow) {
        /*
         * Only the hour matters on this rule, but moment also compares dates.
         * Also note that The same moment taken on 2 different timezones are equal:
         * moment().isSame(moment().tz('us/pacific')) === true
         *
         * We take today's date and concatenate it with now's time so we can
         * compare time taking property timezone into account if needed.
         */
        const createMomentTime = (nowLocalized) => (nowLocalized && moment(`${moment().format('YYYY-MM-DD')}T${nowLocalized.format('HH:mm:ss')}`));
        return {
            valueToCompareByReferenceTimezone: {
                [ReferenceTimezone.Site]: createMomentTime(momentNow[ReferenceTimezone.Site]),
                [ReferenceTimezone.Visitor]: createMomentTime(momentNow[ReferenceTimezone.Visitor]),
            },
            granularity: 'hour',
            debugMethod: 'hour',
        };
    }
    if (ruleKind === RulesConfigProp.VisitDays && momentNow) {
        /*
         *  We get the day of the week (0 is sunday) and transpose it to a new moment.
         * This allows to compare days taking timezones into account if needed
         */
        const createMomentTime = (nowLocalized) => (nowLocalized && moment().day(nowLocalized.weekday()));
        return {
            valueToCompareByReferenceTimezone: {
                [ReferenceTimezone.Site]: createMomentTime(momentNow[ReferenceTimezone.Site]),
                [ReferenceTimezone.Visitor]: createMomentTime(momentNow[ReferenceTimezone.Visitor]),
            },
            granularity: 'day',
            debugMethod: 'day',
        };
    }
    if (ruleKind === RulesConfigProp.VisitDates && momentNow) {
        /*
         * We create a new moment object with now's date in order
         * to do the comparation and take timezones into account if needed
         */
        const createMomentTime = (nowLocalized) => (nowLocalized && moment(nowLocalized.format('YYYY-MM-DD')));
        return {
            valueToCompareByReferenceTimezone: {
                [ReferenceTimezone.Site]: createMomentTime(momentNow[ReferenceTimezone.Site]),
                [ReferenceTimezone.Visitor]: createMomentTime(momentNow[ReferenceTimezone.Visitor]),
            },
            granularity: 'day',
            debugMethod: 'format',
        };
    }
    // Get price widget dateBegin and dateEnd
    const { dateBegin: dateBeginOriginal, dateEnd: dateEndOriginal, } = getVisitorLastComparison()?.data.actual.search || {};
    // Format price data dates to ISO date format for moment manipulation
    const dateBegin = dateBeginOriginal && formatPwSearchDate(dateBeginOriginal, moment);
    const dateEnd = dateEndOriginal && formatPwSearchDate(dateEndOriginal, moment);
    // RULES COMPARING WITH STAY
    if (ruleKind === RulesConfigProp.StayDates && dateBegin && dateEnd && moment) {
        return {
            valueToCompare: {
                dateBegin: moment(dateBegin),
                dateEnd: moment(dateEnd),
            },
            granularity: 'day',
            debugMethod: 'format',
        };
    }
    if (ruleKind === RulesConfigProp.StayDays && dateBegin && dateEnd && moment) {
        // 0 is sunday - 6 is saturday
        return {
            valueToCompare: {
                dateBegin: moment(dateBegin).weekday(),
                dateEnd: moment(dateEnd).weekday(),
                lengthOfStay: daysBetween(dateBegin, dateEnd),
            },
            debugMethod: 'day',
        };
    }
    // RULES COMPARING WITH PRICE WIDGET SEARCH DATA && NOW
    if (ruleKind === RulesConfigProp.StayDaysUntilCheckIn && momentNow && dateBegin) {
        const createNumber = (nowLocalized) => (nowLocalized && moment(dateBegin).endOf('day').diff(nowLocalized.startOf('day'), 'days'));
        return {
            valueToCompareByReferenceTimezone: {
                [ReferenceTimezone.Site]: createNumber(momentNow[ReferenceTimezone.Site]),
                [ReferenceTimezone.Visitor]: createNumber(momentNow[ReferenceTimezone.Visitor]),
            },
        };
    }
    // RULES COMPARING WITH PRICE WIDGET SEARCH && !moment
    if (ruleKind === RulesConfigProp.StayLength && dateBegin && dateEnd) {
        return {
            valueToCompare: daysBetween(dateBegin, dateEnd),
        };
    }
    return undefined;
}

const id$S = 'days_since_last_visit';
const kind$j = RuleKind.Targeting;
const description$S = 'Days passed since user last visit';
const deps$K = ['globalState', 'async', 'getVisitorLastComparison'];
const match$S = async (obj, [globalState, asyncServices, getVisitorLastComparison]) => {
    const ruleConfig = obj.getRulesConfig()[RulesConfigProp.VisitorDaysSincePreviousVisit];
    if (!ruleConfig?.length) {
        return {
            pass: true,
            logs: [buildDebugString(true, ruleConfig)],
        };
    }
    const callbacks = {
        formatRanges: formatDaysSinceLastVisit,
        compareRanges: compareTimerangesNow,
    };
    const moment = await asyncServices.moment;
    return commonTimingRules(obj, callbacks, RulesConfigProp.VisitorDaysSincePreviousVisit, {
        globalState, moment, getVisitorLastComparison, getTimeData,
    });
};
const daysSinceLastVisit = {
    id: id$S,
    kind: kind$j,
    description: description$S,
    deps: deps$K,
    match: match$S,
};

const rulePropMap$3 = {
    valueTo: 'to',
    valueFrom: 'from',
    valueSingle: 'single',
};
function formatInputRanges(comparator, range) {
    const formattedRange = collectionClone(range);
    comparator.requiredKeys.forEach((key) => {
        formattedRange[rulePropMap$3[key]] = formattedRange[key];
    });
    return formattedRange;
}

function compareInputRanges(comparator, dataToCompare, rangeToCompare) {
    let value;
    if (rangeToCompare.referenceTimezone) {
        if ('valueToCompareByReferenceTimezone' in dataToCompare) {
            value = dataToCompare.valueToCompareByReferenceTimezone[rangeToCompare.referenceTimezone];
        }
    }
    else if ('valueToCompare' in dataToCompare) {
        value = dataToCompare.valueToCompare;
    }
    const comparatorResult = { result: false };
    if (value === undefined) {
        return buildResultWithDebug(comparatorResult, rangeToCompare, '<none>');
    }
    if ('single' in rangeToCompare) {
        comparatorResult.result = comparator.method(Number(value), Number(rangeToCompare.single));
    }
    else {
        comparatorResult.result = comparator.method(Number(value), Number(rangeToCompare.from), Number(rangeToCompare.to));
    }
    return buildResultWithDebug(comparatorResult, rangeToCompare, value);
}

const id$R = 'days_until_checkin';
const kind$i = RuleKind.Targeting;
const description$R = 'Days until checkin';
const deps$J = ['globalState', 'async', 'getVisitorLastComparison'];
const match$R = async (obj, [globalState, asyncServices, getVisitorLastComparison]) => {
    const ruleConfig = obj.getRulesConfig()[RulesConfigProp.StayDaysUntilCheckIn];
    if (!ruleConfig?.length) {
        return {
            pass: true,
            logs: [buildDebugString(true, ruleConfig)],
        };
    }
    const callbacks = {
        formatRanges: formatInputRanges,
        compareRanges: compareInputRanges,
    };
    const moment = await asyncServices.moment;
    return commonTimingRules(obj, callbacks, RulesConfigProp.StayDaysUntilCheckIn, {
        globalState, moment, getVisitorLastComparison, getTimeData,
    });
};
const daysUntilCheckin = {
    id: id$R,
    kind: kind$i,
    description: description$R,
    deps: deps$J,
    match: match$R,
};

const id$Q = 'demand';
const kind$h = RuleKind.Targeting;
const description$Q = 'Demand of the hotel';
const deps$I = ['demandManager'];
const match$Q = async (obj, [demandManager]) => {
    const { stayDemand } = obj.getRulesConfig();
    const currentDemand = demandManager.get();
    // If no conditions, just pass the rule
    if (empty(stayDemand)) {
        const pass = true;
        return {
            pass,
            logs: [buildDebugString(pass, stayDemand, { currentDemand })],
        };
    }
    const evalStayDemandItem = (stayDemandItem) => (stayDemandItem.operation === RuleConfigRelationalOperation.Equal
        && stayDemandItem.valueSingle === currentDemand);
    const pass = stayDemand.some(evalStayDemandItem);
    const logs = [buildDebugString(pass, stayDemand, { currentDemand })];
    return {
        pass,
        logs,
    };
};
const demand = {
    id: id$Q,
    kind: kind$h,
    description: description$Q,
    deps: deps$I,
    match: match$Q,
};

const id$P = 'demand_known';
const description$P = 'Demand level needs to be known';
const deps$H = ['demandManager'];
const match$P = async (obj, [demandManager]) => {
    const { stayDemand } = obj.getRulesConfig();
    const currentDemand = demandManager.get();
    const isKnown = currentDemand !== null;
    // To pass this rule, either the targeteable object does not have a stayDemand config
    // OR if it does, then the demandManager must know the current level of demand
    const pass = empty(stayDemand) || isKnown;
    return {
        pass,
        logs: [buildDebugString(pass, stayDemand, isKnown)],
    };
};
const demandKnown = {
    id: id$P,
    description: description$P,
    deps: deps$H,
    match: match$P,
};

const id$O = 'disparities';
const kind$g = RuleKind.Targeting;
const description$O = 'Disparities';
const deps$G = ['disparitiesManager'];
const isInRange = (disparityRatio, disparityItem) => {
    switch (disparityItem.operation) {
        case RuleConfigRelationalOperation.Between:
            return disparityRatio > disparityItem.valueFrom
                && disparityRatio < disparityItem.valueTo;
        case RuleConfigRelationalOperation.GreaterThan:
            return disparityRatio > disparityItem.valueSingle;
        case RuleConfigRelationalOperation.LessThan:
            return disparityRatio < disparityItem.valueSingle;
        default:
            return false;
    }
};
const match$O = async (obj, [disparitiesManager]) => {
    const { stayDisparities } = obj.getRulesConfig();
    const currentDisparities = disparitiesManager.get();
    // If no conditions, just pass the rule
    if (empty(stayDisparities)) {
        const pass = true;
        return {
            pass,
            logs: [buildDebugString(pass, stayDisparities, currentDisparities)],
        };
    }
    const logs = [];
    const evalStayDisparitiesItem = (stayDisparitiesItem) => {
        const itemPass = currentDisparities.some((currentDisparity) => (stayDisparitiesItem.sources.includes(currentDisparity.data.sourceId)
            && isInRange(currentDisparity.data.disparityRatio, stayDisparitiesItem)));
        logs.push(buildDebugString(itemPass, stayDisparitiesItem, currentDisparities));
        return itemPass;
    };
    const pass = stayDisparities.some(evalStayDisparitiesItem);
    return {
        pass,
        logs,
    };
};
const disparities = {
    id: id$O,
    kind: kind$g,
    description: description$O,
    deps: deps$G,
    match: match$O,
};

const id$N = 'disparities_known';
const description$N = 'Disparities need to be known';
const deps$F = ['disparitiesManager'];
const match$N = async (obj, [disparitiesManager]) => {
    const { stayDisparities } = obj.getRulesConfig();
    const currentDisparities = disparitiesManager.get();
    const isKnown = currentDisparities.length > 0;
    // To pass this rule, either the targeteable object does not have a stayDisparities config
    // OR if it does, then the disparitiesManager must have some stored disparity
    const pass = empty(stayDisparities) || isKnown;
    return {
        pass,
        logs: [buildDebugString(pass, stayDisparities, isKnown)],
    };
};
const disparitiesKnown = {
    id: id$N,
    description: description$N,
    deps: deps$F,
    match: match$N,
};

const id$M = 'duetto';
const kind$f = RuleKind.Targeting;
const description$M = 'Duetto demand of the hotel';
const deps$E = ['duettoManager'];
const match$M = async (obj, [duettoManager]) => {
    const { stayDuettoDemand } = obj.getRulesConfig();
    const currentDuettoScore = duettoManager.get();
    // If no conditions, just pass the rule
    if (empty(stayDuettoDemand)) {
        const pass = true;
        return {
            pass,
            logs: [buildDebugString(pass, stayDuettoDemand, { currentDuettoScore })],
        };
    }
    const pass = stayDuettoDemand.some((stayDuettoDemandItem) => currentDuettoScore
        && (stayDuettoDemandItem.min <= currentDuettoScore) // range inclusive for min value
        && (stayDuettoDemandItem.max === 100
            ? currentDuettoScore <= stayDuettoDemandItem.max // range should be inclusive when max is 100
            : currentDuettoScore < stayDuettoDemandItem.max // range should be exclusive when max is not 100
        ));
    const logs = [buildDebugString(pass, stayDuettoDemand, { currentDuettoScore })];
    return {
        pass,
        logs,
    };
};
const duetto = {
    id: id$M,
    kind: kind$f,
    description: description$M,
    deps: deps$E,
    match: match$M,
};

const id$L = 'duetto_known';
const description$L = 'Duetto score needs to be known';
const deps$D = ['duettoManager'];
const match$L = async (obj, [duettoManager]) => {
    const { stayDuettoDemand } = obj.getRulesConfig();
    const currentDuettoScore = duettoManager.get();
    const isKnown = currentDuettoScore !== null;
    // To pass this rule, either the targeteable object does not have a stayDuettoDemand config
    // OR if it does, then the duettoManager must know the current duetto score
    const pass = empty(stayDuettoDemand) || isKnown;
    return {
        pass,
        logs: [buildDebugString(pass, stayDuettoDemand, isKnown)],
    };
};
const duettoKnown = {
    id: id$L,
    description: description$L,
    deps: deps$D,
    match: match$L,
};

const id$K = 'exit_trigger';
const description$K = 'The visitor is leaving';
const deps$C = ['exitManager'];
const match$K = async (obj, [exitManager]) => {
    const { widgetName } = obj.getContext();
    // early exit in case the tool is not an "Exit" tool
    if (widgetName !== WidgetsList.Exit) {
        return {
            pass: true,
            logs: [buildDebugString(true, 'Not an "Exit" tool')],
        };
    }
    // check if the visitor is leaving the page
    const isExiting = exitManager.isExiting();
    return {
        pass: isExiting,
        logs: [buildDebugString(isExiting, 'Exit trigger', `Has ${isExiting ? '' : 'not '}triggered exit state`)],
    };
};
const exitTrigger = {
    id: id$K,
    description: description$K,
    deps: deps$C,
    match: match$K,
};

const id$J = 'geolocation';
const kind$e = RuleKind.Targeting;
const description$J = 'Visitor geolocation';
const deps$B = ['globalState'];
const match$J = async (obj, [globalState]) => {
    const { visitorGeolocation } = obj.getRulesConfig();
    const visitorGeonameIds = globalState.visitor?.geolocation?.geonameIds;
    // early exit in case no visitorGeolocation rules or no visitor geonameIds
    if (empty(visitorGeolocation) || empty(visitorGeonameIds)) {
        return {
            pass: true,
            logs: [buildDebugString(true, '<none>')],
        };
    }
    const conditions = {
        include: visitorGeolocation.filter((geoRule) => geoRule.outcome === RuleConfigCondition.ShouldInclude),
        exclude: visitorGeolocation.filter((geoRule) => geoRule.outcome === RuleConfigCondition.ShouldExclude),
    };
    // Fulfills if:
    // - we know the user location
    // + the location is in one of the IN locations
    //   (or there are no IN locations)
    // + the location is not one of the OUT locations
    //   (or there are no OUT locations)
    const pass = (empty(conditions.include)
        || conditions.include.map((geoRule) => geoRule.geonameId).some((geonameId) => visitorGeonameIds.includes(geonameId))) && (empty(conditions.exclude)
        || !conditions.exclude.map((geoRule) => geoRule.geonameId).some((geonameId) => visitorGeonameIds.includes(geonameId)));
    return {
        pass,
        logs: [buildDebugString(pass, conditions, visitorGeonameIds.toString())],
    };
};
const geolocation = {
    id: id$J,
    kind: kind$e,
    description: description$J,
    deps: deps$B,
    match: match$J,
};

const id$I = 'length_of_stay';
const kind$d = RuleKind.Targeting;
const description$I = 'Length of the visitor\'s stay';
const deps$A = ['globalState', 'async', 'getVisitorLastComparison'];
const match$I = async (obj, [globalState, asyncServices, getVisitorLastComparison]) => {
    const ruleConfig = obj.getRulesConfig()[RulesConfigProp.StayLength];
    if (!ruleConfig?.length) {
        return {
            pass: true,
            logs: [buildDebugString(true, ruleConfig)],
        };
    }
    const callbacks = {
        formatRanges: formatInputRanges,
        compareRanges: compareInputRanges,
    };
    const moment = await asyncServices.moment;
    return commonTimingRules(obj, callbacks, RulesConfigProp.StayLength, {
        globalState, moment, getVisitorLastComparison, getTimeData,
    });
};
const lengthOfStay = {
    id: id$I,
    kind: kind$d,
    description: description$I,
    deps: deps$A,
    match: match$I,
};

function commonOccupancyRules(obj, ruleConfigSection, getVisitorLastComparison) {
    const callbacks = {
        formatRanges: formatInputRanges,
        compareRanges: compareInputRanges,
    };
    const rulesConfig = obj.getRulesConfig();
    // early exit in case no rulegroup or occupancy rules
    if (empty(rulesConfig[ruleConfigSection])) {
        return {
            pass: true,
            logs: [buildDebugString(true)],
        };
    }
    const priceData = getVisitorLastComparison()?.data.actual.search;
    // early exit in case of missing search data
    if (!priceData
        || (notEmpty(rulesConfig.stayOccupancyChildren) && (!isNumeric(priceData.children) || isUndefined(priceData.children)))
        || (notEmpty(rulesConfig.stayOccupancyAdults) && !isNumericGtZero(priceData.adults))
        || (notEmpty(rulesConfig.stayOccupancyRooms) && !isNumericGtZero(priceData.rooms))) {
        return {
            pass: false,
            logs: [buildDebugString(false, 'requires-pw-data', 'missing-or-invalid-data')],
        };
    }
    const ruleTypeNamesMap = {
        stayOccupancyAdults: 'adults',
        stayOccupancyChildren: 'children',
        stayOccupancyRooms: 'rooms',
    };
    return evaluateMultipleRanges({ valueToCompare: Number(priceData[ruleTypeNamesMap[ruleConfigSection]]) }, callbacks, ruleConfigSection, obj);
}

const id$H = 'occupancy_adults';
const kind$c = RuleKind.Targeting;
const description$H = 'Stay occupancy (adults)';
const deps$z = ['getVisitorLastComparison'];
const match$H = async (obj, [getVisitorLastComparison]) => commonOccupancyRules(obj, RulesConfigProp.StayOccupancyAdults, getVisitorLastComparison);
const occupancyAdults = {
    id: id$H,
    kind: kind$c,
    description: description$H,
    deps: deps$z,
    match: match$H,
};

const id$G = 'occupancy_children';
const kind$b = RuleKind.Targeting;
const description$G = 'Stay occupancy (children)';
const deps$y = ['getVisitorLastComparison'];
const match$G = async (obj, [getVisitorLastComparison]) => commonOccupancyRules(obj, RulesConfigProp.StayOccupancyChildren, getVisitorLastComparison);
const occupancyChildren = {
    id: id$G,
    kind: kind$b,
    description: description$G,
    deps: deps$y,
    match: match$G,
};

const id$F = 'occupancy_rooms';
const kind$a = RuleKind.Targeting;
const description$F = 'Stay rooms';
const deps$x = ['getVisitorLastComparison'];
const match$F = async (obj, [getVisitorLastComparison]) => commonOccupancyRules(obj, RulesConfigProp.StayOccupancyRooms, getVisitorLastComparison);
const occupancyRooms = {
    id: id$F,
    kind: kind$a,
    description: description$F,
    deps: deps$x,
    match: match$F,
};

const id$E = 'oraculos_standard';
const kind$9 = RuleKind.Targeting;
const description$E = 'Oraculos standard';
const deps$w = ['oraculoManager'];
const match$E = async (tool, [oraculoManager]) => {
    const { visitorOraculoScore } = tool.getRulesConfig();
    if (empty(visitorOraculoScore)) {
        return {
            pass: true,
            logs: [buildDebugString(true)],
        };
    }
    const ruleResults = [];
    const logs = [];
    visitorOraculoScore.forEach((oraculoRuleItem) => {
        const probability = oraculoManager.getSemanticLayer(oraculoRuleItem.kind);
        // This guard should be unreachable. At this point we should have a valid probability
        if (probability === null) {
            const pass = false;
            ruleResults.push(pass);
            logs.push(buildDebugString(pass, oraculoRuleItem, 'missing accumulated probability'));
            return;
        }
        const pass = oraculoRuleItem.min <= probability // range inclusive for min value
            && (oraculoRuleItem.max === 100
                ? probability <= oraculoRuleItem.max // range should be inclusive when max is 100
                : probability < oraculoRuleItem.max // range should be exclusive when max is not 100
            );
        ruleResults.push(pass);
        logs.push(buildDebugString(pass, oraculoRuleItem, `Oraculo accumulated probability of ${probability} ${pass ? 'is' : 'not'} in range`));
    });
    const pass = ruleResults.every((result) => result);
    return {
        pass,
        logs,
    };
};
const oraculosStandard = {
    id: id$E,
    kind: kind$9,
    description: description$E,
    deps: deps$w,
    match: match$E,
};

/**
 * Check if any valid origin is on the origins sources.
 */
function checkOrigins(validOrigins, actualOrigins) {
    if (validOrigins.length === 0) {
        return true;
    }
    if (actualOrigins.length === 0) {
        return false;
    }
    let originMatch = false;
    for (let i = 0; i < actualOrigins.length; i += 1) {
        for (let j = 0; j < validOrigins.length; j += 1) {
            const pattern = validOrigins[j].indexOf('.') === -1 && actualOrigins[i].indexOf('.') !== -1
                ? `(^|\\.)${validOrigins[j]}\\.` : validOrigins[j].replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
            const regxp1 = new RegExp(pattern, 'i');
            if (actualOrigins[i] && regxp1 && actualOrigins[i].match(regxp1) !== null) {
                originMatch = true;
                break;
            }
        }
        if (originMatch) {
            break;
        }
    }
    return originMatch;
}

const id$D = 'origin_match';
const kind$8 = RuleKind.Targeting;
const description$D = 'Origin match';
const deps$v = ['globalThis', 'globalState'];
/*
 This rule differs from others as it cannot combine includes and excludes,
 it's only been required to define that sources are either included or excluded, not both.
 */
const match$D = async (obj, [globalThis, globalState]) => {
    const { trafficSource } = obj.getRulesConfig();
    const logs = [];
    // early exit in case no rulegroup or origins rules
    if (empty(trafficSource)) {
        return {
            pass: true,
            logs: [buildDebugString(true)],
        };
    }
    const utmSource = parseUrlParameter('utm_source', globalThis.location?.search).toLowerCase();
    const sessionOrigin = globalState.visitor?.tracker?.sessionOrigin;
    const candidateReferrers = [
        globalThis.document?.referrer,
        utmSource,
        sessionOrigin,
    ].filter((value) => !empty(value));
    const evalTrafficSource = (trafficSourceRule) => {
        const originMatch = checkOrigins(trafficSourceRule.sourceDomains, candidateReferrers);
        // sources may be either included or excluded (not both like in some other rules)
        const pass = trafficSourceRule.outcome === RuleConfigCondition.ShouldInclude
            ? originMatch : !originMatch;
        logs.push(buildDebugString(pass, trafficSourceRule, { candidateReferrers }));
        return pass;
    };
    return {
        pass: trafficSource.every(evalTrafficSource),
        logs,
    };
};
const originMatch = {
    id: id$D,
    kind: kind$8,
    description: description$D,
    deps: deps$v,
    match: match$D,
};

/**
 * Format range object for rule evaluation
 */
function formatPriceRange(convertCurrency, totalCostCondition, currencies) {
    if (totalCostCondition.operation === 'between') {
        const from = convertCurrency(currencies, totalCostCondition.valueFrom, totalCostCondition.currencyCode, 'USD');
        const to = convertCurrency(currencies, totalCostCondition.valueTo, totalCostCondition.currencyCode, 'USD');
        return {
            from,
            valueFrom: from,
            to,
            valueTo: to,
        };
    }
    const single = convertCurrency(currencies, totalCostCondition.valueSingle, totalCostCondition.currencyCode, 'USD');
    return {
        single,
        valueSingle: single,
    };
}

const id$C = 'price_range';
const kind$7 = RuleKind.Targeting;
const description$C = 'Price range';
const deps$u = ['globalState', 'getVisitorLastComparison', 'convertCurrency'];
const match$C = async (tool, [globalState, getVisitorLastComparison, convertCurrency]) => {
    const { stayTotalCost } = tool.getRulesConfig();
    const evaluatedStrings = [];
    // If no conditions, just pass the rule
    if (empty(stayTotalCost)) {
        return {
            pass: true,
            logs: [buildDebugString(true)],
        };
    }
    // If PW empty, check last search AFTER origin
    const visitorLastComparison = getVisitorLastComparison({ acceptWithoutAvailability: false });
    const priceData = visitorLastComparison?.data.actual.search;
    const widgetName = visitorLastComparison?.data.actual.context.widgetName;
    const evalStayTotalCost = (stayTotalCostRule) => {
        if (empty(stayTotalCostRule.currencyCode)
            || (stayTotalCostRule.operation !== RuleConfigRelationalOperation.Between
                && empty(stayTotalCostRule.valueSingle)) || (stayTotalCostRule.operation === RuleConfigRelationalOperation.Between
            && (empty(stayTotalCostRule.valueFrom) || empty(stayTotalCostRule.valueTo)))) {
            return true;
        }
        // If missing price_data rule fails
        if (!priceData || empty(priceData.price) || empty(priceData.dateBegin) || empty(priceData.dateEnd)) {
            evaluatedStrings.push('Missing search data');
            return false;
        }
        const amount = convertCurrency(globalState.currencies, priceData.price, priceData.currency, 'USD');
        const range = formatPriceRange(convertCurrency, stayTotalCostRule, globalState.currencies);
        if (!amount || (!range.single && (!range.to || !range.from))) {
            evaluatedStrings.push('Missing price data');
            return false;
        }
        // If PW: multiply by amount of days. if PWP: total is already per stay
        const total = widgetName === 'price'
            ? amount * daysBetween(priceData.dateBegin, priceData.dateEnd)
            : amount;
        const method = comparators.stayTotalCost && !Array.isArray(comparators.stayTotalCost) ? comparators.stayTotalCost[stayTotalCostRule.operation] : undefined;
        if (method) {
            const result = compareInputRanges({ method }, { valueToCompare: total }, range);
            if (result.evaluatedString) {
                evaluatedStrings.push(result.evaluatedString);
            }
            return result.result;
        }
        return false;
    };
    const pass = stayTotalCost.every(evalStayTotalCost);
    const logs = evaluatedStrings;
    return {
        pass,
        logs,
    };
};
const priceRange = {
    id: id$C,
    kind: kind$7,
    description: description$C,
    deps: deps$u,
    match: match$C,
};

const id$B = 'retargeting';
const kind$6 = RuleKind.Targeting;
const description$B = 'Retargeting';
const deps$t = ['globalState'];
const MSG_NO_BE_VISIT = 'No past Booking Engine visit';
const evalVisitorProgressFunnel = (visitorProgressFunnelRuleConfigItem, tracker) => {
    const lastPageFrom = visitorProgressFunnelRuleConfigItem?.pageFrom ?? null;
    const lastPageTo = visitorProgressFunnelRuleConfigItem?.pageTo ?? null;
    // Directly pass if there is no rule to check
    // Note: if the rule is set to "Any" page, there won't be anything to be checked
    if (empty(lastPageFrom) && empty(lastPageTo)) {
        return [true, visitorProgressFunnelRuleConfigItem, undefined];
    }
    // Directly pass if targeting Home Page and there are not previous visits to the Booking Engine, but previous visits exist
    // Note: we cannot be sure if the Home Page has really been visited. This is the best possible approximation
    if (lastPageFrom === 1 && lastPageTo === 1 && !empty(tracker?.previousVisitDate) && empty(tracker?.previousBookingEnginePage)) {
        return [true, visitorProgressFunnelRuleConfigItem, MSG_NO_BE_VISIT];
    }
    // Directly fail if a previous visit to the BE is required but none exists
    if (empty(tracker?.previousBookingEnginePage)) {
        return [false, visitorProgressFunnelRuleConfigItem, MSG_NO_BE_VISIT];
    }
    const pageFromFulfills = lastPageFrom == null || !!(tracker?.previousBookingEnginePage && lastPageFrom <= tracker?.previousBookingEnginePage);
    const pageToFulfills = lastPageTo == null || !!(tracker?.previousBookingEnginePage && lastPageTo >= tracker?.previousBookingEnginePage);
    const pass = pageFromFulfills && pageToFulfills;
    return [pass, visitorProgressFunnelRuleConfigItem, tracker?.previousBookingEnginePage];
};
const match$B = async (tool, [globalState]) => {
    const { visitorFunnelProgress } = tool.getRulesConfig();
    if (empty(visitorFunnelProgress)) {
        return {
            pass: true,
            logs: [buildDebugString(true, null, '?')],
        };
    }
    const logs = [];
    const pass = !!visitorFunnelProgress?.every((visitorProgressFunnelRuleConfigItem) => {
        const itemResult = evalVisitorProgressFunnel(visitorProgressFunnelRuleConfigItem, globalState.visitor?.tracker);
        logs.push(buildDebugString(...itemResult).replace(/\d+/g, (pageCode) => `${pageCode} [${RetargetingPage[Number(pageCode)]}]`));
        return itemResult[0];
    });
    return {
        pass,
        logs,
    };
};
const retargeting = {
    id: id$B,
    kind: kind$6,
    description: description$B,
    deps: deps$t,
    match: match$B,
};

const rulePropMap$2 = {
    valueFrom: 'from',
    valueTo: 'to',
    valueSingle: 'single',
};
function formatRangeDates(comparator, range, services) {
    const { moment } = services;
    const formattedRange = collectionClone(range);
    comparator.requiredKeys.forEach((key) => {
        formattedRange[rulePropMap$2[key]] = moment(formattedRange[key]);
    });
    return formattedRange;
}

/**
 * Compare the PW search time range with a timerange using moment's comparator methods
 * isBefore and isAfter are exclusive, isBetween is inclusive
 */
function compareRangesSearchDates(comparator, timeData, rangeToCompare) {
    const comparatorResult = { result: false };
    const value = timeData.valueToCompare;
    if (value === undefined) {
        return buildResultWithDebug(comparatorResult, rangeToCompare, '<none>');
    }
    if (comparator.requiredKeys.length === 1) {
        // less-than: dateEnd is before comparator rangeToCompare.single
        if (comparator.type === RuleConfigRelationalOperation.LessThan) {
            comparatorResult.result = value.dateEnd[comparator.method](rangeToCompare.single, timeData?.granularity);
            // greater-than: dateBegin is after comparator rangeToCompare.single
        }
        else if (comparator.type === RuleConfigRelationalOperation.GreaterThan) {
            comparatorResult.result = (value.dateBegin[comparator.method])(rangeToCompare.single, timeData?.granularity);
        }
        else if (comparator.type === RuleConfigRelationalOperation.Contain) {
            comparatorResult.result = rangeToCompare.single[comparator.method](value.dateBegin, value.dateEnd, timeData?.granularity, '[]');
        }
    }
    else if (comparator.type === RuleConfigRelationalOperation.Between) {
        // is-between: dateBegin && dateEnd is between comparator date.from and date.to
        comparatorResult.result = value.dateBegin[comparator.method](rangeToCompare.from, rangeToCompare.to, timeData?.granularity, '[]')
            && value.dateEnd[comparator.method](rangeToCompare.from, rangeToCompare.to, timeData?.granularity, '[]');
    }
    else if (comparator.type === RuleConfigRelationalOperation.Equal) {
        // is-equal: dateBegin === date.from && dateEnd === date.to
        comparatorResult.result = value.dateBegin[comparator.method](rangeToCompare.from, timeData?.granularity)
            && (value.dateEnd[comparator.method])(rangeToCompare.to, timeData?.granularity);
    }
    const debugString = `from ${value.dateBegin.format('YYYY-MM-DD')} to ${value.dateEnd.format('YYYY-MM-DD')}`;
    return buildResultWithDebug(comparatorResult, rangeToCompare, debugString);
}

const id$A = 'search_dates';
const kind$5 = RuleKind.Targeting;
const description$A = 'Dates of the visitor\'s stay';
const deps$s = ['globalState', 'async', 'getVisitorLastComparison'];
const match$A = async (obj, [globalState, asyncServices, getVisitorLastComparison]) => {
    const ruleConfig = obj.getRulesConfig()[RulesConfigProp.StayDates];
    if (!ruleConfig?.length) {
        return {
            pass: true,
            logs: [buildDebugString(true, ruleConfig)],
        };
    }
    const callbacks = {
        formatRanges: formatRangeDates,
        compareRanges: compareRangesSearchDates,
    };
    const moment = await asyncServices.moment;
    return commonTimingRules(obj, callbacks, RulesConfigProp.StayDates, {
        globalState, moment, getVisitorLastComparison, getTimeData,
    });
};
const searchDates = {
    id: id$A,
    kind: kind$5,
    description: description$A,
    deps: deps$s,
    match: match$A,
};

function fillDays(from, to) {
    // If dateEnd day is smaller than dateBegin, dateEnd falls in the next week
    // We add 7 to it to be automatically higher than saturday this week
    const dayEnd = to < from ? (to + 7) : to;
    const days = [];
    for (let day = from; day <= dayEnd; day += 1) {
        days.push(day % 7);
    }
    return days;
}
function compareRangesSearchDays(comparator, dataToCompare, rangeToCompare) {
    const value = dataToCompare.valueToCompare;
    const comparatorResult = { result: false };
    if (value === undefined) {
        return buildResultWithDebug(comparatorResult, rangeToCompare, '<none>');
    }
    const searchDays = fillDays(Number(value.dateBegin), Number(value.dateEnd));
    const rangeDays = fillDays(Number(rangeToCompare.valueFrom), Number(rangeToCompare.valueTo));
    if (comparator.requiredKeys.length === 1) {
        // less-than: dateEnd is before comparator rangeToCompare.single
        if (comparator.type === RuleConfigRelationalOperation.LessThan) {
            comparatorResult.result = comparator.method(Number(value.dateEnd), Number(rangeToCompare.valueSingle));
            // greater-than: dateBegin is after comparator rangeToCompare.single
        }
        else if (comparator.type === RuleConfigRelationalOperation.GreaterThan) {
            comparatorResult.result = comparator.method(Number(value.dateBegin), Number(rangeToCompare.valueSingle));
            // return true if stay contains the input day
        }
        else if (comparator.type === RuleConfigRelationalOperation.Contain) {
            comparatorResult.result = searchDays.includes(Number(rangeToCompare.valueSingle));
        }
    }
    else if (comparator.type === RuleConfigRelationalOperation.Between) {
        // If stay is a week or more, all weekdays are included
        if (value.lengthOfStay >= 6) {
            comparatorResult.result = true;
        }
        else {
            // Stay days are included in the rulegroup range
            comparatorResult.result = searchDays.filter((day) => rangeDays.includes(day)).length === searchDays.length;
        }
    }
    else if (comparator.type === 'equal') {
        // is-equal: dateBegin === date.from && dateEnd === date.to
        comparatorResult.result = comparator.method(Number(value.dateBegin), Number(rangeToCompare.valueFrom))
            && comparator.method(Number(value.dateEnd), Number(rangeToCompare.valueTo));
    }
    const debugString = `from ${value.dateBegin} to ${value.dateEnd}, length of stay: ${value.lengthOfStay} `;
    return buildResultWithDebug(comparatorResult, rangeToCompare, debugString);
}

const id$z = 'search_days';
const kind$4 = RuleKind.Targeting;
const description$z = 'Week days of the visitor\'s stay';
const deps$r = ['globalState', 'async', 'getVisitorLastComparison'];
const match$z = async (obj, [globalState, asyncServices, getVisitorLastComparison]) => {
    const ruleConfig = obj.getRulesConfig()[RulesConfigProp.StayDays];
    if (!ruleConfig?.length) {
        return {
            pass: true,
            logs: [buildDebugString(true, ruleConfig)],
        };
    }
    const callbacks = {
        compareRanges: compareRangesSearchDays,
    };
    const moment = await asyncServices.moment;
    return commonTimingRules(obj, callbacks, RulesConfigProp.StayDays, {
        globalState, moment, getVisitorLastComparison, getTimeData,
    });
};
const searchDays = {
    id: id$z,
    kind: kind$4,
    description: description$z,
    deps: deps$r,
    match: match$z,
};

const id$y = 'soldout';
const kind$3 = RuleKind.Targeting;
const description$y = 'Sold out';
const deps$q = ['getVisitorLastComparison'];
const match$y = async (obj, [getVisitorLastComparison]) => {
    const { stayAvailability } = obj.getRulesConfig();
    const logs = [];
    // If no conditions, just pass the rule
    // sold_out (0, '0', false, null, undefined): setting disabled
    if (empty(stayAvailability)) {
        return {
            pass: true,
            logs: [buildDebugString(true)],
        };
    }
    // If PW empty, check last search AFTER origin
    const lastComparisonData = getVisitorLastComparison()?.data.actual.search;
    const evalStayAvailability = (stayAvailabilityRule) => {
        // If missing data rule fails
        if (!lastComparisonData) {
            logs.push(buildDebugString(false, stayAvailabilityRule));
            return false;
        }
        // sold_out: 1 (hasAvailability - false)- tool should be shown ONLY when "Sold Out" (status="no-rooms")
        // sold_out: 2 (hasAvailability - true): tool should be shown ONLY when NOT "Sold Out" (status!="no-rooms")
        const pass = !!((!stayAvailabilityRule.hasAvailability && lastComparisonData.noRooms) || (stayAvailabilityRule.hasAvailability && !lastComparisonData.noRooms));
        logs.push(buildDebugString(pass, stayAvailabilityRule, lastComparisonData.status));
        return pass;
    };
    return {
        pass: stayAvailability.every(evalStayAvailability),
        logs,
    };
};
const soldout = {
    id: id$y,
    kind: kind$3,
    description: description$y,
    deps: deps$q,
    match: match$y,
};

const id$x = 'scheduled_dates';
const description$x = 'Visit/view date';
const deps$p = ['globalState', 'async', 'getVisitorLastComparison'];
const match$x = async (obj, [globalState, asyncServices, getVisitorLastComparison]) => {
    const ruleConfig = obj.getRulesConfig()[RulesConfigProp.VisitDates];
    if (!ruleConfig?.length) {
        return {
            pass: true,
            logs: [buildDebugString(true, ruleConfig)],
        };
    }
    const callbacks = {
        formatRanges: formatRangeDates,
        compareRanges: compareTimerangesNow,
    };
    const moment = await asyncServices.moment;
    return commonTimingRules(obj, callbacks, RulesConfigProp.VisitDates, {
        globalState, moment, getVisitorLastComparison, getTimeData,
    });
};
const scheduledDates = {
    id: id$x,
    description: description$x,
    deps: deps$p,
    match: match$x,
};

const rulePropMap$1 = {
    valueTo: 'to',
    valueFrom: 'from',
    valueSingle: 'single',
};
/*
* If an interval is established that goes from one day to a previous day, we consider it as a week interval
*/
function shouldAddWeekInterval(key, range) {
    return key === 'valueTo' && Number(range.valueTo) < Number(range.valueFrom);
}
/**
 * Format range object for rule evaluation
 */
function formatRangeDays(comparator, range, services) {
    const { moment } = services;
    const formattedRange = collectionClone(range);
    comparator.requiredKeys.forEach((key) => {
        const dayValue = shouldAddWeekInterval(key, range) ? Number(formattedRange[key]) + 7 : Number(formattedRange[key]);
        formattedRange[rulePropMap$1[key]] = moment().day(dayValue);
    });
    return formattedRange;
}

const id$w = 'scheduled_days';
const description$w = 'Visit/view days of the week';
const deps$o = ['globalState', 'async', 'getVisitorLastComparison'];
const match$w = async (obj, [globalState, asyncServices, getVisitorLastComparison]) => {
    const ruleConfig = obj.getRulesConfig()[RulesConfigProp.VisitDays];
    if (!ruleConfig?.length) {
        return {
            pass: true,
            logs: [buildDebugString(true, ruleConfig)],
        };
    }
    const callbacks = {
        formatRanges: formatRangeDays,
        compareRanges: compareTimerangesNow,
    };
    const moment = await asyncServices.moment;
    return commonTimingRules(obj, callbacks, RulesConfigProp.VisitDays, {
        globalState, moment, getVisitorLastComparison, getTimeData,
    });
};
const scheduledDays = {
    id: id$w,
    description: description$w,
    deps: deps$o,
    match: match$w,
};

const rulePropMap = {
    valueFrom: 'from',
    valueTo: 'to',
    valueSingle: 'single',
};
/**
 * Format range object for rule evaluation
 */
function formatRangeTime(comparator, range, services) {
    const { moment } = services;
    const formattedRange = collectionClone(range);
    comparator.requiredKeys.forEach((key) => {
        if (key === 'valueTo' && Number(formattedRange[key]) === 0) {
            // valueTo = 0 is midnight
            formattedRange[key] = 24;
        }
        formattedRange[rulePropMap[key]] = moment().hour(Number(formattedRange[key])).startOf('hour');
    });
    return formattedRange;
}

const id$v = 'scheduled_time';
const description$v = 'Visit/view time of the day';
const deps$n = ['globalState', 'async', 'getVisitorLastComparison'];
// This rule is being treated as left-inclusive only.
const match$v = async (obj, [globalState, asyncServices, getVisitorLastComparison]) => {
    const ruleConfig = obj.getRulesConfig()[RulesConfigProp.VisitHours];
    if (!ruleConfig?.length) {
        return {
            pass: true,
            logs: [buildDebugString(true, ruleConfig)],
        };
    }
    const callbacks = {
        formatRanges: formatRangeTime,
        compareRanges: compareTimerangesNow,
    };
    const moment = await asyncServices.moment;
    return commonTimingRules(obj, callbacks, RulesConfigProp.VisitHours, {
        globalState, moment, getVisitorLastComparison, getTimeData,
    });
};
const scheduledTime = {
    id: id$v,
    description: description$v,
    deps: deps$n,
    match: match$v,
};

const createSubUrlFromHash = (url) => {
    const fakeBase = 'https://fake.app';
    const hashString = url.hash.replace(/^[#!]*/, '');
    const hasSlash = hashString.startsWith('/');
    const hasQueryString = url.hash.includes('?');
    const isBareParams = !(hasSlash || hasQueryString);
    return new URL(isBareParams ? `?${hashString}` : hashString, fakeBase);
};
const id$u = 'url_variables';
const kind$2 = RuleKind.Targeting;
const description$u = 'URL variables';
const deps$m = ['globalThis'];
const match$u = async (obj, [globalThis]) => {
    const { urlVariables } = obj.getRulesConfig();
    const href = globalThis.location?.href;
    if (empty(urlVariables)) {
        return {
            pass: true,
            logs: [buildDebugString(true, urlVariables, href)],
        };
    }
    if (!href) {
        return {
            pass: false,
            logs: [buildDebugString(false, urlVariables, href)],
        };
    }
    const url = new URL(href);
    const searchParams = [...url?.searchParams.values() || []].length ? url.searchParams : createSubUrlFromHash(url).searchParams;
    return checkKeyValueConstraints(searchParams, urlVariables);
};
const urlVariables = {
    id: id$u,
    kind: kind$2,
    description: description$u,
    deps: deps$m,
    match: match$u,
};

const id$t = 'user_past_visits';
const kind$1 = RuleKind.Targeting;
const description$t = 'User past visits';
const deps$l = ['globalState', 'async'];
const match$t = async (tool, [globalState, asyncServices]) => {
    const ruleConfigSection = RulesConfigProp.VisitorPreviousVisitsCount;
    const { visitorPreviousVisitsCount } = tool.getRulesConfig();
    const pastMonthVisit = globalState.visitor?.tracker?.countVisitsCurrentMonth || 0;
    // early exit
    if (empty(visitorPreviousVisitsCount)) {
        return {
            pass: true,
            logs: [buildDebugString(true)],
        };
    }
    const callbacks = {
        formatRanges: formatInputRanges,
        compareRanges: compareInputRanges,
    };
    const dataToCompare = { valueToCompare: pastMonthVisit };
    const moment = await asyncServices.moment;
    return evaluateMultipleRanges(dataToCompare, callbacks, ruleConfigSection, tool, { moment });
};
const userPastVisits = {
    id: id$t,
    description: description$t,
    deps: deps$l,
    match: match$t,
    kind: kind$1,
};

const id$s = 'all_previous_checked';
const description$s = 'All previous tools of this widget are checked';
const deps$k = ['bottle'];
const match$s = async (obj, [bottle]) => {
    const { widgetName } = obj.getContext();
    const widgetInstance = bottle.container[widgetName];
    if (!widgetInstance) {
        throw new Error(`Unable to provide "${widgetName}"`);
    }
    // Search this tool
    const toolIdx = widgetInstance.data.tools.findIndex((other) => other.getId() === obj.getId());
    // Get all previous tools
    const prevTools = widgetInstance.data.tools.slice(0, toolIdx);
    // Find the ones that are already checked
    const prevToolsChecked = prevTools.filter((tool) => tool.getState().checked === true);
    // All previous tools should be checked
    const pass = prevTools.length === prevToolsChecked.length;
    return {
        pass,
        logs: [],
    };
};
const allPreviousChecked = {
    id: id$s,
    description: description$s,
    deps: deps$k,
    match: match$s,
};

const id$r = 'bypass_frequency_config';
const description$r = 'Allowed to bypass frequency config';
const deps$j = ['globalState', 'getSetting'];
const match$r = async (_, [globalState, getSetting]) => {
    // hotels/users/properties in which frecuency config does not apply.
    // hoteltest and family
    const pass = [1013275, 1001150, 1076346, 1091212, 1091213, 1091214].includes(globalState.hotelId)
        || ['29283C4A4CB5F5502758B24F99D1848'].includes(globalState.accountKey)
        || getSetting('disable_tool_frequency') === true;
    return {
        pass,
        logs: [],
    };
};
const bypassFrequencyConfig = {
    id: id$r,
    description: description$r,
    deps: deps$j,
    match: match$r,
};

const id$q = 'can_open_bar_layout';
const description$q = 'Bar layout slot';
const deps$i = ['bottle'];
const match$q = async (obj, [bottle]) => {
    if (obj.getLayout() !== 'bar') {
        return {
            pass: true,
            logs: [buildDebugString(true, 'Not a bar layout')],
        };
    }
    const { widgetName } = obj.getContext();
    const widgetInstance = bottle.container[widgetName];
    if (!widgetInstance) {
        throw new Error(`Unable to provide "${widgetName}"`);
    }
    const currentToolPosition = obj.getPosition();
    // Check if any other Bar tool in the same position is currently being shown
    const otherToolBlocks = widgetInstance.data.tools.some((tool) => {
        const toolState = tool.getState();
        return tool.getLayout() === ToolLayoutKind.Bar
            && tool.getPosition() === currentToolPosition
            && toolState.toBeShown
            && !toolState.closed;
    });
    const pass = !otherToolBlocks;
    return {
        pass,
        logs: [buildDebugString(pass, 'Is Bar layout', `Is ${pass ? 'not' : ''} blocked`)],
    };
};
const canOpenBarLayout = {
    id: id$q,
    description: description$q,
    deps: deps$i,
    match: match$q,
};

const id$p = 'can_open_be';
const description$p = 'Can open booking engine to the latest search or to a default search.';
const deps$h = ['createSearchReplay'];
const match$p = async (obj, [createSearchReplay]) => {
    const actions = [];
    for (const action of obj.getActions()) {
        if (action.kind === AgentActionKind.OpenBookingEngine) {
            const { replayData } = action;
            if (!replayData) {
                return {
                    pass: false,
                    logs: [buildDebugString(false, action, 'No search data')],
                };
            }
            const replayReturn = createSearchReplay(replayData);
            const canGenerateReplayFn = !!replayReturn?.replayFn;
            if (!canGenerateReplayFn) {
                return {
                    pass: false,
                    logs: [buildDebugString(false, action, 'Can not generate replay function')],
                };
            }
            actions.push(action);
        }
    }
    return {
        pass: true,
        logs: [buildDebugString(true, actions)],
    };
};
const canOpenBe = {
    id: id$p,
    description: description$p,
    deps: deps$h,
    match: match$p,
};

const id$o = 'countdown';
const description$o = 'Has countdown timer time left';
const match$o = async (obj) => {
    const countdown = obj.getCountdown();
    const pass = !countdown ? true : countdown.secondsLeft > 0;
    const contextData = {
        date: (new Date()).toString(),
        siteTimezone: obj.getContext().siteTimezone,
    };
    return {
        pass,
        logs: [buildDebugString(pass, countdown, contextData)],
    };
};
const countdown = {
    id: id$o,
    description: description$o,
    match: match$o,
};

const id$n = 'current_page';
const description$n = 'Configured on the current page';
const deps$g = ['globalState'];
const match$n = async (obj, [globalState]) => {
    let pass = false;
    const effectivePageName = globalState.pageName;
    const pages = obj.getPages().map((page) => page.name);
    if (!pages.length) {
        // When no pages are configured in this tool, then
        // we assume the tool should be loaded for any detected page
        pass = !!effectivePageName;
    }
    else {
        pass = pages.includes(effectivePageName);
    }
    return {
        pass,
        logs: [buildDebugString(pass, pages, effectivePageName)],
    };
};
const currentPage = {
    id: id$n,
    description: description$n,
    deps: deps$g,
    match: match$n,
};

const id$m = 'site';
const description$m = 'Configured on the current Site';
const deps$f = ['globalState'];
const match$m = async (obj, [globalState]) => {
    let pass = true;
    const siteIds = obj.getSites();
    const { siteId } = globalState;
    if (siteIds.length > 0 && siteId) { // If no siteIds are configured, then the tool should be loaded for any site
        pass = siteIds.includes(siteId);
    }
    return {
        pass,
        logs: [buildDebugString(pass, siteIds, { siteId })],
    };
};
const site = {
    id: id$m,
    description: description$m,
    deps: deps$f,
    match: match$m,
};

const id$l = 'device';
const description$l = 'Tool is active for this device';
const deps$e = ['globalState'];
const match$l = async (obj, [globalState]) => {
    const devices = obj.getDevices();
    const currentDevice = globalState.media?.name;
    const pass = devices.includes(currentDevice);
    return {
        pass,
        logs: [buildDebugString(pass, devices, currentDevice)],
    };
};
const device = {
    id: id$l,
    description: description$l,
    deps: deps$e,
    match: match$l,
};

const id$k = 'evaluation_frequency';
const description$k = 'Frequency of evaluation';
const deps$d = ['globalState'];
const match$k = async (obj, [globalState]) => {
    const crossSiteFrequencies = [EvaluationFrequency.OncePerSessionCrossSite, EvaluationFrequency.OncePerVisitorCrossSite];
    const frequency = obj.getEvaluationFrequency();
    const previousDate = crossSiteFrequencies.includes(frequency)
        ? (obj.getVisitorPreviousVisitDateOnCrossSite() || obj.getVisitorPreviousVisitDateOnSite())
        : obj.getVisitorPreviousVisitDateOnSite();
    const isOnEveryPage = frequency === EvaluationFrequency.OncePerPage;
    const isFirstVisit = !previousDate;
    const isMoreOrEqualThanAnHourAgo = previousDate !== null && (globalState.pageLoadTime - previousDate) / 3600 >= 1;
    const toolCanBeSeenThisSession = (isFirstVisit && frequency === EvaluationFrequency.OncePerVisitor) // Seen once by this fingerprint
        || (isMoreOrEqualThanAnHourAgo && (frequency === EvaluationFrequency.OncePerSession || frequency === EvaluationFrequency.OncePerSessionCrossSite)); // Seen more than an hour ago
    const pass = isOnEveryPage || isFirstVisit || toolCanBeSeenThisSession;
    return {
        pass,
        logs: [buildDebugString(pass, frequency, { previousDate: previousDate ? (new Date(previousDate * 1000)).toString() : null })],
    };
};
const evaluationFrequency = {
    id: id$k,
    description: description$k,
    deps: deps$d,
    match: match$k,
};

const id$j = 'idle_trigger';
const description$j = 'The visitor is idle';
const deps$c = ['idleManager'];
const match$j = async (obj, [idleManager]) => {
    const toolTrigger = obj.getTrigger();
    // early exit in case the tool is not an idle trigger
    if (toolTrigger.kind !== TriggerKind$1.Idle) {
        return {
            pass: true,
            logs: [buildDebugString(true, { toolTrigger })],
        };
    }
    // check if the visitor idle time has been reached
    const idleTime = idleManager.idleSeconds;
    const pass = idleTime !== null ? idleTime >= toolTrigger.idleTime : false;
    return {
        pass,
        logs: [buildDebugString(pass, { toolTrigger }, { idleTime })],
    };
};
const idleTrigger = {
    id: id$j,
    description: description$j,
    deps: deps$c,
    match: match$j,
};

const id$i = 'is_complete';
const description$i = 'Has valid custom form or valid custom image';
const match$i = async (obj) => {
    const pass = obj.isComplete();
    return {
        pass,
        logs: [buildDebugString(pass)],
    };
};
const isComplete = {
    id: id$i,
    description: description$i,
    match: match$i,
};

const id$h = 'is_native_app';
const description$h = 'On iOS/Android native app';
const deps$b = ['globalState'];
const match$h = async (_obj, [globalState]) => ({
    pass: globalState.media.name === Device.Native,
    logs: [],
});
const isNativeApp = {
    id: id$h,
    description: description$h,
    deps: deps$b,
    match: match$h,
};

const id$g = 'is_online';
const description$g = 'The widget is online (active)';
const deps$a = ['bottle'];
const match$g = async (obj, [bottle]) => {
    const { widgetName } = obj.getContext();
    const widgetInstance = bottle.container[widgetName];
    if (!widgetInstance) {
        throw new Error(`Unable to provide "${widgetName}"`);
    }
    const pass = widgetInstance.isOnline();
    return {
        pass,
        logs: [],
    };
};
const isOnline = {
    id: id$g,
    description: description$g,
    deps: deps$a,
    match: match$g,
};

const id$f = 'is_backend_discarded';
const description$f = 'Discarded by the server to be shown';
const match$f = async (obj) => {
    const pass = !obj.isBackendDiscarded();
    return {
        pass,
        logs: [buildDebugString(pass)],
    };
};
const isBackendDiscarded = {
    id: id$f,
    description: description$f,
    match: match$f,
};

const id$e = 'only_one_tool_shown';
const description$e = 'Only one tool of this widget should be processed (to be shown)';
const deps$9 = ['bottle'];
const match$e = async (obj, [bottle]) => {
    const { widgetName } = obj.getContext();
    const widgetInstance = bottle.container[widgetName];
    if (!widgetInstance) {
        throw new Error(`Unable to provide "${widgetName}"`);
    }
    const pass = widgetInstance.data.tools.every((tool) => tool.getState().processed === false);
    return {
        pass,
        logs: [buildDebugString(pass)],
    };
};
const onlyOneToolShown = {
    id: id$e,
    description: description$e,
    deps: deps$9,
    match: match$e,
};

const id$d = 'ignore_only_one_tool_shown';
const description$d = `Ignore rule "${onlyOneToolShown.description}"`;
const match$d = async (obj) => {
    const pass = obj.shouldEvaluateWithoutLimits() && obj.getState().processed === false;
    return {
        pass,
        logs: [buildDebugString(pass)],
    };
};
const ignoreOnlyOneToolShown = {
    description: description$d,
    id: id$d,
    match: match$d,
};

const id$c = 'load_trigger';
const description$c = 'The tools have been loaded';
const deps$8 = ['loadManager'];
const match$c = async (obj, [loadManager]) => {
    const toolTrigger = obj.getTrigger();
    // early exit in case the tool is not a load trigger
    if (toolTrigger.kind !== TriggerKind$1.Load) {
        return {
            pass: true,
            logs: [buildDebugString(true, { toolTrigger })],
        };
    }
    // check if the elapsed time since tool load has been reached
    const elapsedTime = loadManager.elapsedSeconds;
    const pass = elapsedTime !== null ? elapsedTime >= toolTrigger.delayTime : false;
    return {
        pass,
        logs: [buildDebugString(pass, { toolTrigger }, { elapsedTime })],
    };
};
const loadTrigger = {
    id: id$c,
    description: description$c,
    deps: deps$8,
    match: match$c,
};

const createReturn = (pass = true) => ({
    pass,
    logs: [buildDebugString(pass)],
});
const id$b = 'note_type';
const description$b = 'Note specific rules';
const match$b = async (obj) => {
    const currentVisitorsCountOnSite = obj.getCurrentVisitorsCountOnSite();
    if (currentVisitorsCountOnSite !== null)
        return createReturn(currentVisitorsCountOnSite >= 3);
    const previousDayVisitorsCountOnSite = obj.getPreviousDayVisitorsCountOnSite();
    if (previousDayVisitorsCountOnSite !== null)
        return createReturn(previousDayVisitorsCountOnSite >= 10);
    const previousDayBookingsCountOnSite = obj.getPreviousDayBookingsCountOnSite();
    if (previousDayBookingsCountOnSite !== null)
        return createReturn(previousDayBookingsCountOnSite >= 3);
    const previousWeekTravelersCountOnSite = obj.getPreviousWeekTravelersCountOnSite();
    if (previousWeekTravelersCountOnSite !== null)
        return createReturn(previousWeekTravelersCountOnSite >= 25);
    const timeSincePreviousBookingOnSite = obj.getTimeSincePreviousBookingOnSite();
    if (timeSincePreviousBookingOnSite !== null)
        return createReturn(timeSincePreviousBookingOnSite > 0 && timeSincePreviousBookingOnSite <= 360);
    const offeredPriceDifferenceOnSite = obj.getOfferedPriceDifferenceOnSite();
    if (offeredPriceDifferenceOnSite !== null)
        return createReturn(offeredPriceDifferenceOnSite >= 10 && offeredPriceDifferenceOnSite < 100);
    return createReturn();
};
const noteType = {
    id: id$b,
    description: description$b,
    match: match$b,
};

const configMsg = 'needs free slot';
const id$a = 'only_one_tool_set';
const description$a = 'This widget has no other tool currently set';
const deps$7 = ['bottle'];
const match$a = async (obj, [bottle]) => {
    const { widgetName } = obj.getContext();
    const widgetInstance = bottle.container[widgetName];
    if (!widgetInstance) {
        throw new Error(`Unable to provide "${widgetName}"`);
    }
    // Check if another tool is already set
    const previousToolBlocks = widgetInstance.data.tools.some((tool) => {
        const toolState = tool.getState();
        return toolState.toBeShown && !toolState.closed;
    });
    if (previousToolBlocks) {
        const pass = false;
        return {
            pass,
            logs: [buildDebugString(pass, configMsg, 'slot is in use')],
        };
    }
    const pass = true;
    return {
        pass,
        logs: [buildDebugString(pass, configMsg, 'slot is available')],
    };
};
const onlyOneToolSet = {
    id: id$a,
    description: description$a,
    deps: deps$7,
    match: match$a,
};

const id$9 = 'promocode_inuse';
const description$9 = 'Promocode is not applied';
const deps$6 = ['price'];
const match$9 = async (obj, [price]) => {
    const { promocode: appliedCodeValue } = price.getPromocode() || {};
    const discountCodeActions = obj.getActions().filter((action) => action.kind === AgentActionKind.ApplyDiscount);
    const discountCodeValues = discountCodeActions.map((action) => action.discountCode.value);
    const isNotInUse = (codeValue) => ![codeValue.toLowerCase(), '__unknown__'].includes(appliedCodeValue?.toLowerCase() || '');
    const pass = !appliedCodeValue || discountCodeValues.every(isNotInUse);
    return {
        pass,
        logs: [buildDebugString(pass, discountCodeValues, appliedCodeValue)],
    };
};
const promocodeInuse = {
    id: id$9,
    description: description$9,
    deps: deps$6,
    match: match$9,
};

const id$8 = 'requires_oraculo_loaded';
const description$8 = 'The tool requires oraculo data loaded';
const deps$5 = ['oraculoManager'];
const match$8 = async (obj, [oraculoManager]) => {
    const { visitorOraculoScore } = obj.getRulesConfig();
    if (empty(visitorOraculoScore)) {
        return {
            pass: true,
            logs: [buildDebugString(true)],
        };
    }
    if (empty(oraculoManager.get())) {
        return {
            pass: false,
            logs: [],
        };
    }
    const ruleResults = [];
    const logs = [];
    visitorOraculoScore?.forEach((oraculoRuleItem) => {
        const pass = oraculoManager.getSemanticLayer(oraculoRuleItem.kind) !== null;
        ruleResults.push(pass);
        logs.push(buildDebugString(pass, oraculoRuleItem.kind, `${pass ? 'Has' : 'Missing'} oraculo data for ${oraculoRuleItem.kind} type`));
    });
    const pass = ruleResults.every((result) => result);
    return {
        pass,
        logs,
    };
};
const requiresOraculoLoaded = {
    id: id$8,
    description: description$8,
    deps: deps$5,
    match: match$8,
};

const id$7 = 'requires_pw_data';
const description$7 = 'Requires PW data and PW data is set';
const deps$4 = ['getVisitorLastComparison'];
const match$7 = async (obj, [getVisitorLastComparison]) => {
    if (!obj.involvesComparison()) {
        const pass = true;
        return {
            pass,
            logs: [buildDebugString(pass, 'does-not-require-pw-data', '?')],
        };
    }
    const priceData = getVisitorLastComparison();
    if (!priceData) {
        const pass = false;
        return {
            pass,
            logs: [buildDebugString(pass, 'requires-pw-data', 'does-not-exist')],
        };
    }
    const pass = true;
    return {
        pass,
        logs: [buildDebugString(pass, 'requires-pw-data', 'exists')],
    };
};
const requiresPwData = {
    id: id$7,
    description: description$7,
    deps: deps$4,
    match: match$7,
};

const id$6 = 'scroll_trigger';
const description$6 = 'The visitor has scrolled';
const deps$3 = ['scrollManager'];
const match$6 = async (obj, [scrollManager]) => {
    const toolTrigger = obj.getTrigger();
    // early exit in case the tool trigger is not scroll
    if (toolTrigger.kind !== TriggerKind$1.Scroll) {
        return {
            pass: true,
            logs: [buildDebugString(true, { toolTrigger })],
        };
    }
    // check if the visitor has scrolled the page
    const isScrolling = scrollManager.isScrolling();
    return {
        pass: isScrolling,
        logs: [buildDebugString(isScrolling, { toolTrigger }, { isScrolling })],
    };
};
const scrollTrigger = {
    id: id$6,
    description: description$6,
    deps: deps$3,
    match: match$6,
};

const id$5 = 'save_search';
const description$5 = 'Has save search action and price widget data available';
const deps$2 = ['getVisitorLastComparison'];
const match$5 = async (obj, [getVisitorLastComparison]) => {
    const sendSaveSearchAction = obj.getActions().find((action) => action.kind === AgentActionKind.SendSaveSearch);
    if (!sendSaveSearchAction) {
        return {
            pass: true,
            logs: [buildDebugString(true)],
        };
    }
    const pass = !!getVisitorLastComparison({ acceptWithoutAvailability: false, acceptStayDatesBeforeToday: false });
    return {
        pass,
        logs: [buildDebugString(true, '', sendSaveSearchAction)],
    };
};
const saveSearch = {
    id: id$5,
    description: description$5,
    deps: deps$2,
    match: match$5,
};

const id$4 = 'unique_element';
const description$4 = 'Selector refers to an existing unique element';
const deps$1 = ['bottle'];
const match$4 = async (obj, [bottle]) => {
    const { widgetName } = obj.getContext();
    const widgetInstance = bottle.container[widgetName];
    if (!widgetInstance) {
        throw new Error(`Unable to provide "${widgetName}"`);
    }
    const selector = obj.getMountSelector();
    const { document } = widgetInstance.view._context;
    const mountSelector = findMountElement(selector, { all: true, document });
    // Warn: asuming load_view will be called before any rule check
    const pass = mountSelector ? Array.from(mountSelector).length === 1 : false;
    return {
        pass,
        logs: [buildDebugString(pass, selector, mountSelector)],
    };
};
const selectorUniqueElement = {
    id: id$4,
    description: description$4,
    deps: deps$1,
    match: match$4,
};

const id$3 = 'unique_check';
const description$3 = 'The tool has not been checked previously';
const match$3 = async (obj) => {
    const pass = !obj.getState().checked;
    return {
        pass,
        logs: [],
    };
};
const uniqueCheck = {
    id: id$3,
    description: description$3,
    match: match$3,
};

const id$2 = 'unique_show';
const description$2 = 'The tool has not been processed (to be shown) previously';
const match$2 = async (obj) => {
    const pass = !obj.getState().processed;
    return {
        pass,
        logs: [],
    };
};
const uniqueShow = {
    id: id$2,
    description: description$2,
    match: match$2,
};

const id$1 = 'visitor_registration_status';
const kind = RuleKind.Targeting;
const description$1 = 'Visitor logged-in/registered status';
const deps = ['globalState', 'isUserLogged'];
const match$1 = async (obj, [globalState, isUserLogged]) => {
    const { visitorStatus } = obj.getRulesConfig();
    if (!visitorStatus?.length) {
        return {
            pass: true,
            logs: [],
        };
    }
    const visitorCurrentState = {
        [CredentialsRealm.Native]: {
            isRegistered: !!globalState.visitor.lastLoggedDate,
            isLogged: isUserLogged(),
        },
        [CredentialsRealm.Thn]: {
            // TODO: fill the value in the future THN / Instant Login system
            isRegistered: undefined,
            // TODO: fill the value  in the future THN / Instant Login system
            isLogged: undefined,
        },
    };
    const logs = [];
    const pass = visitorStatus?.some((visitorStatusItem) => {
        const visitorCurrentStateInRealm = visitorCurrentState[visitorStatusItem.realm];
        const currentStateEqualsExpected = ((visitorStatusItem.isRegistered === undefined || visitorStatusItem.isRegistered === visitorCurrentStateInRealm.isRegistered)
            && (visitorStatusItem.isLogged === undefined || visitorStatusItem.isLogged === visitorCurrentStateInRealm.isLogged));
        const itemPass = visitorStatusItem.outcome === RuleConfigCondition.ShouldInclude && currentStateEqualsExpected;
        logs.push(buildDebugString(itemPass, visitorStatusItem, visitorCurrentStateInRealm));
        return itemPass;
    });
    return {
        pass: !!pass,
        logs,
    };
};
const visitorRegistrationStatus = {
    id: id$1,
    kind,
    description: description$1,
    deps,
    match: match$1,
};

const id = 'check_dynamic_tags';
const description = 'Some dynamic tags are missing';
const match = async (obj) => {
    const dynamicTags = obj.getDynamicTags();
    if (dynamicTags.length === 0) {
        const pass = true;
        return {
            pass,
            logs: [buildDebugString(pass, dynamicTags)],
        };
    }
    const allTokens = obj.getAllTokens();
    if (!allTokens) {
        const pass = false;
        return {
            pass,
            logs: [buildDebugString(pass, dynamicTags)],
        };
    }
    const pass = !dynamicTags.some(tag => allTokens[tag] === undefined);
    return {
        pass,
        logs: [buildDebugString(pass, dynamicTags, allTokens)],
    };
};
const checkDynamicTags = {
    id,
    description,
    match,
};

var index = /*#__PURE__*/Object.freeze({
  __proto__: null,
  allPreviousChecked: allPreviousChecked,
  bypassFrequencyConfig: bypassFrequencyConfig,
  canOpenBarLayout: canOpenBarLayout,
  canOpenBe: canOpenBe,
  checkDynamicTags: checkDynamicTags,
  countdown: countdown,
  currentPage: currentPage,
  datalayerVariables: datalayerVariables,
  daysSinceLastVisit: daysSinceLastVisit,
  daysUntilCheckin: daysUntilCheckin,
  demand: demand,
  demandKnown: demandKnown,
  device: device,
  disparities: disparities,
  disparitiesKnown: disparitiesKnown,
  duetto: duetto,
  duettoKnown: duettoKnown,
  evaluationFrequency: evaluationFrequency,
  exitTrigger: exitTrigger,
  geolocation: geolocation,
  idleTrigger: idleTrigger,
  ignoreOnlyOneToolShown: ignoreOnlyOneToolShown,
  isBackendDiscarded: isBackendDiscarded,
  isComplete: isComplete,
  isNativeApp: isNativeApp,
  isOnline: isOnline,
  lengthOfStay: lengthOfStay,
  loadTrigger: loadTrigger,
  noteType: noteType,
  occupancyAdults: occupancyAdults,
  occupancyChildren: occupancyChildren,
  occupancyRooms: occupancyRooms,
  onlyOneToolSet: onlyOneToolSet,
  onlyOneToolShown: onlyOneToolShown,
  oraculosStandard: oraculosStandard,
  originMatch: originMatch,
  priceRange: priceRange,
  promocodeInuse: promocodeInuse,
  requiresOraculoLoaded: requiresOraculoLoaded,
  requiresPwData: requiresPwData,
  retargeting: retargeting,
  saveSearch: saveSearch,
  scheduledDates: scheduledDates,
  scheduledDays: scheduledDays,
  scheduledTime: scheduledTime,
  scrollTrigger: scrollTrigger,
  searchDates: searchDates,
  searchDays: searchDays,
  selectorUniqueElement: selectorUniqueElement,
  site: site,
  soldout: soldout,
  uniqueCheck: uniqueCheck,
  uniqueShow: uniqueShow,
  urlVariables: urlVariables,
  userPastVisits: userPastVisits,
  visitorRegistrationStatus: visitorRegistrationStatus
});

function getStayAvailability(bestAvailableRate) {
    if (!bestAvailableRate || bestAvailableRate.type === NostromoAvailabilityType.Custom) {
        return [];
    }
    return [{
            outcome: RuleConfigCondition.ShouldInclude,
            hasAvailability: bestAvailableRate.type === NostromoAvailabilityType.NotSoldOut,
        }];
}

const daysOfTheWeekMap = {
    [DayName.Sunday]: Day.Sunday,
    [DayName.Monday]: Day.Monday,
    [DayName.Tuesday]: Day.Tuesday,
    [DayName.Wednesday]: Day.Wednesday,
    [DayName.Thursday]: Day.Thursday,
    [DayName.Friday]: Day.Friday,
    [DayName.Saturday]: Day.Saturday,
};
const funnelPagesMap = {
    [NostromoPage.Home]: RetargetingPage.Home,
    [NostromoPage.Calendar]: RetargetingPage.Calendar,
    [NostromoPage.RoomsAndRates]: RetargetingPage.RoomsAndRates,
    [NostromoPage.UserRegisterPage]: RetargetingPage.UserRegisterPage,
    [NostromoPage.BookingConfirmed]: RetargetingPage.BookingConfirmed,
};
const oraculoVariablesMap = {
    flexibleDates: OraculoSemanticLayer.DateFlexibility,
    nights: OraculoSemanticLayer.Nights,
    flexibleDestinations: OraculoSemanticLayer.DestinationFlexibility,
    intent: OraculoSemanticLayer.Intent,
    spend: OraculoSemanticLayer.Spend,
};
const referenceTimezoneMap = {
    hotel: ReferenceTimezone.Site,
    visitor: ReferenceTimezone.Visitor,
};
const ruleConditionMap = {
    [ConditionKind.Exclude]: RuleConfigCondition.ShouldExclude,
    [ConditionKind.Include]: RuleConfigCondition.ShouldInclude,
};
const ruleRelationalOperationDatesSingularMap = {
    [Operator.Is]: RuleConfigRelationalOperation.Equal,
    [Operator.IsAfter]: RuleConfigRelationalOperation.GreaterThan,
    [Operator.IsBefore]: RuleConfigRelationalOperation.LessThan,
    [Operator.IsBetween]: RuleConfigRelationalOperation.Between,
};
const ruleRelationalOperationDatesPluralMap = {
    [Operator.Are]: RuleConfigRelationalOperation.Equal,
    [Operator.AreAfter]: RuleConfigRelationalOperation.GreaterThan,
    [Operator.AreBefore]: RuleConfigRelationalOperation.LessThan,
    [Operator.AreBetween]: RuleConfigRelationalOperation.Between,
};
const ruleRelationalOperationDatesPluralWithContainMap = {
    [Operator.Are]: RuleConfigRelationalOperation.Equal,
    [Operator.AreAfter]: RuleConfigRelationalOperation.GreaterThan,
    [Operator.AreBefore]: RuleConfigRelationalOperation.LessThan,
    [Operator.AreBetween]: RuleConfigRelationalOperation.Between,
    [Operator.Contain]: RuleConfigRelationalOperation.Contain,
};
const ruleRelationalOperationNumericSingularMap = {
    [Operator.Is]: RuleConfigRelationalOperation.Equal,
    [Operator.IsBetween]: RuleConfigRelationalOperation.Between,
    [Operator.IsGreater]: RuleConfigRelationalOperation.GreaterThan,
    [Operator.IsLower]: RuleConfigRelationalOperation.LessThan,
};
const ruleRelationalOperationNumericPluralMap = {
    [Operator.Are]: RuleConfigRelationalOperation.Equal,
    [Operator.AreBetween]: RuleConfigRelationalOperation.Between,
    [Operator.AreGreater]: RuleConfigRelationalOperation.GreaterThan,
    [Operator.AreLower]: RuleConfigRelationalOperation.LessThan,
};
const ruleRelationalOperationRateMap = {
    [Operator.IsBetween]: RuleConfigRelationalOperation.Between,
    [Operator.IsHigher]: RuleConfigRelationalOperation.GreaterThan,
    [Operator.IsLower]: RuleConfigRelationalOperation.LessThan,
};
const ruleVariableOperationMap = {
    [DataVariableRuleOperator.AnyValue]: RuleConfigAbstractVariableRelationalOperation.ValueIsNotEmpty,
    [DataVariableRuleOperator.NotAnyValue]: RuleConfigAbstractVariableRelationalOperation.ValueIsEmpty,
    [DataVariableRuleOperator.Contains]: RuleConfigAbstractVariableRelationalOperation.ValueDoesContain,
    [DataVariableRuleOperator.NotContains]: RuleConfigAbstractVariableRelationalOperation.ValueDoesNotContain,
    [DataVariableRuleOperator.Greater]: RuleConfigAbstractVariableRelationalOperation.ValueIsGreaterThan,
    [DataVariableRuleOperator.Lower]: RuleConfigAbstractVariableRelationalOperation.ValueIsLowerThan,
    [DataVariableRuleOperator.Is]: RuleConfigAbstractVariableRelationalOperation.ValueIsEqual,
    [DataVariableRuleOperator.IsNot]: RuleConfigAbstractVariableRelationalOperation.ValueIsNotEqual,
};
const sourceDomainMap = /* #__PURE__ */ Object.fromEntries(Object.values(SocialDomain).map((item) => [`https://${item}.com`, item]));
const evaluationFrequencyMap = {
    [TimingFrequency.EveryPage]: EvaluationFrequency.OncePerPage,
    [TimingFrequency.OncePerVisit]: EvaluationFrequency.OncePerSession,
    [TimingFrequency.OncePerProperty]: EvaluationFrequency.OncePerVisitor,
    [TimingFrequency.OncePerVisitor]: EvaluationFrequency.OncePerVisitorCrossSite,
    [TimingFrequency.OncePerBrand]: EvaluationFrequency.OncePerSessionCrossSite,
};
const discountCodeKindMap = {
    [DiscountCodeKind.Default]: DiscountCodeKind$1.Default,
    [DiscountCodeKind.Coupon]: DiscountCodeKind$1.Coupon,
    [DiscountCodeKind.Rate]: DiscountCodeKind$1.Rate,
    [DiscountCodeKind.Corporative]: DiscountCodeKind$1.Corpo,
    [DiscountCodeKind.Group]: DiscountCodeKind$1.Group,
};
const uriSchemaMap = {
    [ButtonActionKind.OpenUrl]: UriSchema.Http,
    [ButtonActionKind.OpenMailClient]: UriSchema.Mailto,
    [ButtonActionKind.CallPhoneNumber]: UriSchema.Tel,
};
const inlinerPositionMap = {
    after: 'IA',
    before: 'IB',
    inside: 'II',
};

/**
 * Gets the date segment of a simplified extended ISO format (ISO 8601).
 * @param esEpoch An ECMAScript Epoch in milliseconds
 */
function getIsoDateFromEsEpoch(esEpoch) {
    return new Date(esEpoch).toISOString().split('T')[0];
}

function basicRuleStayDateMapper(rule) {
    const outcome = ruleConditionMap[rule.condition];
    const operation = ruleRelationalOperationDatesPluralWithContainMap[rule.operator];
    if (!operation) {
        return null;
    }
    if (operation === RuleConfigRelationalOperation.Between || operation === RuleConfigRelationalOperation.Equal) {
        return {
            valueFrom: getIsoDateFromEsEpoch(Number(rule.from)),
            valueTo: getIsoDateFromEsEpoch(Number(rule.to)),
            operation,
            outcome,
        };
    }
    return {
        valueSingle: getIsoDateFromEsEpoch(Number(rule.from)),
        operation,
        outcome,
    };
}
function getStayDates(stayDatesRules) {
    if (!stayDatesRules) {
        return [];
    }
    return stayDatesRules.map(basicRuleStayDateMapper)
        .filter((item) => item !== null);
}

function basicRuleStayDaysMapper(rule) {
    const outcome = ruleConditionMap[rule.condition];
    const operation = ruleRelationalOperationDatesPluralWithContainMap[rule.operator];
    if (!operation) {
        return null;
    }
    const from = daysOfTheWeekMap[rule.from];
    if (from === undefined) {
        return null;
    }
    if (operation === RuleConfigRelationalOperation.Between || operation === RuleConfigRelationalOperation.Equal) {
        const to = daysOfTheWeekMap[rule.to];
        if (to === undefined) {
            return null;
        }
        return {
            valueFrom: from,
            valueTo: to,
            operation,
            outcome,
        };
    }
    return {
        valueSingle: from,
        operation,
        outcome,
    };
}
function getStayDays(stayDaysOfTheWeekRules) {
    if (!stayDaysOfTheWeekRules) {
        return [];
    }
    return stayDaysOfTheWeekRules.map(basicRuleStayDaysMapper)
        .filter((item) => item !== null);
}

function basicRuleNumericPluralFaultyMapper(other) {
    const outcome = ruleConditionMap[other.condition];
    // Note this mapping is considered "faulty" non-orthodox because uses "DatesPluralOperator" instead of "NumericPluralOperator"
    const operation = ruleRelationalOperationDatesPluralMap[other.operator];
    if (!operation) {
        return null;
    }
    if (operation === RuleConfigRelationalOperation.Between) {
        return {
            valueFrom: Number(other.from),
            valueTo: Number(other.to),
            operation,
            outcome,
        };
    }
    return {
        valueSingle: Number(other.from),
        operation,
        outcome,
    };
}
function getStayDaysUntilCheckIn(daysUntilCheckInRules) {
    if (!daysUntilCheckInRules) {
        return [];
    }
    return daysUntilCheckInRules.map(basicRuleNumericPluralFaultyMapper)
        .filter((item) => item !== null)
        .map((item) => ({ ...item, referenceTimezone: ReferenceTimezone.Site }));
}

function getStayDemand(rule) {
    if (!rule) {
        return [];
    }
    return [{
            valueSingle: rule.operator,
            operation: RuleConfigRelationalOperation.Equal,
        }];
}

function getStayDisparities(rule) {
    if (!rule) {
        return [];
    }
    const operation = ruleRelationalOperationRateMap[rule.operator];
    if (!operation) {
        return [];
    }
    const outcome = ruleConditionMap[rule.condition];
    const { otas = [], metas = [] } = rule;
    const sources = [...otas, ...metas];
    if (!sources.length) {
        return [];
    }
    if (operation === RuleConfigRelationalOperation.Between) {
        const valueFrom = Number(rule.from);
        const valueTo = Number(rule.to);
        if (!isNumeric(valueFrom) || !isNumeric(valueTo)) {
            return [];
        }
        return [{
                valueFrom,
                valueTo,
                operation,
                outcome,
                sources,
            }];
    }
    const valueSingle = Number(rule.from);
    if (!isNumeric(valueSingle)) {
        return [];
    }
    return [{
            valueSingle,
            operation: operation,
            outcome,
            sources,
        }];
}

function basicRuleNumericSingularMapper(other) {
    const outcome = ruleConditionMap[other.condition];
    const operation = ruleRelationalOperationNumericSingularMap[other.operator];
    if (!operation) {
        return null;
    }
    if (operation === RuleConfigRelationalOperation.Between) {
        return {
            valueFrom: Number(other.from),
            valueTo: Number(other.to),
            operation,
            outcome,
        };
    }
    return {
        valueSingle: Number(other.from),
        operation,
        outcome,
    };
}
function getStayLength(lengthOfStayRules) {
    if (!lengthOfStayRules) {
        return [];
    }
    return lengthOfStayRules.map(basicRuleNumericSingularMapper)
        .filter((item) => item !== null);
}

function basicRuleNumericPluralMapper(other) {
    const outcome = ruleConditionMap[other.condition];
    const operation = ruleRelationalOperationNumericPluralMap[other.operator];
    if (!operation) {
        return null;
    }
    if (operation === RuleConfigRelationalOperation.Between) {
        return {
            valueFrom: Number(other.from),
            valueTo: Number(other.to),
            operation,
            outcome,
        };
    }
    return {
        valueSingle: Number(other.from),
        operation,
        outcome,
    };
}
function getNumericPluralGeneric(genericRules) {
    if (!genericRules) {
        return [];
    }
    return genericRules.map(basicRuleNumericPluralMapper)
        .filter((item) => item !== null);
}

function getStayTotalCost(bestAvailableRate) {
    const emptyResult = [];
    if (bestAvailableRate?.type !== 'custom') {
        return emptyResult;
    }
    const currencyCode = bestAvailableRate.currency;
    if (!currencyCode) {
        return emptyResult;
    }
    const operation = ruleRelationalOperationRateMap[bestAvailableRate.operator];
    if (!operation) {
        return emptyResult;
    }
    const outcome = RuleConfigCondition.ShouldInclude;
    if (bestAvailableRate.from === undefined) {
        return emptyResult;
    }
    if (operation === RuleConfigRelationalOperation.Between) {
        if (bestAvailableRate.to === undefined) {
            return emptyResult;
        }
        return [{
                currencyCode: currencyCode,
                valueFrom: bestAvailableRate.from,
                valueTo: bestAvailableRate.to,
                operation: operation,
                outcome,
            }];
    }
    return [{
            currencyCode: currencyCode,
            valueSingle: bestAvailableRate.from,
            operation: operation,
            outcome,
        }];
}

function dataVariableMapper(rule) {
    const operation = ruleVariableOperationMap[rule.operator];
    if (operation !== RuleConfigAbstractVariableRelationalOperation.ValueIsNotEmpty && operation !== RuleConfigAbstractVariableRelationalOperation.ValueIsEmpty) {
        return {
            operation,
            value: rule.value,
        };
    }
    return {
        operation: operation,
    };
}
function getVariablesGeneric(variablesData) {
    if (!variablesData) {
        return [];
    }
    return variablesData.map((data) => ({
        key: data.name,
        constraints: data.rules.map(dataVariableMapper),
    }));
}

function getVisitorTrafficSource(visitorProfileData) {
    if (!visitorProfileData) {
        return [];
    }
    const defaultSources = visitorProfileData.defaultSources;
    if (!defaultSources) {
        return [];
    }
    return [{
            sourceDomains: defaultSources.map((item) => sourceDomainMap[item] ?? item),
            outcome: ruleConditionMap[visitorProfileData.condition],
        }];
}

function basicRuleDatesSingularMapper(rule) {
    const outcome = ruleConditionMap[rule.condition];
    const operation = ruleRelationalOperationDatesSingularMap[rule.operator];
    if (!operation) {
        return null;
    }
    if (operation === RuleConfigRelationalOperation.Between) {
        return {
            valueFrom: getIsoDateFromEsEpoch(Number(rule.from)),
            valueTo: getIsoDateFromEsEpoch(Number(rule.to)),
            operation,
            outcome,
        };
    }
    return {
        valueSingle: getIsoDateFromEsEpoch(Number(rule.from)),
        operation,
        outcome,
    };
}
function getVisitDates(timingData) {
    const dateRanges = timingData?.dateRange;
    if (!dateRanges) {
        return [];
    }
    const referenceTimezone = referenceTimezoneMap[timingData.timezone];
    return dateRanges.map(basicRuleDatesSingularMapper)
        .filter((item) => item !== null)
        .map((item) => ({ ...item, referenceTimezone }));
}

function basicRuleDayPluralMapper(rule) {
    const outcome = ruleConditionMap[rule.condition];
    const operation = ruleRelationalOperationDatesPluralMap[rule.operator];
    if (!operation) {
        return null;
    }
    const from = daysOfTheWeekMap[rule.from];
    if (from === undefined) {
        return null;
    }
    if (operation === RuleConfigRelationalOperation.Between) {
        const to = daysOfTheWeekMap[rule.to];
        if (to === undefined) {
            return null;
        }
        return {
            valueFrom: from,
            valueTo: to,
            operation,
            outcome,
        };
    }
    return {
        valueSingle: from,
        operation,
        outcome,
    };
}
function getVisitDays(timingData) {
    const daysOfTheWeekRules = timingData?.daysOfTheWeek;
    if (!daysOfTheWeekRules) {
        return [];
    }
    const referenceTimezone = referenceTimezoneMap[timingData.timezone];
    return daysOfTheWeekRules.map(basicRuleDayPluralMapper)
        .filter((item) => item !== null)
        .map((item) => ({ ...item, referenceTimezone }));
}

function getVisitorFunnelProgress(funnelProgress) {
    const page = funnelPagesMap[funnelProgress];
    return page && funnelProgress ? [{
            outcome: RuleConfigCondition.ShouldInclude,
            pageFrom: page,
            pageTo: page,
        }] : [];
}

function getVisitorGeolocation(geolocationData) {
    if (!geolocationData) {
        return [];
    }
    return geolocationData.map((location) => ({
        geonameId: location.id,
        name: location.name,
        outcome: ruleConditionMap[location.condition],
    }));
}

const getHoursFromTimestring = (time) => {
    const [hh, mm] = time.split(':').map((item) => Number(item));
    const hours = mm === 59 ? (hh + 1) : hh;
    return hours % 24;
};

function getVisitHours(timingData) {
    const timeOfTheDayRules = timingData?.timeOfTheDay;
    if (!timeOfTheDayRules) {
        return [];
    }
    const referenceTimezone = referenceTimezoneMap[timingData.timezone];
    return timeOfTheDayRules.map((rule) => {
        const outcome = ruleConditionMap[rule.condition];
        const operation = ruleRelationalOperationDatesSingularMap[rule.operator];
        if (!operation) {
            return null;
        }
        if (typeof rule.from !== 'string') {
            return null;
        }
        if (operation === RuleConfigRelationalOperation.Between) {
            if (typeof rule.to !== 'string') {
                return null;
            }
            return {
                valueFrom: getHoursFromTimestring(rule.from),
                valueTo: getHoursFromTimestring(rule.to),
                operation,
                outcome,
                referenceTimezone,
            };
        }
        return {
            valueSingle: getHoursFromTimestring(rule.from),
            operation,
            outcome,
            referenceTimezone,
        };
    }).filter((item) => item !== null);
}

function getVisitorOraculoScore(oraculoData) {
    if (!oraculoData) {
        return [];
    }
    return Object.keys(oraculoVariablesMap).map((key) => {
        const source = oraculoData[key];
        const kind = oraculoVariablesMap[key];
        const isValid = source && kind && ('to' in source) && ('from' in source);
        return isValid ? {
            kind,
            max: source.to,
            min: source.from,
            outcome: RuleConfigCondition.ShouldInclude,
        } : null;
    }).filter((item) => item !== null);
}

function getVisitorStatus(visitorStatus) {
    if (visitorStatus === VisitorStatus.RegisteredOrLogged) {
        return [{
                outcome: RuleConfigCondition.ShouldInclude,
                isRegistered: true,
                realm: CredentialsRealm.Native,
            },
            {
                outcome: RuleConfigCondition.ShouldInclude,
                isLogged: true,
                realm: CredentialsRealm.Native,
            }];
    }
    if (visitorStatus === VisitorStatus.RegisteredAndLogged) {
        // For this option the requirement to be logged-in is the most restrictive;
        // additionally a visitor can't be logged-in without being registered.
        // Thus we just need to require that the visitor is currently logged-in,
        // there is no need to check for registration.
        return [{
                outcome: RuleConfigCondition.ShouldInclude,
                isLogged: true,
                realm: CredentialsRealm.Native,
            }];
    }
    if (visitorStatus === VisitorStatus.RegisteredAndNotLogged) {
        return [{
                outcome: RuleConfigCondition.ShouldInclude,
                isRegistered: true,
                isLogged: false,
                realm: CredentialsRealm.Native,
            }];
    }
    if (visitorStatus === VisitorStatus.NotRegisteredAndNotLogged) {
        return [{
                outcome: RuleConfigCondition.ShouldInclude,
                isRegistered: false,
                isLogged: false,
                realm: CredentialsRealm.Native,
            }];
    }
    if (visitorStatus === VisitorStatus.NotLogged) {
        return [{
                outcome: RuleConfigCondition.ShouldInclude,
                isLogged: false,
                realm: CredentialsRealm.Native,
            }];
    }
    return [];
}

function getStayDuettoDemand(duettoRule) {
    if (!duettoRule) {
        return [];
    }
    return [{
            min: duettoRule.from,
            max: duettoRule.to,
            outcome: RuleConfigCondition.ShouldInclude,
        }];
}

class RulesConfig {
    datalayerVariables;
    stayDuettoDemand;
    stayAvailability;
    stayDates;
    stayDays;
    stayDaysUntilCheckIn;
    stayDemand;
    stayDisparities;
    stayLength;
    stayOccupancyAdults;
    stayOccupancyChildren;
    stayOccupancyRooms;
    stayTotalCost;
    trafficSource;
    urlVariables;
    visitDates;
    visitDays;
    visitHours;
    visitorDaysSincePreviousVisit;
    visitorFunnelProgress;
    visitorGeolocation;
    visitorOraculoScore;
    visitorPreviousVisitsCount;
    visitorStatus;
    constructor(payloadRules = {}) {
        this.datalayerVariables = getVariablesGeneric(payloadRules.dataVariables?.dataLayerVariables);
        this.stayDuettoDemand = getStayDuettoDemand(payloadRules.integrations?.demandDuetto);
        this.stayDemand = getStayDemand(payloadRules.demand);
        this.stayAvailability = getStayAvailability(payloadRules.search?.bestAvailableRate);
        this.stayDates = getStayDates(payloadRules.search?.stayDates);
        this.stayDays = getStayDays(payloadRules.search?.stayDaysOfTheWeek);
        this.stayDaysUntilCheckIn = getStayDaysUntilCheckIn(payloadRules.search?.daysUntilCheckIn);
        this.stayDisparities = getStayDisparities(payloadRules.search?.disparities);
        this.stayLength = getStayLength(payloadRules.search?.lengthOfStay);
        this.stayOccupancyAdults = getNumericPluralGeneric(payloadRules.travelParty?.adults);
        this.stayOccupancyChildren = getNumericPluralGeneric(payloadRules.travelParty?.children);
        this.stayOccupancyRooms = getNumericPluralGeneric(payloadRules.travelParty?.rooms);
        this.stayTotalCost = getStayTotalCost(payloadRules.search?.bestAvailableRate);
        this.trafficSource = getVisitorTrafficSource(payloadRules.visitorProfile);
        this.urlVariables = getVariablesGeneric(payloadRules.dataVariables?.urlVariables);
        this.visitDays = getVisitDays(payloadRules.timing);
        this.visitDates = getVisitDates(payloadRules.timing);
        this.visitorDaysSincePreviousVisit = getNumericPluralGeneric(payloadRules.visitorBehaviour?.daysSinceLastVisit);
        this.visitorFunnelProgress = getVisitorFunnelProgress(payloadRules.visitorBehaviour?.funnelProgress);
        this.visitorGeolocation = getVisitorGeolocation(payloadRules.visitorProfile?.locations);
        this.visitHours = getVisitHours(payloadRules.timing);
        this.visitorOraculoScore = getVisitorOraculoScore(payloadRules.oraculo);
        this.visitorStatus = getVisitorStatus(payloadRules.visitorBehaviour?.visitorStatus);
        this.visitorPreviousVisitsCount = getNumericPluralGeneric(payloadRules.visitorBehaviour?.numberOfPastVisits);
    }
}

const defaultActions = () => {
    const dismiss = {
        kind: AgentActionKind.Dismiss,
    };
    const engage = {
        kind: AgentActionKind.Engage,
    };
    const fallback = {
        kind: AgentActionKind.Fallback,
    };
    const genericLinkClick = {
        kind: AgentActionKind.GenericLinkClick,
        shouldSendActivity: true,
    };
    const hide = {
        kind: AgentActionKind.Hide,
    };
    const show = {
        kind: AgentActionKind.Show,
    };
    const actions = [
        dismiss,
        engage,
        fallback,
        genericLinkClick,
        hide,
        show,
    ];
    return actions;
};
const loginAction = (moduleId) => {
    const result = {
        moduleId,
        kind: AgentActionKind.Login,
        shouldSendActivity: true,
    };
    return result;
};
const sendFormAction = (moduleId) => {
    const result = {
        moduleId,
        kind: AgentActionKind.SendForm,
        shouldSendActivity: true,
    };
    return result;
};
const sendSaveSearchAction = (moduleId) => {
    const result = {
        moduleId,
        kind: AgentActionKind.SendSaveSearch,
        shouldSendActivity: true,
    };
    return result;
};
const openUriAction = (moduleId, uri, action, newTab, inheritUrlParams, extraParams) => {
    const result = {
        moduleId,
        kind: AgentActionKind.OpenUri,
        uriSchema: uriSchemaMap[action],
        uri,
        inheritUrlParams,
        newTab,
        shouldSendActivity: true,
        extraParams,
    };
    return result;
};
const applyDiscountAction = (moduleId, value, kind) => {
    const discountCodeKind = discountCodeKindMap[kind];
    const discountCode = {
        id: null,
        value,
        kind: discountCodeKind,
    };
    const result = {
        moduleId,
        kind: AgentActionKind.ApplyDiscount,
        discountCode,
        shouldSendActivity: true,
    };
    return result;
};
const emptyAction = (moduleId) => {
    const result = {
        moduleId,
        kind: AgentActionKind.NoAction,
    };
    return result;
};
const sendSubscribeAction = (moduleId) => {
    const result = {
        moduleId,
        kind: AgentActionKind.SendSubscribe,
        shouldSendActivity: true,
    };
    return result;
};
const openBookingEngineAction = (moduleId, replayData, extraParams) => {
    const result = {
        moduleId,
        kind: AgentActionKind.OpenBookingEngine,
        replayData,
        shouldSendActivity: true,
        extraParams,
    };
    return result;
};

function calcSecondsLeftFromDuration(options) {
    const { durationSeconds, firstViewEpoch } = options;
    const currentEpoch = Math.round(Date.now() / 1000);
    const effectivePreviousViewEpoch = firstViewEpoch || currentEpoch;
    return durationSeconds - (currentEpoch - effectivePreviousViewEpoch);
}
function calcSecondsLeftFromExpiration(options) {
    const { expirationEpoch, timezone, moment } = options;
    if (!moment) {
        // TODO: possible alternative without library
        return undefined;
    }
    if (!expirationEpoch) {
        return undefined;
    }
    let expirationMoment = moment.unix(expirationEpoch).utc();
    expirationMoment = moment.tz(expirationMoment.format('YYYY-MM-DD HH:mm:ss'), timezone || moment.tz.guess());
    return expirationMoment.diff(moment().utc(), 'seconds');
}
/**
 * Calculates the seconds of life left depending on parameters.
 */
// TODO: delete once admin is deprecated
function calcSecondsLeft(options) {
    const { durationSeconds, firstViewEpoch, expirationEpoch, timezone, moment, } = options;
    if (durationSeconds) {
        return calcSecondsLeftFromDuration({ durationSeconds, firstViewEpoch });
    }
    return calcSecondsLeftFromExpiration({ expirationEpoch, timezone, moment });
}

const ONE_MINUTE = 60;
const ONE_HOUR = 60 * 60;
const ONE_DAY = 60 * 60 * 24;
/**
 * Returns the Countdown when the type is DurationPerVisitor
 * @param firstVisitDate An Epoch (seconds) representing when the visitor first visited the tool
 */
const getDurationPerVisitorCountdown = (firstVisitDate, minutes, hours, days) => {
    const durationSeconds = minutes * ONE_MINUTE + hours * ONE_HOUR + (days ?? 0) * ONE_DAY;
    const secondsLeft = calcSecondsLeft({
        durationSeconds,
        firstViewEpoch: firstVisitDate,
    });
    return {
        secondsLeft,
        durationSeconds,
        kind: CountdownKind$1.DurationPerVisitor,
    };
};
/**
 * Returns the Countdown when the type is FixedExpiration and the timezone type is Visitor
 * @param date An ES Epoch (milliseconds) when the countdown will expire
 * @param [moment]
 */
const getFixedExpirationCountdownWithVisitorTimezone = (date, moment) => {
    const expirationEpoch = Math.round(date / 1000);
    const secondsLeft = calcSecondsLeft({
        expirationEpoch,
        moment,
    }) ?? 0;
    return {
        referenceTimezone: ReferenceTimezone.Visitor,
        expirationEpoch,
        secondsLeft,
        kind: CountdownKind$1.FixedExpiration,
    };
};
/**
 * Returns the Countdown when the type is FixedExpiration and the timezone type is Site
 * @param timezone The site timezone
 * @param date An ES Epoch (milliseconds) when the countdown will expire
 * @param [moment]
 */
const getFixedExpirationCountdownWithSiteTimezone = (timezone, date, moment) => {
    const expirationEpoch = Math.round(date / 1000);
    const secondsLeft = calcSecondsLeft({
        expirationEpoch,
        timezone,
        moment,
    }) ?? 0;
    return {
        referenceTimezone: ReferenceTimezone.Site,
        expirationEpoch,
        secondsLeft,
        kind: CountdownKind$1.FixedExpiration,
    };
};

/** Discriminates if a given language is considered RTL or not */
function isRtlLanguage(languageCode) {
    return Object.values(RightToLeftLanguageCode).includes(languageCode);
}

/**
 * Check if the passed tool content modules contain an activity
 * module of a given kind.
 */
function hasActivityOfKind(noteModules, activityKind) {
    return noteModules.some((content) => (content.moduleType === ToolModuleKind.Activity && content.textKey === activityKind));
}

const hasValidTranslatedUrl = (kebabLanguageCode, module) => {
    const { image } = module;
    if (!image) {
        return false;
    }
    if (image.languageType === LocaleImageKind.Single) {
        const urls = image.urls;
        if (!urls) {
            return false;
        }
        if (!urls.original) {
            return false;
        }
        return true;
    }
    const urls = image.urls;
    if (!urls) {
        return false;
    }
    if (!Object.keys(urls).includes(kebabLanguageCode)) {
        return false;
    }
    const url = urls[kebabLanguageCode];
    if (!url?.original) {
        return false;
    }
    return true;
};
const hasValidTranslatedTextInModule = (kebabLanguageCode, device, module) => {
    // TODO: remove casting to "mobile" | "desktop" once TranslatableModule gets updated to contain "native"
    const deviceKind = (
    // eslint-disable-next-line no-nested-ternary
    device === Device.Mobile
        ? Device.Mobile
        : (device === Device.Native ? Device.Native : Device.Desktop));
    const translatableModule = module;
    if (!(deviceKind in translatableModule)) {
        return false;
    }
    const translations = translatableModule[deviceKind];
    const translation = translations[kebabLanguageCode];
    if (!translation) {
        return false;
    }
    if (!translation.trim()) {
        return false;
    }
    return true;
};
const hasValidTranslatedTextInModules = (kebabLanguageCode, device, modules) => {
    const withoutCurrentLanguage = modules.find((module) => !hasValidTranslatedTextInModule(kebabLanguageCode, device, module));
    if (withoutCurrentLanguage) {
        return false;
    }
    return true;
};

const DYNAMIC_TAG_REGEX = /^(?:(?<source>.+?)@@@@)?(?<name>.+?)(?: \| '(?<defaultValue>.*)')?$/;
const fillDynamicTags = (keys, services) => {
    const { dataLayerHelper, globalThis, getVisitorLastComparison } = services;
    const builtInHelper = {
        lastComparison: undefined,
        getLastComparisonOnce() {
            if (this.lastComparison === undefined) {
                this.lastComparison = getVisitorLastComparison({ acceptStayDatesBeforeToday: false }) ?? null;
            }
            return this.lastComparison;
        },
        get(key) {
            switch (key) {
                case ActivityKind.TodaySpecialOffer:
                case 'last_search_price': {
                    const { response, original } = this.getLastComparisonOnce()?.data ?? {};
                    return response?.priceData?.formats?.shownHtmlPm || response?.priceData?.formats?.shownHtml || original?.priceFormatted;
                }
                case 'last_search_check_in': {
                    const { response, original } = this.getLastComparisonOnce()?.data ?? {};
                    return response?.data?.dateBeginFormatted || original?.dateBeginFormatted;
                }
                case 'last_search_check_out': {
                    const { response, original } = this.getLastComparisonOnce()?.data ?? {};
                    return response?.data?.dateEndFormatted || original?.dateEndFormatted;
                }
                case 'last_search_adults': {
                    const { actual } = this.getLastComparisonOnce()?.data ?? {};
                    return actual?.search?.adults;
                }
                case 'last_search_children': {
                    const { actual } = this.getLastComparisonOnce()?.data ?? {};
                    return actual?.search?.children ?? '0';
                }
                case 'last_search_rooms': {
                    const { actual } = this.getLastComparisonOnce()?.data ?? {};
                    return actual?.search?.rooms;
                }
                case 'last_search_nights': {
                    const { actual } = this.getLastComparisonOnce()?.data ?? {};
                    return actual?.search?.nights;
                }
                default:
                    throw new Error('unknown key');
            }
        },
    };
    const dataProviders = {
        BuiltIn: builtInHelper,
        DataLayer: dataLayerHelper,
        URL: new URLSearchParams(globalThis.location.search),
    };
    const isValidSource = (key) => key in dataProviders;
    const dynamicTags = Object.fromEntries(keys.flatMap((key) => {
        const match = key.match(DYNAMIC_TAG_REGEX);
        const { source, name, defaultValue } = match?.groups || {};
        const effectiveSource = source ?? 'BuiltIn';
        if (!isValidSource(effectiveSource)) {
            return [];
        }
        const effectiveKey = source ? `${source}@@@@${name}` : name;
        const effectiveDefaultValue = defaultValue === '' ? undefined : defaultValue;
        const dataProvider = dataProviders[effectiveSource];
        try {
            const rawData = dataProvider.get(name);
            const data = rawData !== undefined && rawData !== null && !isString(rawData) ? String(rawData) : rawData;
            const effectiveData = data || effectiveDefaultValue;
            // TODO: Store only one of the keys (either with or without the default value)
            // once it's clear how the component will use it.
            return [[key, effectiveData], [effectiveKey, effectiveData]];
        }
        catch (error) {
            if (error instanceof Error && error.message === 'unknown key') {
                return [];
            }
            return [[key, effectiveDefaultValue], [effectiveKey, effectiveDefaultValue]];
        }
    }));
    return dynamicTags;
};

function createReplayData(buildDefaultSearch, search, discount) {
    if (search === null) {
        return null;
    }
    return {
        search: search
            || buildDefaultSearch(),
        discount: { id: null, value: '', kind: DiscountCodeKind$1.Default },
    };
}

class Tool {
    payload;
    context;
    container;
    state;
    originalState;
    rulesConfig;
    modalLayouts = [
        ToolLayoutKind.Circular,
        ToolLayoutKind.CustomImage,
        ToolLayoutKind.Fullscreen,
        ToolLayoutKind.FullscreenMini,
        ToolLayoutKind.Sidebar,
        ToolLayoutKind.Square,
        ToolLayoutKind.SquareImage,
    ];
    static defaultState = Object.freeze({
        checked: false,
        closed: false,
        manualStatus: '',
        opened: false,
        processed: false,
        showed: false,
        toBeShown: false,
    });
    constructor({ payload, context, container, state = { ...Tool.defaultState }, originalState, }) {
        this.payload = payload;
        this.context = context;
        this.container = container;
        this.state = state;
        this.originalState = originalState || { ...this.state };
    }
    /**
     * Denotes that the tool is ready for usage.
     * No other method other than the above privileged methods
     * should be used before the Promise resolves.
     */
    async onReady() {
        if (this.getCountdown()) {
            await this.container.async.moment;
        }
        return this;
    }
    // ToolLike follows
    getContext() {
        return this.context;
    }
    getDevices() {
        const { devices } = this.payload.settings || {};
        if (!devices) {
            return [Device.Desktop, Device.Mobile, Device.Native];
        }
        const activeDevices = [];
        if (devices[DeviceKind.Desktop]?.active) {
            activeDevices.push(Device.Desktop);
        }
        if (devices[DeviceKind.Mobile]?.active) {
            activeDevices.push(Device.Mobile);
        }
        if (devices[DeviceKind.Native]?.active) {
            activeDevices.push(Device.Native);
        }
        return activeDevices;
    }
    getPayload() {
        return this.payload;
    }
    getPosition() {
        const { layout, devices, embedded } = this.payload.settings ?? {};
        const { device } = this.context;
        if (embedded) {
            const position = (device === Device.Mobile ? embedded.mobile?.position : embedded.desktop?.position);
            return inlinerPositionMap[position] ?? null;
        }
        return layout?.position
            ?? (device === Device.Mobile ? devices?.mobile?.position : devices?.desktop?.position)
            ?? null;
    }
    getContainer() {
        return this.container;
    }
    getState() {
        return this.state;
    }
    getStatus() {
        if (this.state.checked) {
            if (this.state.failedRuleId === 'oraculos_standard') {
                return 'excluded-oraculo';
            }
            if (this.state.failedRuleKind === RuleKind.Targeting) {
                return 'excluded-targeting';
            }
            if (!this.state.toBeShown) {
                return 'excluded-other';
            }
            if (this.state.processed) {
                if (this.state.controlSelected) {
                    return 'control';
                }
                if (this.state.showed) {
                    return 'showed';
                }
                if (!this.state.controlSelected && !this.state.showed && !this.state.manualStatus) {
                    return 'loading';
                }
                // Manual status can only be effective when the tool has been processed
                if (this.state.manualStatus) {
                    return this.state.manualStatus;
                }
            }
        }
        return null;
    }
    updatePayload(payload) {
        merge(this.payload, payload);
    }
    updateContext(value) {
        merge(this.context, value);
    }
    updateState(value) {
        merge(this.state, value);
        this.container.bus.emit('thn:tool.updated', null, this);
    }
    resetState() {
        Object.keys(this.state).forEach((key) => {
            delete this.state[key];
        });
        this.updateState(this.originalState);
    }
    toJSON() {
        return {
            context: this.context,
            payload: this.payload,
            state: this.state,
            originalState: this.originalState,
        };
    }
    clone() {
        return new Tool({
            payload: collectionClone(this.payload),
            context: collectionClone(this.context),
            container: this.container,
            state: this.state,
            originalState: this.originalState,
        });
    }
    cloneDeep() {
        return new Tool({
            ...JSON.parse(JSON.stringify(this)),
            container: this.container,
        });
    }
    getAbTestPercentage() {
        const { percentAbTest } = this.payload.tokens ?? {};
        return percentAbTest ? Number(percentAbTest) : null;
    }
    getActions() {
        const basicActions = defaultActions();
        const nonInteractionActions = [];
        if (this.payload.type === 'predictive_audience') {
            nonInteractionActions.push({
                kind: AgentActionKind.PredictiveAudience,
                predictiveAudienceId: this.getId(),
            });
        }
        if (this.payload.type === 'custom_script' && this.payload.source) {
            nonInteractionActions.push({
                kind: AgentActionKind.LoadScript,
                source: this.payload.source,
            });
        }
        if (this.context.widgetName === WidgetsList.Note
            && this.getLayout() === ToolLayoutKind.Bar
            && this.payload.settings?.layout.behaviour !== 'overlay'
            && this.getPosition() !== 'B') {
            nonInteractionActions.push({ kind: AgentActionKind.TranslateDocumentBody });
        }
        const { modules = [] } = this.payload.content || {};
        const moduleActions = modules
            .map((contentModule) => {
            const { id, moduleType } = contentModule;
            if (moduleType === ToolModuleKind.Form) {
                return sendFormAction(id);
            }
            if (moduleType === ToolModuleKind.SavedSearch) {
                return sendSaveSearchAction(id);
            }
            if (moduleType === ToolModuleKind.Button
                || moduleType === ToolModuleKind.ImageWithBehaviour) {
                const moduleWithAction = contentModule;
                const { // @ts-ignore - Get extraParams from wherever the data comes from. This extraction is for guidance only.
                type: action, extraParameters, inheritUrlParams, openNewTab, } = moduleWithAction.behaviour;
                const extraParams = extraParameters;
                if (action === ButtonActionKind.OpenUrl
                    || action === ButtonActionKind.OpenMailClient
                    || action === ButtonActionKind.CallPhoneNumber) {
                    const { value } = moduleWithAction.behaviour;
                    if (!value) {
                        return null;
                    }
                    const { kebabLanguageCode } = this.context;
                    const uri = typeof value === 'object' ? kebabLanguageCode && value[kebabLanguageCode] : value;
                    if (!uri) {
                        return null;
                    }
                    return openUriAction(id, uri, action, openNewTab, inheritUrlParams, extraParams);
                }
                if (action === ButtonActionKind.OpenBookingEngine
                    || action === ButtonActionKind.LastSearch) {
                    const { search = null } = this.container.getVisitorLastComparison({ acceptStayDatesBeforeToday: false, acceptWithoutAvailability: false })?.data?.actual || {};
                    const defaultCurrency = this.context.currencyCode || search?.currency || this.context.siteCurrencyCode || CurrencyCode.Usd;
                    const replayData = createReplayData(this.container.buildDefaultSearch, action === ButtonActionKind.LastSearch
                        ? search
                        : this.container.buildDefaultSearch({ currency: defaultCurrency }));
                    return openBookingEngineAction(id, replayData, extraParams);
                }
                if (action === ButtonActionKind.ApplyPromoCode) {
                    const { value, kind } = moduleWithAction.behaviour;
                    if (!value) {
                        return null;
                    }
                    if (!kind) {
                        return null;
                    }
                    return applyDiscountAction(id, value, kind);
                }
                if (action === ButtonActionKind.CloseTool) {
                    return emptyAction(id);
                }
                if (action === ButtonActionKind.SavedSearch) {
                    return sendSaveSearchAction(id);
                }
            }
            if (moduleType === ToolModuleKind.EmailCapture) {
                return sendSubscribeAction(id);
            }
            if (moduleType === ToolModuleKind.Login) {
                return loginAction(id);
            }
            return null;
        })
            .filter((moduleAction) => moduleAction !== null);
        const actions = [...basicActions, ...nonInteractionActions, ...moduleActions];
        return actions;
    }
    getCountdown() {
        const { modules = [] } = this.payload.content || {};
        const module = modules.find((item) => item.moduleType === ToolModuleKind.Countdown);
        if (!module) {
            return null;
        }
        const countdown = module;
        const { details } = countdown;
        // case: duration per visitor (from it first seen)
        if (countdown.type === CountdownKind.Time) {
            const firstVisitDate = this.getVisitorFirstVisitDateOnSite();
            return getDurationPerVisitorCountdown(firstVisitDate, details.minutes, details.hours, details.days);
        }
        // case: fixed expiration date
        if (!details.date) {
            return null;
        }
        const { moment } = this.container;
        const expirationDateTimeMs = details.date + (details.hours * 60 * 60 * 1000) + (details.minutes * 60 * 1000);
        // case: fixed expiration date with visitor timezone
        if (details.timezone === CountdownTimezone.Visitor) {
            return getFixedExpirationCountdownWithVisitorTimezone(expirationDateTimeMs, moment);
        }
        // case: fixed expiration date with hotel timezone
        const { siteTimezone } = this.context;
        if (!siteTimezone) {
            const incompleteCountdown = {
                expirationEpoch: 0,
                kind: CountdownKind$1.FixedExpiration,
                referenceTimezone: ReferenceTimezone.Site,
                secondsLeft: 0,
            };
            return incompleteCountdown;
        }
        return getFixedExpirationCountdownWithSiteTimezone(siteTimezone, expirationDateTimeMs, moment);
    }
    // eslint-disable-next-line class-methods-use-this
    getDiscountCodes() {
        return [];
    }
    getEvaluationFrequency() {
        const { frequency = TimingFrequency.EveryPage } = this.payload.settings?.timing || {};
        return evaluationFrequencyMap[frequency];
    }
    getHideTime() {
        const { pagetime } = this.payload.settings?.timing || {};
        if (!pagetime) {
            return null;
        }
        if (pagetime === -1) {
            return null;
        }
        const result = pagetime * 1000;
        return result;
    }
    getId() {
        return this.payload.toolId || this.payload.id || '';
    }
    getMountSelector() {
        if (this.context.widgetName !== WidgetsList.Inliner) {
            return null;
        }
        if (this.context.device === Device.Mobile) {
            return this.payload.settings?.embedded?.mobile?.cssSelector ?? null;
        }
        return this.payload.settings?.embedded?.desktop?.cssSelector ?? null;
    }
    getName() {
        return this.payload.name;
    }
    // eslint-disable-next-line class-methods-use-this
    getScope() {
        // Note: all tools are considered "chain" tools on nostromo
        // because they are all shared among different sites
        return Scope.CrossSite;
    }
    getSites() {
        if (this.payload.properties) {
            return this.payload.properties.map((site) => site.id);
        }
        // If nothing configured, assume the tool targets the "current" site
        if (this.context.siteId) {
            return [this.context.siteId];
        }
        return [];
    }
    getPages() {
        return this.payload.pages.map((page) => ({ name: page }));
    }
    getPreviousDayBookingsCountOnSite() {
        if (hasActivityOfKind((this.payload.content?.modules || []), ActivityKind.BookedToday)) {
            return Number(this.payload.tokens?.bookedToday) || 0;
        }
        return null;
    }
    getTimeSincePreviousBookingOnSite() {
        if (hasActivityOfKind((this.payload.content?.modules || []), ActivityKind.LastReservation)) {
            return Number(this.payload.tokens?.lastReservation) || 0;
        }
        return null;
    }
    // eslint-disable-next-line class-methods-use-this
    getPreviousWeekTravelersCountOnSite() {
        return null;
    }
    getCurrentVisitorsCountOnSite() {
        if (hasActivityOfKind((this.payload.content?.modules || []), ActivityKind.NowViewing)) {
            return Number(this.payload.tokens?.nowViewing) || 0;
        }
        return null;
    }
    getOfferedPriceDifferenceOnSite() {
        if (hasActivityOfKind((this.payload.content?.modules || []), ActivityKind.DiscountToday)) {
            return Number(this.payload.tokens?.discountToday) || 0;
        }
        return null;
    }
    getPreviousDayVisitorsCountOnSite() {
        if (hasActivityOfKind((this.payload.content?.modules || []), ActivityKind.TodayViewed)) {
            return Number(this.payload.tokens?.todayViewed) || 0;
        }
        return null;
    }
    getLayout() {
        return this.payload.settings?.layout?.type;
    }
    getRulesConfig() {
        if (!this.rulesConfig) {
            this.rulesConfig = new RulesConfig(this.payload.audience?.rules ?? {});
        }
        return this.rulesConfig;
    }
    getTrigger() {
        const { trigger } = this.payload.settings || {};
        if (!trigger || trigger.type === TriggerKind.Load) {
            const loadData = {
                kind: TriggerKind$1.Load,
                delayTime: trigger?.delay || 0,
            };
            return loadData;
        }
        if (trigger.type === TriggerKind.Scroll) {
            const scrollData = {
                kind: TriggerKind$1.Scroll,
                scrollOffset: trigger.scrollOffset || 0,
            };
            return scrollData;
        }
        const idleData = {
            kind: TriggerKind$1.Idle,
            idleTime: trigger.delay || 0,
        };
        return idleData;
    }
    getVersionId() {
        return this.payload.versionId || '';
    }
    getVisitorFirstVisitDateOnSite() {
        const timestamp = this.payload.tokens?.visitorFirstVisitDateOnSite;
        if (!timestamp) {
            return 0;
        }
        return Number(timestamp.slice(0, 10)) || 0;
    }
    getVisitorPreviousVisitDateOnSite() {
        const timestamp = this.payload.tokens?.visitorPreviousVisitDateOnSite;
        if (!timestamp) {
            return 0;
        }
        return Number(timestamp.slice(0, 10)) || 0;
    }
    getVisitorPreviousVisitDateOnCrossSite() {
        const timestamp = this.payload.tokens?.visitorPreviousVisitDateOnCrossSite;
        if (!timestamp) {
            return 0;
        }
        return Number(timestamp.slice(0, 10)) || 0;
    }
    getAllTokens() {
        const originalDynamicTags = this.getDynamicTags();
        if (!originalDynamicTags.length) {
            return this.payload.tokens;
        }
        const dynamicTags = fillDynamicTags(originalDynamicTags, this.container);
        const { tokens } = this.payload;
        return {
            ...tokens,
            ...dynamicTags,
        };
    }
    getDynamicTags() {
        const dynamicTags = this.payload.dynamicTags || [];
        const modules = this.payload.content?.modules || [];
        if (hasActivityOfKind(modules, ActivityKind.TodaySpecialOffer)) {
            dynamicTags.push(ActivityKind.TodaySpecialOffer);
        }
        return dynamicTags;
    }
    hasApplyDiscountAction() {
        return this.getActions()
            .filter((action) => action.kind === AgentActionKind.ApplyDiscount).length > 0;
    }
    involvesComparison() {
        if (this.getDiscountCodes().length) {
            return true;
        }
        const modules = this.payload.content?.modules || [];
        if (hasActivityOfKind(modules, ActivityKind.TodaySpecialOffer)) {
            return true;
        }
        const containsModulesInvolvingComparison = modules.some((contentModule) => {
            const { moduleType } = contentModule;
            if (contentModule.moduleType === ToolModuleKind.SavedSearch) {
                return true;
            }
            if (moduleType === ToolModuleKind.Button
                || moduleType === ToolModuleKind.ImageWithBehaviour) {
                const moduleWithAction = contentModule;
                const { type: action } = moduleWithAction.behaviour;
                if (action === ButtonActionKind.LastSearch) {
                    return true;
                }
            }
            return false;
        });
        if (containsModulesInvolvingComparison) {
            return true;
        }
        const rulesConfig = this.getRulesConfig();
        if (rulesConfig.stayAvailability?.length
            || rulesConfig.stayDates?.length
            || rulesConfig.stayDays?.length
            || rulesConfig.stayDaysUntilCheckIn?.length
            || rulesConfig.stayLength?.length
            || rulesConfig.stayOccupancyAdults?.length
            || rulesConfig.stayOccupancyChildren?.length
            || rulesConfig.stayOccupancyRooms?.length
            || rulesConfig.stayTotalCost?.length) {
            return true;
        }
        return false;
    }
    isAbTesting() {
        return this.getAbTestPercentage() !== null;
    }
    isActive() {
        const { status } = this.payload;
        return status === 'live';
    }
    isBackendDiscarded() {
        const { isBackendRejected } = this.payload.tokens ?? {};
        return isBackendRejected === '1';
    }
    isComplete() {
        const { kebabLanguageCode } = this.context;
        if (!kebabLanguageCode) {
            return false;
        }
        const { modules = [] } = this.payload.content || {};
        const { device } = this.context;
        const imageWithBehaviourModule = modules.find((module) => module.moduleType === ToolModuleKind.ImageWithBehaviour);
        if (imageWithBehaviourModule) {
            return hasValidTranslatedUrl(kebabLanguageCode, imageWithBehaviourModule);
        }
        const translatableModuleKinds = [
            ToolModuleKind.Paragraph,
            ToolModuleKind.Button,
            ToolModuleKind.Heading,
        ];
        const translatableModules = modules.filter((module) => translatableModuleKinds.includes(module.moduleType));
        if (translatableModules) {
            return hasValidTranslatedTextInModules(kebabLanguageCode, device, translatableModules);
        }
        return false;
    }
    isExperiment() {
        return !!this.payload.flowInfo?.experimentId;
    }
    isModal() {
        if (this.context.widgetName === WidgetsList.Note) {
            return false;
        }
        if (this.context.widgetName === WidgetsList.Inliner) {
            return false;
        }
        const layoutKind = this.payload.settings?.layout?.type;
        if (!layoutKind) {
            return false;
        }
        return this.modalLayouts.includes(layoutKind);
    }
    shouldEvaluateWithoutLimits() {
        return this.payload.settings?.display ?? false;
    }
    shouldRtl() {
        return isRtlLanguage(this.context.languageCode);
    }
    getFontsData() {
        const fonts = this.payload.theme?.styles?.fonts;
        if (!fonts) {
            return null;
        }
        const fontsData = Object.values(fonts)
            .filter((font) => font.spec.fontType === FontType.File || font.spec.fontType === FontType.Google)
            .map((src) => {
            const { spec } = src;
            const font = {
                family: spec.cssName,
                key: spec.key,
                kind: spec.fontType,
            };
            return font;
        });
        return fontsData;
    }
}

/**
 * Decorates a property descriptor with default values.
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/defineProperty#description}
 * @param {object} descriptor - The descriptor to be decorated.
 * @return {object}
 */
function decoratePropertyDescriptor(descriptor = {}) {
    return {
        ...DEFAULT_PROPERTY_DESCRIPTOR,
        ...descriptor,
    };
}

/**
 * Denotes if a given fingerprint ending char code is an even number.
 *
 * When the ending char code is even, then the visitor would be selected
 * to be in the "control" group of an AB test (without visual feedback).
 *
 * When the ending char code is odd, then the visitor would NOT be selected
 * to be in the "control" group of an AB test (will have visual feedback).
 */
function isFingerprintPar(fingerprint = '') {
    return fingerprint.substr(-1).charCodeAt(0) % 2 === 0;
}

const magicNumber = 0.390625;
/**
 * Determine if a given fingerprint should be selected to be in
 * the control group of an AB test, with variable percentage.
 *
 * The standard AB test splits the groups in 50%. In this function
 * we can specify the % of visitors we want to be in the control group.
 *
 * @param fingerprint - The visitor fingerprint.
 * @param percent - The percentage of visitors to be in the control group,
 *  in a range of `0` (no visitors in the control group) to `100` (all
 *  visitors in the control group).
 */
function isFingerprintPercent(fingerprint, percent) {
    return parseInt(`0X${fingerprint.slice(-2)}`, 16) * magicNumber < percent;
}

const trap = () => { };
class Widget {
    /** The services container. */
    container;
    /** The scoped logger. */
    logger = {
        closeDebugGroup: trap,
        debug: trap,
        error: trap,
        info: trap,
        log: trap,
        openDebugGroup: trap,
        time: trap,
        timeEnd: trap,
        trace: trap,
        warn: trap,
    };
    __init = {};
    // eslint-disable-next-line class-methods-use-this
    get __computed() {
        return {
            targetPages: decoratePropertyDescriptor({
                get: () => {
                    const extraPages = this.container.getSetting(`${stringSnakeCase(String(this.data.name))}_target_pages`);
                    if (this.data.pages) {
                        return [...this.data.pages, ...(Array.isArray(extraPages) ? extraPages : [])];
                    }
                    if (!empty(extraPages)) {
                        return Array.isArray(extraPages) ? extraPages : [];
                    }
                },
            }),
        };
    }
    // eslint-disable-next-line class-methods-use-this
    get __default() {
        return {
            initialized: false,
            online: 0,
            registered: false,
        };
    }
    // eslint-disable-next-line class-methods-use-this
    get __excluded() {
        return ['callEngine', 'setup'];
    }
    // eslint-disable-next-line class-methods-use-this
    get __preserved() {
        return [
            'bubbles',
            'initialized',
            'registered',
        ];
    }
    get callEngine() {
        return this.container?.callEngine;
    }
    constructor(options) {
        this.setup(options);
    }
    setup(options) {
        const priscine = empty(this.data);
        const { container } = options;
        setup.call(this, options);
        // Assign the container
        if (!(this.container || container)) {
            throw new Error('Missing service container');
        }
        if (container) {
            this.container = container;
        }
        // Bind prototype chain methods to the widget instance
        let proto = Object.getPrototypeOf(this);
        const objectPrototype = Object.getPrototypeOf({});
        while (proto !== objectPrototype) {
            // eslint-disable-next-line @typescript-eslint/no-loop-func
            Object.getOwnPropertyNames(proto).forEach((key) => {
                const value = proto[key];
                if (typeof value === 'function' // is a function AND
                    && !this.__excluded.some((fname) => key === fname) // is NOT excluded
                    && !Object.prototype.hasOwnProperty.call(this, key) // the widget doesn't have this property already AND
                    && ( // is not bound
                    Object.prototype.hasOwnProperty.call(value, 'prototype')
                        || !value.name
                        || (value.name.indexOf('bound ') !== 0))) {
                    // bind the function to the widget
                    this[key] = value.bind(this);
                }
            });
            proto = Object.getPrototypeOf(proto);
        }
        // Assign a logger for the widget
        if (this.container.$has('Logger')) {
            this.logger = this.container.Logger.get(this.data.name);
        }
        // Execute the registration hook
        if (priscine) {
            this.register();
        }
    }
    /**
     * Sends a message to the parent window with postMessage.
     */
    bubble(payload) {
        if (this.shouldBubble()) {
            this.container.globalThis.parent.postMessage(
            // Filter through stringify to avoid non-clonables
            JSON.parse(stringify(payload)), this.getTargetOrigin());
            return true;
        }
        return false;
    }
    getTargetOrigin() {
        return this.container.globalState.companionOrigin || '*';
    }
    /**
     * Denotes if the widget should "bubble" to the parent window.
     */
    shouldBubble() {
        return !!(isIframed() && this.data.bubbles);
    }
    /**
     * Register any application services/requirements.
     */
    register() {
        const debugPrefix = 'register()';
        // Typically registration should happen just once
        if (this.data.registered) {
            return this;
        }
        if (!this.container.$has('bus')) {
            throw new Error('Missing "bus" service');
        }
        this.data.registered = true;
        this.container.bus.on('window:message', (event) => {
            // On companion "thn_pong" action (ack of parent companion agent)
            // If this widget has bubbling capabilities, activate the bubbling.
            if (event?.data?.action === 'thn_pong' && 'bubbles' in this.data) {
                this.data.bubbles = true;
            }
        });
        this.container.bus.on('window:message', (event) => {
            const actionParts = event?.data?.action?.match(/(reset|reboot|remove|minimize|fix_ui|load|destroy)_([^_]+)_widget/);
            if (!(actionParts && actionParts.length > 2)) {
                return;
            }
            const args = event?.data?.args || [];
            const widgetName = actionParts[2];
            if (this.data.name !== widgetName) {
                return;
            }
            this.logger.trace(debugPrefix, 'Handled event', event);
            const widgetMethodName = actionParts[1];
            const widgetMethod = this[widgetMethodName];
            // Check if the method exists in the widget
            if (this[widgetMethodName]) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                widgetMethod(...args);
            }
            else {
                const widgetError = new Error(`Method ${widgetMethodName} does not exist in widget ${this.data.name}`);
                this.container.errorMonitor.addError(widgetError);
            }
        });
        return this;
    }
    /**
     * Initialization of Widgets that need loading of view related resources.
     *
     * This is a placeholder method, may be overwritten by inheritant
     * classes without this super method being called.
     *
     * @abstract
     */
    async init() {
        this.data.initialized = true;
        return this;
    }
    sendBeacon(endpoint, payload) {
        const result = this.container.sendBeacon(endpoint, payload);
        this.logger?.debug?.('sendBeacon()', endpoint, payload, result);
        return result;
    }
    /**
     * Sends a message to the companion agent with postMessage.
     *
     * @param payload - The message payload.
     * @param to - The intended recipient of the message.
     */
    transmit(payload, to) {
        // From parent to child if all this conditions are met:
        // 1 - We are not iframed (probably child)
        // 2 - Intended recipient is NOT explicitly the parent (probably ourselfs)
        // 3 - We have a registered child agent (of course)
        if (!isIframed() && to !== 'parent' && this.container.globalState?.childFrame) {
            this.container.globalState.childFrame?.postMessage(
            // Filter through stringify to avoid non-clonables
            JSON.parse(stringify(payload)), 
            // @ts-ignore to use as in postMessage(message: any, targetOrigin: string)
            this.getTargetOrigin());
            return true;
        }
        // From child to parent (aka "bubble") if all this conditions are met:
        // 1 - We have bubbling enabled
        // 2 - We are the child (iframe), which is implicit recognized in shouldBubble()
        // 3 - Intended recipient is NOT explicitly the child (us)
        if (this.shouldBubble() && to !== 'child') {
            return this.bubble(payload);
        }
        return false;
    }
    /**
     * Get the widget data.
     */
    getData() {
        return this.data;
    }
    /**
     * Decides if a user is considered a "control" user.
     *
     * When on AB test mode is active, the "control" users are those
     * that won't see widgets/tools.
     *
     * @param options.abTestActive - The AB test mode is active
     * @param options.fingerprint - The visitor fingeprint.
     * @param options.office - The visitor office status.
     * @param options.abTestPercentage - The percentage of visitors to
     *  be in the control group.
     */
    isControlUser({ abTestActive = !empty(this.getData().abTest), fingerprint = this.container.globalState.fingerprint, office = this.container.globalState.office, abTestPercentage = undefined, } = {}) {
        // If AB test mode is not active, no way to be a control user
        if (empty(abTestActive)) {
            return false;
        }
        // On office no-one is considered a control user
        if (!empty(office)) {
            return false;
        }
        // At this point, we are AB testing and not office, so
        // * ODD users are considered control (don't see tools)
        // * EVEN users are "web" users (see tools)
        return abTestPercentage !== null && abTestPercentage !== undefined
            ? isFingerprintPercent(fingerprint, abTestPercentage)
            : isFingerprintPar(fingerprint);
    }
    /**
     * Denotes if the Widget is online.
     */
    isOnline() {
        const data = this.getData();
        const { globalState } = this.container;
        // 1 - always online for office
        if (globalState.office) {
            return true;
        }
        // 2 - always offline for properties without paid products
        if (globalState.site?.isFreemium) {
            return false;
        }
        // 3 - the master THN switch must be ON
        if (!globalState.online) {
            return false;
        }
        // 3 - the master Widget switch (if exists) must be ON
        if (('online' in data) && !data.online) {
            return false;
        }
        const isMobile = globalState.media?.name === Device.Mobile;
        // 4 - the mobile specific Widget switch (if exists) must be ON
        if (isMobile && ('mobileOnline' in data) && !data.mobileOnline) {
            return false;
        }
        // 5 - desktop specific Widget switch (if exists) must be ON
        if (!isMobile && ('desktopOnline' in data) && !data.desktopOnline) {
            return false;
        }
        return true;
    }
    /**
     * Resets the widget data.
     */
    reset() {
        reset.apply(this);
        this.bubble({
            action: `reset_${this.data.name}_widget`,
        });
        return this;
    }
    /**
     * Emit an event on the event bus.
     *
     * Adds the `thn:<widgetName>.` prefix automatically.
     *
     * @param event - The event name
     */
    emit(event, ...args) {
        const qualified = `thn:${this.data.name}.${event}`;
        this.container.bus.emit(qualified, null, ...args);
        return this;
    }
    /**
     * Calls current widget's show implementation as a fallback in case
     * no load implementation is defined at current widget's level.
     */
    load(options) {
        // @ts-ignore
        // eslint-disable-next-line @typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-call
        return this.show?.(options) || Promise$1.resolve(this);
    }
    destroy(ctx) {
        const debugPrefix = 'destroy()';
        this.logger.trace(debugPrefix, 'Not implemented');
    }
    /**
     * Checks if the given page name matches a page where this widget should activate.
     */
    isTargetPage(pageName = this.container.globalState.pageName) {
        const { targetPages } = this.data;
        // "targetPages" value must be an array for even considering evaluation
        if (!Array.isArray(targetPages)) {
            return false;
        }
        // If the widget is not configured in any specific page: then it is active everywhere
        if (empty(targetPages)) {
            return true;
        }
        // If the widget is configured on specific pages...
        // we require a current detected page to do the check
        if (empty(pageName)) {
            return false;
        }
        // The widget is considered active if the current detected page
        // is one of the configured pages where this widget should activate
        return !!targetPages?.includes(pageName);
    }
    /**
     * Send object "events" that may come after evaluation.
     * AKA: send-event, ack-activity, activity
     */
    sendActivity(_target, _details) {
        const debugPrefix = 'sendActivity()';
        this.logger?.trace(debugPrefix, 'Not implemented');
        return false;
    }
    withSendActivity(fn, action, target) {
        let activitySent = false;
        const { handler, shouldSendActivity, ...pluckedAction } = action;
        return (async (...args) => {
            if (!activitySent) {
                activitySent = this.sendActivity(target, pluckedAction);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            return fn(...args);
        });
    }
}

/**
 * The Booking widget.
 */
class Booking extends Widget {
    get __default() {
        return {
            ...super.__default,
            name: WidgetsList.Booking,
            mode: WidgetMode.Auto,
            // always on
            online: 1,
            detectedData: [],
            completeData: {},
            pages: [PageName.BookingConfirmed],
        };
    }
    get __computed() {
        return {
            ...super.__computed,
            set: {
                get() {
                    const bookingDetails = this.completeData.bookings;
                    if (!bookingDetails?.length) {
                        return false;
                    }
                    return !bookingDetails.some((bookingData) => bookingData.set === false);
                },
            },
        };
    }
    /**
     * Register any application services/requirements.
     */
    register() {
        // Typically registration should happen just once
        if (this.data.registered) {
            return this;
        }
        // Super function flags registered=true
        super.register();
        // Register a listener for "visitor visit data" set,
        // which is the event triggered once a page changes and
        // the minimum visitor data has been set for that page.
        this.container.bus.on(['thn:visitor-visit-data.set'], () => {
            if (this.isTargetPage()) {
                this.init().catch((reason) => this.logger.debug(reason));
            }
        });
        this.container.bus.on(['thn:booking.set'], ({ data } = {}) => {
            const analyticsNames = [
                // The event name was originally send as "THN BOOKING", by error.
                // It has been deprecapted in the official docs, but we keep it in order not to break existing setups.
                this.data.name.toUpperCase(),
                // The event name corrected is "THN Booking" (consistent with the other Widgets)
                stringCapitalize(this.data.name),
            ];
            // This code sends our partners campaign parameters with booking events to track conversions when a user visits the website through a partner.
            // This fields are not part of the official documentation **on purpose** (to not promote their usage).
            // Note: This method is unreliable as URL parameters rarely persist during navigation. Remove when no longer in use.
            const campaignId = parseUrlParameter('campaign');
            const isCyberclickCampaign = campaignId.toLowerCase().startsWith('cbk_');
            const partnerCampaignIds = {
                gcid: parseUrlParameter('gclid'), // GCommerce ID
                gccampaign: isCyberclickCampaign ? null : campaignId, // GCommerce Campaign
                cbkid: isCyberclickCampaign ? campaignId : null, // Cyberclick ID
            };
            data.forEach((bookingData) => {
                // Remove undefined values via JSON.stringify
                const bookingParams = JSON.parse(JSON.stringify({
                    bookingId: bookingData.bookingId || undefined,
                    price: bookingData.price || undefined,
                    currency: bookingData.currency || undefined,
                    dateBegin: bookingData.dateBegin || undefined,
                    dateEnd: bookingData.dateEnd || undefined,
                    ...partnerCampaignIds,
                }));
                for (const analyticsName of analyticsNames) {
                    this.container.sendSiteAnalytics(analyticsName, bookingParams);
                }
            });
        });
        return this;
    }
    /**
     * Initializes the booking confirmed.
     */
    async init(params) {
        const debugPrefix = 'init()';
        // log
        this.logger.debug(debugPrefix, `Initializing Booking Confirmed${this.data.initialized ? ' (again)' : ''}`);
        if (params) {
            this.container.dataLayer.push(bookingDatalayerModel.transform(params));
            return this;
        }
        // mark as initialized
        this.data.initialized = true;
        // if mode is automatic
        if (this.data.mode === WidgetMode.Auto) {
            // Nobody knows WHY the Booking widget execution is delayed 1000ms
            // Indeed It doesn't make sense, seems like a very very OLD hack.
            // We should try to remove this delay, little by little ...
            // and we start with property 1024733 (Synxis)
            const disableBookingDelay = this.container.getSetting('disable_booking_delay');
            const delay = disableBookingDelay ? 0 : 1000;
            setTimeout(() => {
                // set data
                this.setData(params);
                // store the log
                this.save();
                // observe
                this.observeDom();
            }, delay);
            // if mode is manual and params where passed
        }
        else {
            this.logger.debug(`Booking Confirmed is executed in **${this.data.mode}** mode`);
            // set data
            this.setData(params);
            // store the log
            this.save();
        }
        return this;
    }
    /**
     * Denotes if the booking confirmed data is set.
     */
    isSet() {
        return this.data.set;
    }
    /**
     * Denote if the object passed can be considered
     * an external params valid object.
     *
     * "External params" means an object passed-in
     * in the programmatical api. For instance:
     * ```
     * thn.widgets.booking.init({
     *     booking_id: 'abcdf',
     *     currency: 'EUR',
     *     price: 1000,
     *     ...
     * });
     * ```
     */
    // eslint-disable-next-line class-methods-use-this
    isValidParams(obj) {
        // For now we just make a simple check
        return isPlainObject(obj);
    }
    /**
     * Saves the booking confirmed data.
     */
    save() {
        const debugPrefix = 'save()';
        this.logger.debug(debugPrefix, 'Call');
        const page = 'booking-confirmed';
        this.sendStatus();
        this.container.uploadReport()
            .catch((reason) => this.logger.debug(reason));
        // Send the HTML code if the setting is enabled
        if (this.container.getSetting('store_booking_html')) {
            this.container.uploadPageHtml(page);
        }
    }
    /**
     * Setup DOM observers needed for the booking confirmed.
     *
     * Should not be called directly, its called by booking_widget.init().
     * Does not apply if the widget is offline.
     * Each booking system has its own independent actions.
     * This function might do nothing.
     *
     * Notice: when using callbacks, remember NOT to use `this` to reference
     * the booking widget. Insted use the full namespace `thn.widgets.booking`
     * or you may use the `widget` alias.
     */
    observeDom() {
        const debugPrefix = 'observeDom()';
        // Engine
        const context = {
            widget: this,
        };
        this.logger.debug(debugPrefix, 'Call');
        this.callEngine('bookingObserveDom', context);
        return this;
    }
    /**
     * Denotes if the booking confirmed data is sufficient to be set.
     */
    // eslint-disable-next-line class-methods-use-this
    isEnough(params) {
        return !!((params.price && params.currency) || params.bookingId);
    }
    /**
     * Set widget configuration.
     */
    setConfig(params) {
        this.setup({
            extend: true,
            source: {
                initData: { ...this.__init, ...params },
            },
        });
        return this;
    }
    /**
     * Fills the booking ack data given the booking details and the last comparison context.
     * @param bookingDetails - The detected and the merged data validated
     * @param lastComparisonContext
     */
    fillBookingData(bookingDetails, lastComparisonContext) {
        const falsyValuesToNull = (data) => Object.fromEntries(Object.entries(data).map(([key, value]) => [key, value || null]));
        this.data.completeData = {
            bookings: bookingDetails.map((data, index) => {
                if (!data.bookingId) {
                    const formattedIndex = (index + 1).toString().padStart(2, '0');
                    // eslint-disable-next-line no-param-reassign
                    data.bookingId = `T-${this.container.globalState.contextId}-${formattedIndex}`;
                }
                return falsyValuesToNull(data);
            }),
            parsedData: this.data.detectedData.map((data) => falsyValuesToNull(data)),
            lastBookingSearch: {
                server: lastComparisonContext.server || null,
                client: lastComparisonContext.client || null,
            },
        };
    }
    /**
     * Set the booking widget data.
     *
     * The approach for this widget is greedy, this means calling
     * will try to record the booking in the DB even if this function detects nothing.
     * You must set the prop `set` to `false` to avoid that behaviour.
     *
     * This function will do nothing if the widget data is already set.
     * Please call {@link Booking#reset} previously to
     * unset the data.
     */
    setData(params) {
        const debugPrefix = 'setData()';
        this.logger.debug(debugPrefix, 'Call');
        if (params) {
            this.container.dataLayer.push(bookingDatalayerModel.transform(params));
            return this;
        }
        // Session Data
        const tmpSession = {};
        const estimatedData = {};
        // Use either last search or PW/PWP data, we do not want to infer data older than 24 hours
        const lastComparisonContext = this.container.getVisitorLastComparison({ acceptWithoutAvailability: false, acceptVisitDatesBeforeLast24Hours: false, asAll: true });
        const sourceData = lastComparisonContext.default;
        // Only try to guess data from session when in "auto" mode
        // (avoid for dataLayer mode)
        if (sourceData && this.isEnough(sourceData)) {
            Object.assign(tmpSession, sourceData);
            // Set an estimated booking data (remove undefined values via JSON.stringify)
            Object.assign(estimatedData, JSON.parse(JSON.stringify(tmpSession)));
            // Source Data price will be the cheapest per day but that is the best we got
            // Special case: if the Source Data data comes from the PWP, then price is already total
            if (tmpSession.dateBegin && tmpSession.dateEnd && tmpSession.price && sourceData.widgetName !== 'package') {
                estimatedData.price = tmpSession.price * daysBetween(tmpSession.dateBegin, tmpSession.dateEnd);
            }
        }
        const context = {
            debugPrefix: 'setData()',
            params,
            widget: this,
            tmpSession,
            estimatedData,
        };
        const detectedDataArray = this.getDetectedData(context);
        this.logger.debug(debugPrefix, 'Detected data:', detectedDataArray);
        this.logger.debug(debugPrefix, 'Estimated data:', estimatedData);
        const detectedDataValidated = bookingDetailsModel.transform({ bookingDetails: detectedDataArray });
        this.data.detectedData = detectedDataValidated.bookingDetails || [];
        const estimatedDataValidated = bookingDetailsItemModel.transform(estimatedData);
        this.logger.debug(debugPrefix, 'Detected data (validated):', detectedDataValidated.bookingDetails);
        this.logger.debug(debugPrefix, 'Estimated data (validated):', estimatedDataValidated);
        // always supersede estimation with obtained data
        // note: with this, all references to tmp_session should be going slowly (WIP)
        if (this.data.detectedData.length === 1) {
            const mergedData = this.data.detectedData.map((validatedData) => ({ ...estimatedDataValidated, ...validatedData }));
            this.logger.debug(debugPrefix, 'Merged data (validated):', mergedData);
            // mark as set if the minimum data has been set, and assign
            const detectedDataObject = bookingDetailsModel.transform({ bookingDetails: mergedData });
            this.fillBookingData(detectedDataObject.bookingDetails, lastComparisonContext);
        }
        else {
            this.logger.debug(debugPrefix, 'Detected and validated data with multi bookings, no estimated data will be merged.');
            this.fillBookingData(this.data.detectedData, lastComparisonContext);
        }
        // log
        this.data.completeData.bookings.forEach((data) => {
            this.logger.info(`Data actually set in the ${this.data.name} widget:`, ['',
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                ` Price     : ${data.price} ${data.currency}`,
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                ` Dates     : ${data.dateBegin} / ${data.dateEnd}`,
                // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                ` Booking Id: ${data.bookingId}`,
                ` Is set    : ${data.set ? 'Yes' : 'No'}`,
            ].join('\n'));
        });
        if (this.data.set) {
            this.emit('set', { data: this.data.completeData.bookings });
        }
        return this;
    }
    /**
     * @memberof module:widgets.Booking#
     */
    getDetectedData(context) {
        if (this.data.mode === 'datalayer') {
            return this.getDetectedDatalayerData();
        }
        return this.getDetectedEngineData(context);
    }
    /**
     * @memberof module:widgets.Booking#
     * @private
     */
    getDetectedDatalayerData() {
        const debugPrefix = 'getDetectedDatalayerData()';
        this.logger.debug(debugPrefix, 'Call');
        const thnDatalayerData = this.container.dataLayerHelper.get('thn');
        return [datalayerEventBookingModel.transform(thnDatalayerData, { strict: true })];
    }
    getDetectedEngineData(context) {
        const debugPrefix = 'getDetectedEngineData()';
        this.logger.debug(debugPrefix, 'Call');
        let detectedData = null;
        try {
            detectedData = this.callEngine('bookingParseData', { ...context, debugPrefix });
            if (Array.isArray(detectedData) && detectedData.length) {
                this.logger.debug(debugPrefix, 'Multi data:', detectedData);
                this.logger.debug(debugPrefix, 'Batch setting of each detected data, start by 0');
            }
        }
        catch (error) {
            this.logger.error(debugPrefix, error);
            this.container.errorMonitor.addError(error);
        }
        return (Array.isArray(detectedData) || !detectedData)
            ? detectedData
            : [detectedData];
    }
    /**
     * Send the result of a widget evaluation.
     * AKA: add-visit, tool-ack
     */
    sendStatus() {
        const debugPrefix = 'sendStatus()';
        this.logger.debug(debugPrefix, 'Call');
        if (!this.isSet()) {
            this.logger.debug(debugPrefix, 'Abort: no data set');
            return this;
        }
        // "just in case" call the main visit always
        this.container.sendPageVisit();
        const endpoint = '/agent/ack-booking';
        this.sendBeacon(endpoint, this.data.completeData);
        return this;
    }
}

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for (var i = decorators.length - 1; i >= 0; i--) {
        var context = {};
        for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
        for (var p in contextIn.access) context.access[p] = contextIn.access[p];
        context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
        var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        }
        else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function __runInitializers(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for (var i = 0; i < initializers.length; i++) {
        value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    }
    return useValue ? value : void 0;
}

// TODO: this decorators are temporarily here until the new package @thehotelsnetwork/agent-decorators is formalized
// Once that happens, we can import from them from that package.
function loggedMethod(originalMethod, context) {
    const methodName = `${String(context.name)}()`;
    function replacementMethod(...args) {
        this.logger?.trace?.(methodName, 'Call. Args:', args);
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-argument
        const result = originalMethod.call(this, ...args);
        this.logger?.trace?.(methodName, 'Call. Result:', result);
        return result;
    }
    return replacementMethod;
}

/**
 * The Booking Draft widget.
 */
let BookingDraft = /* #__PURE__ */ (() => {
    let _classSuper = Widget;
    let _instanceExtraInitializers = [];
    let _init_decorators;
    let _setData_decorators;
    let _getDetectedData_decorators;
    let _isEnough_decorators;
    let _isSet_decorators;
    let _sendStatus_decorators;
    let _reset_decorators;
    return class BookingDraft extends _classSuper {
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _init_decorators = [loggedMethod];
            _setData_decorators = [loggedMethod];
            _getDetectedData_decorators = [loggedMethod];
            _isEnough_decorators = [loggedMethod];
            _isSet_decorators = [loggedMethod];
            _sendStatus_decorators = [loggedMethod];
            _reset_decorators = [loggedMethod];
            __esDecorate(this, null, _init_decorators, { kind: "method", name: "init", static: false, private: false, access: { has: obj => "init" in obj, get: obj => obj.init }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _setData_decorators, { kind: "method", name: "setData", static: false, private: false, access: { has: obj => "setData" in obj, get: obj => obj.setData }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _getDetectedData_decorators, { kind: "method", name: "getDetectedData", static: false, private: false, access: { has: obj => "getDetectedData" in obj, get: obj => obj.getDetectedData }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _isEnough_decorators, { kind: "method", name: "isEnough", static: false, private: false, access: { has: obj => "isEnough" in obj, get: obj => obj.isEnough }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _isSet_decorators, { kind: "method", name: "isSet", static: false, private: false, access: { has: obj => "isSet" in obj, get: obj => obj.isSet }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _sendStatus_decorators, { kind: "method", name: "sendStatus", static: false, private: false, access: { has: obj => "sendStatus" in obj, get: obj => obj.sendStatus }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _reset_decorators, { kind: "method", name: "reset", static: false, private: false, access: { has: obj => "reset" in obj, get: obj => obj.reset }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(this, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        }
        get __default() {
            return {
                ...super.__default,
                name: WidgetsList.BookingDraft,
                online: 1,
                desktopOnline: 1,
                mobileOnline: 1,
                parsedData: [],
                pages: [PageName.UserRegisterPage],
            };
        }
        /**
         * Register any application services/requirements.
         */
        register() {
            // Typically registration should happen just once
            if (this.data.registered) {
                return this;
            }
            // Super function flags registered=true
            super.register();
            // Reacting to some key events this widget will kick-off
            this.container.bus.on([
                'thn:visitor-visit-data.set',
                'thn:on-state-change',
                'thn:on-hash-change',
                'dataLayer:push',
            ], () => {
                if (!this.isOnline()) {
                    return;
                }
                if (this.isTargetPage()) {
                    this.logger?.debug?.('Is target page');
                    this.init().catch((reason) => this.logger?.debug?.(reason));
                }
                else {
                    this.logger?.debug?.('Is not target page');
                }
            });
            return this;
        }
        /**
         * Initializes the Booking Draft widget.
         */
        async init() {
            await super.init();
            return this.setData();
        }
        /**
         * Set the Booking Draft widget data.
         */
        setData() {
            const debugPrefix = 'setData()';
            const detectedData = this.getDetectedData();
            this.logger.debug(debugPrefix, 'Detected data:', detectedData);
            if (!detectedData) {
                return this;
            }
            const { bookingDetails: detectedDataValidated } = bookingDetailsModel.transform({ bookingDetails: detectedData });
            const detectedDataValidatedFiltered = detectedDataValidated.filter((item) => this.isEnough(item));
            this.logger.debug(debugPrefix, 'Detected data (validated):', detectedDataValidatedFiltered);
            if (detectedDataValidatedFiltered.length) {
                this.data.parsedData = detectedDataValidatedFiltered;
                this.logger.info(`Data actually set in the ${this.data.name} widget:`, this.data.parsedData);
                this.emit('set', { data: this.data.parsedData });
                this.sendStatus();
            }
            return this;
        }
        getDetectedData() {
            const debugPrefix = 'getDetectedData()';
            let detectedData = null;
            try {
                const context = {
                    debugPrefix,
                    widget: this,
                };
                detectedData = this.callEngine('bookingDraftParseData', context);
            }
            catch (error) {
                this.logger.error(debugPrefix, error);
                this.container.errorMonitor.addError(error);
            }
            return (Array.isArray(detectedData) || !detectedData)
                ? detectedData
                : [detectedData];
        }
        /**
         * Denotes if the booking draft data is sufficient to be set.
         */
        // eslint-disable-next-line class-methods-use-this
        isEnough(params) {
            return !!(params.price && params.currency && params.dateBegin && params.dateEnd);
        }
        isSet() {
            return !!this.data.parsedData?.length;
        }
        sendStatus() {
            const debugPrefix = 'sendStatus()';
            if (!this.isSet()) {
                this.logger.debug(debugPrefix, 'Abort: no data set');
                return this;
            }
            if (!this.container.globalState.contextToken) {
                this.logger.warn(debugPrefix, 'Abort: no contextToken');
                return this;
            }
            // "just in case" call the main visit always
            this.container.sendPageVisit();
            const endpoint = '/agent/ack/booking-draft';
            this.sendBeacon(endpoint, { parsedData: this.data.parsedData });
            return this;
        }
        reset() {
            this.data.parsedData = [];
            return this;
        }
        constructor() {
            super(...arguments);
            __runInitializers(this, _instanceExtraInitializers);
        }
    };
})();

/**
 * The Chat widget.
 */
class Chat extends Widget {
    get __default() {
        return {
            ...super.__default,
            name: WidgetsList.Chat,
            mobileOnline: 0,
            pages: [],
            olarkId: null,
            olarkConfiguration: {},
            languageCodes: {
                en: 'en-US',
                de: 'de-DE',
                es: 'es-ES',
                fr: 'fr-FR',
                it: 'it-IT',
                nl: 'nl-NL',
                pt: 'pt-BR',
                ru: 'ru-RU',
                sv: 'sv-SE',
                tr: 'tr-TR',
                zh: 'zh-CN',
            },
        };
    }
    /**
     * Register any application services/requirements.
     */
    register() {
        // Typically registration should happen just once
        if (this.data.registered) {
            return this;
        }
        // Super function flags registered=true
        super.register();
        // Register a listener for "visitor visit data" set,
        // which is the event triggered once a page changes and
        // the minimum visitor data has been set for that page.
        this.container.bus.on('thn:visitor-visit-data.set', () => {
            if (this.isOnline() && this.isTargetPage()) {
                this.load().catch((reason) => this.logger.debug(reason));
            }
        });
        this.container.bus.on('thn:page.unload', () => {
            this.hide();
        });
        return this;
    }
    async init() {
        const debugPrefix = 'init()';
        this.logger.debug(debugPrefix, 'Call');
        if (!this.data.initialized || !this.container.globalThis.olark) {
            /* eslint-disable */
            /* Olark official init code */
            (function (o, l, a, r, k, y) {
                if (o.olark) {
                    return;
                }
                r = 'script';
                y = l.createElement(r);
                r = l.getElementsByTagName(r)[0];
                y.async = 1;
                y.src = `//${a}`;
                r.parentNode.insertBefore(y, r);
                y = o.olark = function () {
                    k.s.push(arguments);
                    k.t.push(+new Date());
                };
                y.extend = function (i, j) {
                    y('extend', i, j);
                };
                y.identify = function (i) {
                    y('identify', k.i = i);
                };
                y.configure = function (i, j) {
                    y('configure', i, j);
                    k.c[i] = j;
                };
                k = y._ = {
                    s: [],
                    t: [+new Date()],
                    c: {},
                    l: a,
                };
            }(this.container.globalThis, this.container.globalThis.document, 'static.olark.com/jsclient/loader.js'));
            /* eslint-enable */
            this.data.initialized = true;
        }
        // Olark generic config
        Object.entries(this.data.olarkConfiguration).forEach(([key, value]) => {
            this.logger.debug(debugPrefix, `option - ${key}: ${value}`);
            this.container.globalThis.olark?.configure(key, value);
        });
        // Olark language
        const { globalState } = this.container;
        const lang = this.data.languageCodes[globalState.language] || 'en-US';
        this.container.globalThis.olark?.configure('system.localization', lang);
        this.logger.debug(debugPrefix, `option - system.localization: ${lang}`);
        // Olark Id
        this.logger.debug(debugPrefix, `ID: ${this.data.olarkId}`);
        this.container.globalThis.olark?.identify(this.data.olarkId);
        return this;
    }
    isOnline() {
        return !!(super.isOnline()
            // This widget requires at minimum the olarkId
            && this.data.olarkId);
    }
    hide() {
        this.container.globalThis.olark?.('api.box.hide');
        return this;
    }
    async load() {
        this.init().catch((reason) => this.logger.debug(reason));
        this.container.globalThis.olark?.('api.box.show');
        return this;
    }
}

const MESSAGE_ACTION_APPLY_DISCOUNT = 'thn_apply_discount';
const MESSAGE_ACTION_DISMISS = 'thn_dismiss';
const MESSAGE_ACTION_ENGAGE = 'thn_engage';
const MESSAGE_ACTION_NO_ACTION = 'thn_no_action';
const MESSAGE_ACTION_GENERIC_LINK_CLICK = 'thn_generic_link_click';
const MESSAGE_ACTION_LOGIN = 'thn_login';
const MESSAGE_ACTION_OPEN_BE = 'thn_open_be';
const MESSAGE_ACTION_OPEN_URI = 'thn_open_uri';
const MESSAGE_ACTION_SEND_ACTIVITY = 'thn_send_activity';
const MESSAGE_ACTION_SEND_FORM = 'thn_send_form';
const MESSAGE_ACTION_SEND_SAVE_SEARCH = 'thn_send_save_search';
const MESSAGE_ACTION_SEND_SITE_CONTACT = 'thn_send_site_contact';
const MESSAGE_ACTION_SEND_STATUS = 'thn_send_status';
const MESSAGE_ACTION_SEND_SUBSCRIBE = 'thn_send_subscribe';
const MESSAGE_ACTION_NATIVE_SHOW_INLINER = 'thn_native_show_inliner';
const MESSAGE_ACTION_NATIVE_DESTROY_INLINER = 'thn_native_destroy_inliner';
const RULES_FAIL_ICON = '✖';
const RULES_FAIL_TEXT = 'fail';
const RULES_FAIL_MSG = `${RULES_FAIL_ICON} ${RULES_FAIL_TEXT}`;
const RULES_PASS_ICON = '✔';
const RULES_PASS_TEXT = 'pass';
const RULES_PASS_MSG = `${RULES_PASS_ICON} ${RULES_PASS_TEXT}`;
const CSS_PREFIX = 'thn--';
const NO_CHILD_ELEMENTS = [
    // Elements that silently hide childs
    'AREA', 'BASE', 'BR', 'COL', 'EMBED', 'HR', 'IMG', 'INPUT', 'LINK', 'META', 'PARAM', 'SOURCE', 'TRACK', 'WBR',
    // Elements with restricted content
    'TEXTAREA', 'SCRIPT', 'STYLE', 'TITLE', 'IFRAME',
];

const formatReturn = (unknownResult) => {
    if (isString(unknownResult)) {
        return {
            promocode: unknownResult,
            promocodeType: Object.values(DiscountCodeKind$1)[0],
        };
    }
    return unknownResult;
};
/**
 * Get the promocode in use.
 */
function getPromocode(parseUrlParameter$1 = parseUrlParameter) {
    let promocode = '';
    let promocodeType = '';
    const { globalState, globalThis, callEngine, } = this.container;
    // first try to get the promocode using globalState.promocodeVars
    if (!empty(globalState.promocodeVars)) {
        Object.values(DiscountCodeKind$1).some((type) => {
            if (globalState.promocodeVars[type]) {
                globalState.promocodeVars[type].some((promoVar) => {
                    // first search on the querystring
                    let value = parseUrlParameter$1(promoVar);
                    // then search on the DOM
                    // if the promocode_variable represents an input id/name/class
                    // but not if it represents a function
                    if (!value && promoVar.slice(-2) !== '()') {
                        const input = ['.', '#', '['].includes(promoVar.substr(0, 1))
                            ? `input[type=text]${promoVar}, ${promoVar} input[type=text]`
                            : `input[name="${promoVar}"], input[id="${promoVar}"][type=text]`;
                        const el = globalThis.document.querySelector(input);
                        if (el) {
                            value = el.value;
                        }
                    }
                    // finally, if found
                    if (value) {
                        promocodeType = type;
                        promocode = value;
                        return true; // break
                    }
                    return false;
                });
                // If found a promocode, stop searching
                if (promocode) {
                    return true; // break
                }
            }
            return false;
        });
    }
    // This is what we have detected "generically"
    const context = {
        promocode,
        promocodeType,
    };
    // Let's call the engine, which has a much more deep expertise on the page.
    // Note we pass the "generically" detected promocode to the engine, so It
    // gains knowledge of what the generic detection has been.
    const promocodeFromEngine = callEngine.call(this, 'getPromocode', context);
    if (isString(promocodeFromEngine)) {
        // When the value of the promocode matches
        // since the engine didn't tell us the type
        // we just return the generic detection
        if (context.promocode === promocodeFromEngine) {
            return formatReturn(context);
        }
        // When the value of the engine detected promocode does not
        // match the generic detection, then we can't assume the generic type
        return formatReturn({
            promocode: promocodeFromEngine,
            promocodeType: Object.values(DiscountCodeKind$1)[0],
        });
    }
    if (isPlainObject(promocodeFromEngine)
        && isString(promocodeFromEngine.promocode)) {
        // When the value of the promocode matches
        // and the engine does not tell us the type
        if (context.promocode === promocodeFromEngine.promocode
            && empty(promocodeFromEngine.promocodeType)) {
            return formatReturn(context);
        }
        // When the value of the engine detected promocode does not
        // match the generic detection, then we can't assume the generic type
        return formatReturn({
            promocode: promocodeFromEngine.promocode,
            promocodeType: promocodeFromEngine.promocodeType
                || Object.values(DiscountCodeKind$1)[0],
        });
    }
    // If we reach this point, the engine has not detected anything useful
    return formatReturn(context);
}

/**
 * Iterates over the tools of a list (or the widget tools)
 * and performs reset on each tool.
 *
 * If a `predicate` is passed, then the reset is performed
 * only for tools on which the predicate returns truthy.
 * The predicate is invoked with two arguments: (value, key).
 *
 * @param {array} [tools] The list of tools.
 * @param {function} [predicate=identity] The function invoked per item.
 * @returns {mixed} Returns the processed list, or the widget.
 */
function resetToolsBy(tools, predicate = identity) {
    (tools || (this.data && this.data.tools) || [])
        .filter(ary(predicate, 2))
        .forEach((tool) => tool.resetState());
    return tools || this;
}

// By limiting the arity of reset_tools_by to one
// we effectively convert it to a reset_tools for all
// without a predicate that filters the tools list.
const _resetTools = /* #__PURE__ */ ary(resetToolsBy, 1);
function resetTools(...args) {
    return _resetTools.apply(this, args);
}

const cantApplyErrorMsg = 'Can\'t apply discount code';
function createApplyDiscountHandler(action, services) {
    const { createSearchReplay, logger } = services;
    const { discountCode: discount } = action;
    const canApplyDiscount = !!createSearchReplay({ discount })?.replayFn;
    if (!canApplyDiscount) {
        throw new Error(cantApplyErrorMsg);
    }
    return async () => {
        const replayResult = createSearchReplay({ discount });
        if (!replayResult?.replayFn) {
            logger.warn(`${cantApplyErrorMsg} (jit context)`, action);
            return false;
        }
        try {
            await replayResult.replayFn();
            return true;
        }
        catch (error) {
            logger.warn('Failure to apply discount', error);
            return false;
        }
    };
}

function createOpenBookingEngineHandler(commonData, services) {
    const replayReturn = services.createSearchReplay(commonData.replayData, { extraParams: commonData.extraParams });
    if (!replayReturn?.replayFn) {
        return null;
    }
    return async () => {
        try {
            await replayReturn?.replayFn?.();
            return true;
        }
        catch (error) {
            services.logger.debug('Error executing replayFn:', error);
            return false;
        }
    };
}

const buildUrlFromHash = (hash, baseUrl) => {
    const currentUrl = new URL(baseUrl);
    currentUrl.hash = hash;
    return currentUrl.toString();
};
const addExtraParamsToUrl = (url, extraParams) => {
    const urlObj = new URL(url);
    extraParams.forEach(([key, value]) => {
        if (value !== undefined) {
            urlObj.searchParams.set(key, value);
        }
    });
    return urlObj.toString();
};
function createOpenUriHandler(action, services) {
    return async () => {
        const { globalThis, openLink, widget } = services;
        const { extraParams, inheritUrlParams, newTab, uri: uriOrHash, uriSchema, } = action;
        const isHash = uriOrHash.startsWith('#');
        let uri = isHash ? buildUrlFromHash(uriOrHash, globalThis.location.href) : uriOrHash;
        uri = extraParams ? addExtraParamsToUrl(uri, extraParams) : uri;
        const openLinkOptions = {
            preserveQueryParams: inheritUrlParams,
            uriSchema,
        };
        const windowName = newTab ? '_blank' : '_self';
        const args = [uri, windowName, openLinkOptions];
        const argsWithInheritedParams = [appendUrlParams(uri, String(globalThis.location)), windowName, openLinkOptions];
        // If the received uri is a hash, open the link in the current window
        if (isHash) {
            openLink(...args);
            return true;
        }
        // First try to open the link in the parent window
        const bubbled = widget.bubble({
            action: 'thn_exec',
            payload: {
                func: 'openLink',
                args: inheritUrlParams ? argsWithInheritedParams : args,
            },
        });
        // Second, if not successfully bubbled, try to open the link here
        if (!bubbled) {
            openLink(...args);
        }
        return true;
    };
}

const debugPrefix$2 = 'createHandler()';
const createHandler = (builder, services) => {
    const handler = async (formData) => {
        const { fetch, endpoint, logger, } = services;
        logger?.debug(debugPrefix$2, 'view data', formData);
        const body = builder(formData);
        const options = {
            body,
        };
        logger?.debug(debugPrefix$2, 'request', body);
        const response = await fetch(endpoint, options);
        logger?.debug(debugPrefix$2, 'response', response);
        return response.ok;
    };
    return handler;
};

const endpoint$2 = '/agent/tools/email-capture';
const createSendSubscribeHandler = (commonData, services) => {
    const { moduleId, contextToken, tool, } = commonData;
    const bodyBuilder = (data) => {
        const { emailAddress: address, terms } = data;
        const body = {
            contextToken,
            emailCapture: {
                id: moduleId,
                toolId: tool?.getId(),
                toolVersion: tool?.getVersionId(),
                address,
                terms,
            },
        };
        return body;
    };
    const handlerServices = { ...services, endpoint: endpoint$2 };
    const handler = createHandler(bodyBuilder, handlerServices);
    return handler;
};

const endpoint$1 = '/agent/tools/form';
const createSendFormHandler = (commonData, services) => {
    const { moduleId, contextToken, tool, } = commonData;
    const bodyBuilder = (data) => {
        const { formFields: fields, terms } = data;
        const body = {
            contextToken,
            form: {
                id: moduleId,
                toolId: tool?.getId(),
                toolVersion: tool?.getVersionId(),
                fields,
                terms,
            },
        };
        return body;
    };
    const handlerServices = { ...services, endpoint: endpoint$1 };
    const handler = createHandler(bodyBuilder, handlerServices);
    return handler;
};

/**
 * Formats a search entry price according to the "priceNight" config value of this given entry.
 *
 * @param {object} options
 * @param {object} options.entry - The search entry.
 * @return {object}
 */
function formatPricePerFrequency({ entry }) {
    const { adults, dateBegin, dateEnd, currency, guests, price, roomsDispo, } = entry.data.actual.search;
    const { widgetName, } = entry.data.actual.context;
    const { priceNight, priceRoom, } = entry.data.actual.config;
    const nights = daysBetween(dateBegin, dateEnd);
    // Remember PW and PWP `price` properties have different meaning.
    // PWP.price: contains the price per stay (total including flights)
    // PW.price: contains the price per night (of all rooms and guests!)
    const formats = {};
    if (!price) {
        return {
            currency,
            priceNight,
            price: 0,
        };
    }
    formats[PriceNightConfig.PerStay] = widgetName === 'package' ? price : price * nights;
    formats[PriceNightConfig.PerNight] = widgetName === 'package' ? price / nights : price;
    // "per person" is total stay / per person
    if (guests) {
        formats[PriceNightConfig.PerPerson] = formats[PriceNightConfig.PerStay] / guests;
    }
    // "per adult" is total stay / per adult
    if (adults) {
        formats[PriceNightConfig.PerAdult] = formats[PriceNightConfig.PerStay] / adults;
    }
    const result = {
        currency,
        priceNight,
        price: formats[priceNight] || 0,
    };
    // "priceRoom" is a special configuration.
    // Default value 1/true means that "price" contains the TOTAL (all rooms) price
    // Special value 0/false means that "price" contains the total PER ROOM price
    // thus in this later case we must multiply by the amount of rooms
    // to obtain the real total
    // WARN: do not trust falsyness here
    if (!priceRoom && roomsDispo) {
        result.price *= roomsDispo.length;
    }
    return result;
}

const endpoint = '/agent/save-search';
const createSendSaveSearchHandler = (commonData, services) => {
    const { contextToken, searchEntry: entry, tool, } = commonData;
    if (!entry) {
        return async () => false;
    }
    const bodyBuilder = (formData) => {
        const { createSearchReplay } = services;
        let processData;
        if ('emailAddress' in formData) { // ActionHandlerSendSaveSearch
            processData = {
                address: formData.emailAddress,
                terms: formData.terms,
            };
        }
        else { // ActionHandlerClassicSendSaveSearch
            processData = {
                address: formData.email,
                terms: [{
                        termId: null,
                        isChecked: !empty(formData.terms_accepted),
                    }],
            };
        }
        const hasResponse = !empty(entry.data?.response);
        const responseDataPrice = hasResponse && entry.data.response?.priceData?.formats?.shownNumeric;
        const price = responseDataPrice || formatPricePerFrequency({ entry }).price;
        const searchId = hasResponse ? entry.data?.request?.data?.params?.search_id : undefined;
        const priceNight = entry.data?.actual?.config?.priceNight;
        const { currency, dateBegin, dateEnd, children, adults, guests, } = entry.data.actual.search;
        const rooms = entry.data?.actual?.search?.roomsDispo?.length;
        const directUrl = entry?.data?.actual?.context?.saveSearchBaseUrl;
        const url = createSearchReplay({ search: entry.data.actual.search }, { baseUrl: directUrl })?.replayUrl
            || directUrl
            || globalThis.location?.href?.toString()
            || '';
        const body = {
            contextToken,
            saveSearch: {
                ...processData,
                searchId,
                url,
                toolId: tool?.getId(),
                toolVersion: tool?.getVersionId(),
                toolType: tool?.getContext().widgetTypeId || null,
                currency,
                dateBegin,
                dateEnd,
                price,
                priceNight,
                rooms,
                children,
                adults,
                guests,
            },
        };
        return body;
    };
    const handlerServices = { ...services, endpoint };
    const handler = createHandler(bodyBuilder, handlerServices);
    return handler;
};

var LoginEndpointPath = /*@__PURE__*/(function (LoginEndpointPath = {}) {
    LoginEndpointPath["UserSignin"] = "/agent/users/login-or-create";
    LoginEndpointPath["UserSignup"] = "/agent/users/login-or-create";
    LoginEndpointPath["UserOtpValidation"] = "/agent/users/otp/validate";
    LoginEndpointPath["UserOtpSend"] = "/agent/users/otp/resend";
    return LoginEndpointPath;
})(LoginEndpointPath);

const debugPrefix$1 = 'loginHandler()';
const isNullBodyStatus = (status) => {
    const nullBodyStatuses = [101, 103, 204, 205, 304];
    return nullBodyStatuses.includes(status);
};
const signupUser = async (options, services, sharedData) => {
    const { fetch, logger } = services;
    // eslint-disable-next-line no-param-reassign
    sharedData.userId = undefined; // Reset sharedData
    const response = await fetch(LoginEndpointPath.UserSignup, options);
    const loginResponseData = isNullBodyStatus(response.status) ? null : await response.json();
    logger?.debug(debugPrefix$1, 'Response data', loginResponseData);
    // User already exists
    if (response.status === 200) {
        // eslint-disable-next-line no-param-reassign
        sharedData.userId = loginResponseData?.data?.userId;
        return {
            next: 'validation',
            ok: true,
        };
    }
    // User created
    if (response.status === 201) {
        // eslint-disable-next-line no-param-reassign
        sharedData.userId = loginResponseData?.data?.userId;
        return {
            ok: true,
        };
    }
    // T&C not accepted, user not registered, or other
    if (response.status === 400) {
        return {
            next: 'signup',
            ok: true,
        };
    }
    // Other not expected error
    return {
        ok: false,
    };
};
const signinUser = async (options, services, sharedData) => {
    const { fetch, logger } = services;
    // eslint-disable-next-line no-param-reassign
    sharedData.userId = undefined; // Reset sharedData
    const response = await fetch(LoginEndpointPath.UserSignin, options);
    const loginResponseData = isNullBodyStatus(response.status) ? null : await response.json();
    logger?.debug(debugPrefix$1, 'Response data', loginResponseData);
    // User exists
    if (response.status === 200) {
        // eslint-disable-next-line no-param-reassign
        sharedData.userId = loginResponseData?.data?.userId;
        return {
            next: 'validation',
            ok: true,
        };
    }
    // User registered globally, but not on the current property
    if (response.status === 201) {
        // eslint-disable-next-line no-param-reassign
        sharedData.userId = loginResponseData?.data?.userId;
        return {
            ok: true,
        };
    }
    // T&C not accepted, user not registered, or other
    if (response.status === 400) {
        return {
            next: 'signup',
            ok: true,
        };
    }
    // Other not expected error
    return {
        ok: false,
    };
};
const hasUserId = (body) => 'userId' in body && !!body.userId;
const validateUser = async (options, services) => {
    if (!hasUserId(options.body)) {
        return { ok: false };
    }
    const { fetch, logger } = services;
    const response = await fetch(LoginEndpointPath.UserOtpValidation, options);
    const loginResponseData = isNullBodyStatus(response.status) ? null : await response.json();
    logger?.debug(debugPrefix$1, 'Response data', loginResponseData);
    // Code is valid
    if (response.ok) {
        return {
            ok: true,
        };
    }
    // Invalid code or other
    return {
        ok: false,
    };
};
const resendValidationCode = async (options, services) => {
    const { fetch, logger } = services;
    if (!hasUserId(options.body)) {
        return { ok: false };
    }
    const response = await fetch(LoginEndpointPath.UserOtpSend, options);
    const loginResponseData = isNullBodyStatus(response.status) ? null : await response.json();
    logger?.debug(debugPrefix$1, 'Response data', loginResponseData);
    // Code resent successfully
    if (response.ok) {
        return {
            next: 'validation',
            ok: true,
        };
    }
    // Invalid code or other
    return {
        ok: false,
    };
};
const createLoginHandler = (commonData, services) => {
    const { contextToken } = commonData;
    const { logger } = services;
    const sharedData = {};
    const handler = async (formData) => {
        logger?.debug(debugPrefix$1, 'input:', formData);
        if (formData.action === 'signup') {
            const body = {
                contextToken,
                email: formData.emailAddress,
                terms: formData.terms,
            };
            return signupUser({ body }, services, sharedData);
        }
        if (formData.action === 'signin') {
            const body = {
                contextToken,
                email: formData.emailAddress,
            };
            return signinUser({ body }, services, sharedData);
        }
        if (formData.action === 'validation') {
            const body = {
                contextToken,
                code: formData.code,
                userId: sharedData.userId,
            };
            return validateUser({ body }, services);
        }
        if (formData.action === 'resend') {
            const body = {
                contextToken,
                userId: sharedData.userId,
            };
            return resendValidationCode({ body }, services);
        }
        return { ok: false }; // Unrecognized action
    };
    return handler;
};

function once(fn) {
    return function wrappedOnce() {
        let result;
        if (isFunction(fn)) {
            // @ts-ignore
            // eslint-disable-next-line prefer-rest-params,@typescript-eslint/no-unsafe-assignment
            result = fn.apply(this, arguments);
        }
        if (fn) {
            // @ts-ignore
            // eslint-disable-next-line no-param-reassign
            fn = undefined;
        }
        return result;
    };
}

function __variableDynamicImportRuntime0__(path) {
  switch (path) {
    case './views/inliner-native.ts': return import('./chunk-inliner-native.js');
    case './views/inliner-pcomponents.ts': return import('./chunk-inliner-pcomponents.js');
    case './views/kitt-dummy.ts': return import('./chunk-kitt-dummy.js');
    case './views/kitt-pcomponents.ts': return import('./chunk-kitt-pcomponents.js');
    case './views/note-pcomponents.ts': return import('./chunk-note-pcomponents.js');
    case './views/popup-pcomponents.ts': return import('./chunk-popup-pcomponents.js');
    case './views/price-ipcomponents.ts': return import('./chunk-price-ipcomponents.js');
    case './views/price-pcomponents.ts': return import('./chunk-price-pcomponents.js');
    case './views/review-ipcomponents.ts': return import('./chunk-review-ipcomponents.js');
    case './views/review-pcomponents.ts': return import('./chunk-review-pcomponents.js');
    default: return new Promise$1(function(resolve, reject) {
      (typeof queueMicrotask === 'function' ? queueMicrotask : setTimeout)(
        reject.bind(null, new Error("Unknown variable dynamic import: " + path))
      );
    })
   }
 }
class WidgetWithView extends Widget {
    // eslint-disable-next-line class-methods-use-this
    get __default() {
        return {
            ...super.__default,
            mirrorRtlLang: 1,
        };
    }
    get __computed() {
        return {
            ...super.__computed,
            isRightAlign: decoratePropertyDescriptor({
                get: () => !!(!empty(this.data.mirrorRtlLang)
                    && this.container.globalState.rightAlignLanguages?.includes(this.container.globalState.language ?? 'en')),
            }),
            defaultZIndex: decoratePropertyDescriptor({
                get: () => (this.container.globalState.media?.name === 'mobile' ? this.data.mobileDefaultZIndex : this.data.desktopDefaultZIndex),
            }),
        };
    }
    view;
    /**
     * Load the current view.
     *
     * Should be called and awaited each time the
     * view could change. That situation differs per Widget.
     */
    async loadView(formatFamily) {
        const name = `${this.data.viewCategory || this.data.name}-${formatFamily || this.data.formatFamily || ''}`;
        // The context for the view instantiation may be overwritten by a given engine
        // For instance, in `engine.inlinerGetContext` we can provide another window/document
        const extraContext = this.container.callEngine(`${this.data.name}GetContext`) || {};
        const context = {
            document: this.container.globalThis.document,
            thn: this.container.globalThis.thn,
            widget: this,
            window: this.container.globalThis,
            ...extraContext,
        };
        const contextHash = `_${Object.keys(extraContext).join(',')}`;
        // Must load a new view
        const shouldInstantiate = !this.view
            || this.view._name !== name
            || this.view._contextHash !== contextHash;
        if (!shouldInstantiate) {
            return this;
        }
        // Destroy the previous view
        this.callView('destroy');
        // If the JS version of the view does not exist, then it must be a TS view
        const viewModule = await __variableDynamicImportRuntime0__(`./views/${name}.ts`);
        const { factory } = viewModule;
        this.view = factory(context);
        this.view._name = name;
        this.view._context = context;
        this.view._contextHash = contextHash;
        return this;
    }
    isVisible(checkVisibleAttribute = true) {
        // @ts-ignore TODO declarations
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        const el = this.data.el || this?.view?.data?.el;
        return checkVisibleAttribute
            ? (el?.getAttribute('data-thn-visible') === '1')
            : !!(el);
    }
    /**
     * Calls a view-adapter function as a widget method.
     *
     * @param method - The name of the view-adapter function.
     * @param args - Argument values to be passed to the function.
     */
    callView(method, ...args) {
        return invoke(this, `view.${method}`, ...args);
    }
}

function addPixelsToElement(pixelsToAdd, element, computedStyle) {
    // increase z-index to avoid stacking issues
    const currentZindex = computedStyle.zIndex === 'auto' ? 0 : Number(computedStyle.zIndex);
    // eslint-disable-next-line no-param-reassign
    element.style.zIndex = (currentZindex + 1).toString();
    const matrix = computedStyle.transform;
    // if there is no transform matrix, just add the pixels to translateY
    if (matrix === 'none') {
        // eslint-disable-next-line no-param-reassign
        element.style.transform = `translateY(${pixelsToAdd}px)`;
        return;
    }
    // Extract the translateY value from the matrix
    const matrixValues = matrix.match(/matrix\((.+)\)/)?.[1].split(', ');
    if (!matrixValues) {
        return;
    }
    const actualTranslateY = parseFloat(matrixValues[5]); // The translateY value is in the 6th position
    // Calculate the new translateY value
    const newTranslateY = actualTranslateY + pixelsToAdd;
    // Apply the new translateY value maintaining the other values of the matrix
    // eslint-disable-next-line no-param-reassign
    element.style.transform = `matrix(${matrixValues[0]}, ${matrixValues[1]}, ${matrixValues[2]}, ${matrixValues[3]}, ${matrixValues[4]}, ${newTranslateY})`;
}
function shouldTranslateElement(element) {
    return element instanceof HTMLElement;
}
function isElementPositionFixedOrSticky(el, getComputedStyle) {
    if (!isVisible(el)) {
        return true;
    }
    const computedStyle = getComputedStyle(el);
    return ['fixed', 'sticky'].includes(computedStyle.position)
        || (!!el.children.length && Array.from(el.children).every(child => isElementPositionFixedOrSticky(child, getComputedStyle)));
}
function applyTranslationStyles(element, config, elementsMap, computedStyle) {
    // store the original styles
    elementsMap.set(element, {
        transform: element.style.transform,
        transition: element.style.transition,
        zIndex: element.style.zIndex,
    });
    // apply the translation styles
    addPixelsToElement(config.y, element, computedStyle);
    // eslint-disable-next-line no-param-reassign
    element.style.transition = 'transform 0.3s ease';
}
const debugPrefix = 'translateDocumentBody()';
function createTranslateDocumentBody(services) {
    const { document, globalThis, logger } = services;
    /**
     * Translates the body of the document by the specified amount of pixels.
     * It returns a function that will reset the original styles
     * @param config.y - The amount of pixels to translate the body
     */
    return function translateDocumentBody(config) {
        logger.debug(debugPrefix, 'start');
        const rootElements = document.body.children;
        const elementsMap = new Map();
        Array.from(rootElements).forEach((element) => {
            if (!shouldTranslateElement(element)) {
                return;
            }
            const computedStyles = globalThis.getComputedStyle(element);
            if (isElementPositionFixedOrSticky(element, globalThis.getComputedStyle)) {
                // In case of fixed or sticky elements, we do not apply translation BUT we should increase the z-index
                // to avoid stacking issues with other elements that are translated
                elementsMap.set(element, {
                    transform: element.style.transform,
                    transition: element.style.transition,
                    zIndex: element.style.zIndex,
                });
                const currentZindex = computedStyles.zIndex === 'auto' ? 0 : Number(computedStyles.zIndex);
                // eslint-disable-next-line no-param-reassign
                element.style.zIndex = (currentZindex + 1).toString();
                return;
            }
            applyTranslationStyles(element, config, elementsMap, computedStyles);
        });
        logger.debug(debugPrefix, 'Translated elements:', elementsMap);
        return function untranslate() {
            if (!elementsMap.size) {
                logger.debug(debugPrefix, 'Unable to untranslate again');
                return;
            }
            logger.debug(debugPrefix, 'Start untranslating');
            elementsMap.forEach((originalStyles, element) => {
                // eslint-disable-next-line no-param-reassign
                element.style.transform = originalStyles.transform;
                // eslint-disable-next-line no-param-reassign
                element.style.transition = originalStyles.transition;
                // eslint-disable-next-line no-param-reassign
                element.style.zIndex = originalStyles.zIndex;
            });
            elementsMap.clear();
        };
    };
}

/* eslint-disable @typescript-eslint/unbound-method */
class WidgetWithTools extends WidgetWithView {
    resetTools = resetTools.bind(this);
    rulesEvaluator;
    rulesCollection = index;
    currentProcessId;
    onProcessAbort = generateCallbackQueue();
    actionToHandler = {
        [MESSAGE_ACTION_APPLY_DISCOUNT]: AgentActionKind.ApplyDiscount,
        [MESSAGE_ACTION_DISMISS]: AgentActionKind.Dismiss,
        [MESSAGE_ACTION_ENGAGE]: AgentActionKind.Engage,
        [MESSAGE_ACTION_NO_ACTION]: AgentActionKind.NoAction,
        [MESSAGE_ACTION_GENERIC_LINK_CLICK]: AgentActionKind.GenericLinkClick,
        [MESSAGE_ACTION_LOGIN]: AgentActionKind.Login,
        [MESSAGE_ACTION_OPEN_BE]: AgentActionKind.OpenBookingEngine,
        [MESSAGE_ACTION_OPEN_URI]: AgentActionKind.OpenUri,
        [MESSAGE_ACTION_SEND_FORM]: AgentActionKind.SendForm,
        [MESSAGE_ACTION_SEND_SAVE_SEARCH]: AgentActionKind.SendSaveSearch,
        [MESSAGE_ACTION_SEND_SUBSCRIBE]: AgentActionKind.SendSubscribe,
        [MESSAGE_ACTION_SEND_ACTIVITY]: this.sendActivity.bind(this),
        [MESSAGE_ACTION_SEND_STATUS]: this.sendStatus.bind(this),
    };
    // eslint-disable-next-line class-methods-use-this
    get __default() {
        return {
            ...super.__default,
            tools: [],
        };
    }
    /**
     * Make an object that bundles all the services and data
     * needed for the UI module.
     */
    async bundleForUi(context) {
        const tool = await (context.tool.clone()).onReady();
        const toolContext = tool.getContext();
        const { globalState } = this.container;
        const bundle = {
            actions: [],
            country: toolContext.visitorCountryCode || globalState.country,
            device: toolContext.device || globalState.media?.name,
            language: toolContext.languageCode || globalState.language,
            overrides: collectionClone(globalState.overrides || {}),
            tool,
            logger: this.logger,
            zIndex: (this.container.getSetting?.(`${this.data.name}_z_index`) || this.data.defaultZIndex || ''),
            widgetName: this.data.name,
        };
        const searchEntry = this.container.getVisitorLastComparison({ acceptWithoutAvailability: false });
        const contextToken = toolContext.contextToken || globalState.contextToken;
        const { fetch, createSearchReplay } = this.container;
        const { logger } = this;
        let hasEngaged = false;
        let hasDismissed = false;
        const dismissHandler = async () => {
            if (hasEngaged || hasDismissed) {
                return hasDismissed;
            }
            hasDismissed = await (toolContext.isDelegated
                ? this.createDelegateeHandler(MESSAGE_ACTION_DISMISS, tool)()
                : this.sendActivity(tool, { kind: AgentActionKind.Dismiss }));
            return hasDismissed;
        };
        const engageHandler = async () => {
            if (hasEngaged || hasDismissed) {
                return hasEngaged;
            }
            hasEngaged = await (toolContext.isDelegated
                ? this.createDelegateeHandler(MESSAGE_ACTION_ENGAGE, tool)()
                : this.sendActivity(tool, { kind: AgentActionKind.Engage }));
            return hasEngaged;
        };
        const withExtraHandlers = (mainHandler, ...extraHandlers) => (async (...args) => {
            for (const extraHandler of extraHandlers) {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,no-await-in-loop
                await extraHandler(...args);
            }
            // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-return
            return mainHandler(...args);
        });
        bundle.actions = tool.getActions().map((action) => {
            let handler;
            const { moduleId } = action;
            const commonData = {
                moduleId: moduleId || '',
                contextToken,
                searchEntry,
                tool,
            };
            switch (action.kind) {
                case AgentActionKind.ApplyDiscount:
                    if (toolContext.isDelegated) {
                        // If delegated, we inspect the delegated context to see if application is possible
                        if (toolContext.canApplyDiscount) {
                            // The parent script always commands the child to apply the discount
                            const applyDiscountHandler = this.createDelegateeHandler(MESSAGE_ACTION_APPLY_DISCOUNT, tool, action);
                            // The definitive handler simulates that Engage has been done
                            handler = withExtraHandlers(applyDiscountHandler, () => { hasEngaged = true; });
                        }
                    }
                    else {
                        // We only create a handler if we are sure we can apply
                        try {
                            const applyDiscountHandler = once(createApplyDiscountHandler(action, {
                                createSearchReplay,
                                logger,
                            }));
                            // The definitive handler includes a call to the next-gen Engage
                            handler = withExtraHandlers(applyDiscountHandler, engageHandler);
                        }
                        catch { /* empty */ }
                    }
                    break;
                case AgentActionKind.Dismiss:
                    handler = dismissHandler;
                    break;
                case AgentActionKind.Engage:
                    // Note: engageHandler is aware of delegation state
                    handler = engageHandler;
                    break;
                case AgentActionKind.NoAction:
                    if (toolContext.isDelegated) {
                        const noActionHandler = this.createDelegateeHandler(MESSAGE_ACTION_NO_ACTION, tool, action);
                        // The definitive handler simulates that Engage has been done
                        handler = withExtraHandlers(noActionHandler, () => { hasEngaged = true; });
                    }
                    else {
                        handler = engageHandler;
                    }
                    break;
                case AgentActionKind.Fallback:
                    handler = async () => true;
                    break;
                case AgentActionKind.GenericLinkClick:
                    if (toolContext.isDelegated) {
                        const genericLinkHandler = this.createDelegateeHandler(MESSAGE_ACTION_GENERIC_LINK_CLICK, tool, action);
                        // The definitive handler simulates that Engage has been done
                        handler = withExtraHandlers(genericLinkHandler, () => { hasEngaged = true; });
                    }
                    else {
                        handler = engageHandler;
                    }
                    break;
                case AgentActionKind.Hide:
                    handler = this.onToolHide.bind(this, bundle.tool);
                    break;
                case AgentActionKind.OpenBookingEngine:
                    if (toolContext.isDelegated) {
                        const openBookingEngineHandler = this.createDelegateeHandler(MESSAGE_ACTION_OPEN_BE, bundle.tool, action);
                        // The definitive handler simulates that Engage has been done
                        handler = withExtraHandlers(openBookingEngineHandler, () => { hasEngaged = true; });
                    }
                    else {
                        const openBookingEngineServices = {
                            fetch, logger, createSearchReplay,
                        };
                        const { replayData, extraParams } = action;
                        // This condition should never be true since the `canOpenBe` rule should check that replayData exists.
                        if (!replayData) {
                            break;
                        }
                        const openBookingEngineHandler = createOpenBookingEngineHandler({ ...commonData, replayData, extraParams }, openBookingEngineServices);
                        if (openBookingEngineHandler) {
                            // The definitive handler includes a call to the next-gen Engage
                            handler = withExtraHandlers(openBookingEngineHandler, engageHandler);
                        }
                    }
                    break;
                case AgentActionKind.OpenUri:
                    if (toolContext.isDelegated) {
                        const openUriHandler = this.createDelegateeHandler(MESSAGE_ACTION_OPEN_URI, bundle.tool, action);
                        // The definitive handler simulates that Engage has been done
                        handler = withExtraHandlers(openUriHandler, () => { hasEngaged = true; });
                    }
                    else {
                        const openUriHandler = once(createOpenUriHandler(action, { globalThis: this.container.globalThis, openLink, widget: this }));
                        // The definitive handler includes a call to the next-gen Engage
                        handler = withExtraHandlers(openUriHandler, engageHandler);
                    }
                    break;
                case AgentActionKind.SendSaveSearch:
                    // Note It is not possible to arrive at this point of execution
                    // without a search entry existing, either in the current script or the child.
                    // Rule checking protects us.
                    if (toolContext.isDelegated) {
                        const sendSaveSearchHandler = this.createDelegateeHandler(MESSAGE_ACTION_SEND_SAVE_SEARCH, bundle.tool, action);
                        // The definitive handler simulates that Engage has been done
                        handler = withExtraHandlers(sendSaveSearchHandler, () => { hasEngaged = true; });
                    }
                    else {
                        const sendSaveSearchServices = {
                            fetch, logger, createSearchReplay,
                        };
                        const sendSaveSearchHandler = createSendSaveSearchHandler(commonData, sendSaveSearchServices);
                        // The definitive handler includes a call to the next-gen Engage
                        handler = withExtraHandlers(sendSaveSearchHandler, engageHandler);
                    }
                    break;
                case AgentActionKind.SendSubscribe:
                    if (toolContext.isDelegated) {
                        const sendSubscribeHandler = this.createDelegateeHandler(MESSAGE_ACTION_SEND_SUBSCRIBE, bundle.tool, action);
                        // The definitive handler simulates that Engage has been done
                        handler = withExtraHandlers(sendSubscribeHandler, () => { hasEngaged = true; });
                    }
                    else {
                        const sendSubscribeServices = {
                            fetch, logger,
                        };
                        const sendSubscribeHandler = createSendSubscribeHandler(commonData, sendSubscribeServices);
                        // The definitive handler includes a call to the next-gen Engage
                        handler = withExtraHandlers(sendSubscribeHandler, engageHandler);
                    }
                    break;
                case AgentActionKind.SendForm:
                    if (toolContext.isDelegated) {
                        const sendFormHandler = this.createDelegateeHandler(MESSAGE_ACTION_SEND_FORM, bundle.tool, action);
                        // The definitive handler simulates that Engage has been done
                        handler = withExtraHandlers(sendFormHandler, () => { hasEngaged = true; });
                    }
                    else {
                        const sendFormServices = {
                            fetch, logger,
                        };
                        const sendFormHandler = createSendFormHandler(commonData, sendFormServices);
                        // The definitive handler includes a call to the next-gen Engage
                        handler = withExtraHandlers(sendFormHandler, engageHandler);
                    }
                    break;
                case AgentActionKind.Show:
                    handler = this.onToolShow.bind(this, bundle.tool);
                    break;
                case AgentActionKind.Login: {
                    // TODO: Note this action can't be currently delegated because createDelegateeHandler is not complete
                    const instantLoginServices = {
                        fetch, logger,
                    };
                    const loginHandler = createLoginHandler(commonData, instantLoginServices);
                    // The definitive handler includes a call to the next-gen Engage
                    handler = withExtraHandlers(loginHandler, engageHandler);
                    break;
                }
                case AgentActionKind.TranslateDocumentBody: {
                    const translateDocumentBodyServices = {
                        // eslint-disable-next-line no-underscore-dangle
                        document: this.view._context.document, globalThis: this.container.globalThis, logger,
                    };
                    handler = createTranslateDocumentBody(translateDocumentBodyServices);
                    break;
                }
            }
            if (handler && !toolContext.isDelegated && action.shouldSendActivity) {
                handler = this.withSendActivity(handler, action, tool);
            }
            return { ...action, handler };
        });
        return bundle;
    }
    /**
     * Register any application services/requirements.
     */
    register() {
        const debugPrefix = 'register()';
        // Typically registration should happen just once
        if (this.data.registered) {
            return this;
        }
        super.register();
        // Register a listener for "visitor tools" set,
        // which is the event triggered once a page changes and
        // the tools data has been set for that page.
        this.container.bus.on([
            'thn:visitor-tools.set',
            'thn:visitor-oraculo.set',
            'thn:demand',
            'thn:disparity',
            'thn:duetto',
            'thn:exit',
            'thn:idle',
            'thn:visitor-tools.loaded',
            'thn:scroll',
        ], () => this.process());
        let startServerEventsListener;
        this.container.bus.on('thn:page.unload', () => {
            this.unsetTools();
            this.destroy();
            this.onProcessAbort();
            startServerEventsListener?.cancel();
        });
        this.container.bus.on('thn:visitor-tools.set', () => {
            const isTargetPage = this.container.price?.isTargetPage?.() || this.container.package?.isTargetPage?.();
            if (!isTargetPage) {
                return;
            }
            const requiresServerEventsListener = this.data.tools.some((tool) => {
                const rulesConfig = tool.getRulesConfig();
                if (rulesConfig[RulesConfigProp.VisitorOraculoScore]?.length) {
                    return true;
                }
                const rulesConfigStayDisparities = rulesConfig[RulesConfigProp.StayDisparities];
                const hasDisparitiesRules = rulesConfigStayDisparities?.length;
                if (hasDisparitiesRules) {
                    return true;
                }
                const rulesConfigDuetto = rulesConfig[RulesConfigProp.StayDuettoDemand];
                const hasDuettoRules = rulesConfigDuetto?.length;
                if (hasDuettoRules) {
                    return true;
                }
                const rulesConfigDemand = rulesConfig[RulesConfigProp.StayDemand];
                const hasDemandsRules = rulesConfigDemand?.length;
                return hasDemandsRules;
            });
            if (!requiresServerEventsListener) {
                return;
            }
            startServerEventsListener = cancellable((serverEventsListener) => { serverEventsListener.listen(); });
            this.container.async.serverEventsListener
                .then((serverEventsListener) => startServerEventsListener(serverEventsListener))
                .catch((error) => this.logger.error('Error starting server events listener', error));
        });
        // Register a listener for PW data changes.
        this.container.bus.on([
            'thn:package.set',
            'thn:price.set',
        ], ({ changed, entry, firstTime }) => {
            const hasDifferentData = changed || firstTime;
            // Nothing to be done if the PW set data is the same
            // OR if the data set comes from a child script
            if (!hasDifferentData || entry.state.delegated) {
                return;
            }
            return this.process();
        });
        // Function to be called when a message from the companion agent is received. Will NOT apply to inliners
        this.container.bus.on('window:message', this.onCompanionMessageActionHandler.bind(this));
        this.container.bus.on('window:message', async (event) => {
            const { action, tool, widgetName, args, } = event.data || {};
            if (!action || this.data.name !== widgetName)
                return;
            switch (action) {
                case 'destroy_widget':
                    this.destroy(...args);
                    return;
                case 'update_delegated_tool': {
                    const updatedDelegatedTool = this.format(tool);
                    const foundTool = this.data.tools.find((t) => t.getId() === updatedDelegatedTool.getId());
                    if (foundTool) {
                        foundTool.updateState(updatedDelegatedTool.getState());
                    }
                    return;
                }
                case 'load_delegated_tool': {
                    this.logger.trace(debugPrefix, 'Handled event', event);
                    const delegatedTool = this.format(tool);
                    const widgetNameTargets = [WidgetsList.Layer, WidgetsList.Exit];
                    if (widgetNameTargets.includes(widgetName)) {
                        this.destroy();
                    }
                    await this.load({ tool: delegatedTool });
                    // eslint-disable-next-line no-useless-return
                    return;
                }
            }
        });
        this.container.bus.on('thn:tool.updated', (tool) => {
            if (tool.getContext().isDelegated && tool.getContext().widgetName === this.data.name) {
                this.transmit({
                    action: 'update_delegated_tool',
                    widgetName: this.data.name,
                    tool: JSON.parse(stringify(tool)),
                });
            }
        });
        const debouncedProcess = debounce(() => this.process(), 1000);
        this.container.bus.on('dataLayer:push', (arg0) => {
            const message = arg0.message;
            if (!message._isThn) {
                return debouncedProcess();
            }
        });
        return this;
    }
    createToolContext() {
        const { getSetting, globalState, isUserLogged } = this.container;
        const { language = 'en' } = globalState;
        const kebabLanguageCode = language?.replace(/_/g, '-');
        return {
            chainId: globalState.chainId ? String(globalState.chainId) : '',
            // This is a copy of the current contextToken to be used when sending tool status
            contextToken: globalState.contextToken,
            currencyCode: this.container.price?.data?.currency,
            device: globalState.media?.name,
            hotelId: globalState.hotelId,
            isUserLogged: isUserLogged(),
            kebabLanguageCode,
            languageCode: language,
            pageId: globalState.pageId,
            pageName: globalState.pageName,
            propertyId: globalState.propertyId,
            siteCurrencyCode: globalState.hotelCurrency,
            siteId: globalState.siteId,
            siteTimezone: globalState.timezone || null,
            showWatermark: !globalState.overrides?.orPowbyPopup,
            visitorCountryCode: globalState.country,
            visitorFingerprint: globalState.fingerprint,
            widgetTypeId: this.data.widgetTypeId,
            widgetName: this.data.name,
            zIndex: (getSetting?.(`${this.data.name}_z_index`) || this.data.defaultZIndex || ''),
        };
    }
    /**
     * Get the list of rules to fulfill before showing a tool.
     */
    getRules() {
        const { rulesCollection } = this;
        return [
            rulesCollection.isOnline,
            rulesCollection.idleTrigger,
            rulesCollection.loadTrigger,
            rulesCollection.scrollTrigger,
            rulesCollection.uniqueShow,
            rulesCollection.requiresOraculoLoaded,
            rulesCollection.requiresPwData,
            rulesCollection.demandKnown,
            rulesCollection.disparitiesKnown,
            rulesCollection.duettoKnown,
            rulesCollection.device,
            rulesCollection.currentPage,
            rulesCollection.site,
            rulesCollection.isBackendDiscarded,
            rulesCollection.isComplete,
            rulesCollection.saveSearch,
            rulesCollection.countdown,
            rulesCollection.canOpenBe,
            rulesCollection.promocodeInuse,
            rulesCollection.checkDynamicTags,
            [rulesCollection.bypassFrequencyConfig, rulesCollection.evaluationFrequency],
            rulesCollection.scheduledDates,
            rulesCollection.scheduledDays,
            rulesCollection.scheduledTime,
            rulesCollection.originMatch,
            rulesCollection.retargeting,
            rulesCollection.visitorRegistrationStatus,
            rulesCollection.geolocation,
            rulesCollection.occupancyAdults,
            rulesCollection.occupancyChildren,
            rulesCollection.occupancyRooms,
            rulesCollection.urlVariables,
            rulesCollection.datalayerVariables,
            rulesCollection.soldout,
            rulesCollection.priceRange,
            rulesCollection.daysSinceLastVisit,
            rulesCollection.daysUntilCheckin,
            rulesCollection.lengthOfStay,
            rulesCollection.searchDates,
            rulesCollection.searchDays,
            rulesCollection.userPastVisits,
            rulesCollection.demand,
            rulesCollection.disparities,
            rulesCollection.duetto,
            rulesCollection.oraculosStandard,
        ];
    }
    /**
     * Format a tool.
     */
    format(toolOrPayload) {
        // return same tool if its already a Tool instance
        if (toolOrPayload instanceof Tool) {
            return toolOrPayload;
        }
        if (has(toolOrPayload, ['context', 'payload', 'state'])) {
            const serializedTool = toolOrPayload;
            return new Tool({ ...serializedTool, container: this.container });
        }
        const payload = toolOrPayload;
        return new Tool({
            payload,
            context: this.createToolContext(),
            container: this.container,
        });
    }
    /**
     * Send tool/widget events that may come after evaluation.
     * AKA: send-event, ack-activity, activity
     */
    sendActivity(tool, details) {
        const debugPrefix = 'sendActivity()';
        this.logger?.trace(debugPrefix, 'Call');
        if (!tool) {
            return false;
        }
        const toolContext = tool.getContext();
        const contextToken = toolContext.contextToken || this.container.globalState.contextToken;
        if (toolContext.isDelegated) {
            // Command the original companion Agent to send the beacon
            this.logger?.trace(debugPrefix, `Transmit to companion (toolId: ${tool.getId()})`);
            this.transmit({
                action: MESSAGE_ACTION_SEND_ACTIVITY,
                payload: {
                    data: JSON.parse(stringify(tool)),
                    details,
                    toolId: tool.getId(),
                    widgetName: toolContext.widgetName,
                },
            });
            return true;
        }
        const payload = {
            contextToken,
            toolId: tool?.getId?.() ?? undefined,
            toolVersion: tool?.getVersionId?.() ?? undefined,
            eventName: ActivityKind$1.Action,
            eventDetails: details,
            widgetName: toolContext.widgetName,
        };
        const analyticsPayload = {
            messageId: payload.toolId,
            nonInteraction: false,
            siteId: toolContext.siteId,
            type: toolContext.widgetName,
            details,
        };
        this.container.sendSiteAnalytics(AnalyticsEventName.Activity, JSON.parse(stringify(analyticsPayload)));
        return this.sendBeacon('/agent/ack/activity', JSON.parse(stringify(payload)));
    }
    /**
     * Send the result of a widget/tool evaluation.
     * AKA: add-visit, tool-ack
     */
    sendStatus(tool, details) {
        const debugPrefix = 'sendStatus()';
        this.logger?.trace(debugPrefix, 'Call');
        // "just in case" call the main visit always
        this.container.sendPageVisit();
        if (!tool) {
            return false;
        }
        const toolContext = tool.getContext();
        const toolStatus = tool.getStatus();
        if (toolContext.isDelegated) {
            // Command the original companion Agent to send the beacon
            this.logger?.trace(debugPrefix, `Transmit to companion (toolId: ${tool.getId()})`);
            this.transmit({
                action: MESSAGE_ACTION_SEND_STATUS,
                payload: {
                    data: JSON.parse(stringify(tool)),
                    details,
                    toolId: tool.getId(),
                    widgetName: toolContext.widgetName,
                },
            });
            return true;
        }
        // The event "THN MessageStatus" sends generic information about the tools being processed.
        // This event is only sent when the tool status is "control" or "showed" to avoid sending an excessive number of events.
        if (toolStatus && ['control', 'showed'].includes(toolStatus)) {
            const analyticsPayload = {
                abTest: toolStatus === 'control',
                messageId: tool.getId(),
                shown: toolStatus === 'showed',
                status: toolStatus,
                siteId: this.container.globalState.siteId,
                type: toolContext.widgetName,
            };
            this.container.sendSiteAnalytics(AnalyticsEventName.MessageStatus, analyticsPayload);
        }
        const toolState = tool.getState();
        const payload = {
            // Note this "contextToken" value will override the default
            // "contextToken" value added by the sendBeacon service, which matches
            // the current value of "contextToken" in the globalState.
            // This "contextToken" here matches the one that was valid when the tool was created.
            contextToken: toolContext.contextToken || undefined,
            failedConditionLog: toolState.failedRuleLog || undefined,
            status: toolStatus,
            toolId: tool.getId(),
            toolType: toolContext.widgetName,
            toolVersion: tool.getVersionId() ?? undefined,
            url: this.container.globalThis?.location?.href?.toString?.(),
            visitorLoggedIn: toolContext.isUserLogged,
            // Note this is not a typo: endpoint contract is "widgetId"
            widgetId: toolContext.widgetTypeId,
        };
        const endpoint = '/agent/ack-tool';
        return this.sendBeacon(endpoint, payload);
    }
    /**
     * Set a list of tools in the widget.
     *
     * Will map each item of the list with `Widget.format`.
     */
    setTools(toolsCollection) {
        this.logger.trace('setTools()', 'Call', toolsCollection);
        if (!Array.isArray(toolsCollection)) {
            throw new TypeError('tools is not an Array');
        }
        this.data.tools = toolsCollection.map((t) => this.format(t));
        return this;
    }
    /**
     * Unset the list of tools on the widget.
     */
    unsetTools() {
        this.logger.trace('unsetTools()', 'Call');
        this.data.tools = [];
        return this;
    }
    /**
     * Check if a tool passes the evalution of rules.
     */
    async checkTool({ tool }) {
        if (tool.getState().processed) {
            // A tool that has already been processed will not recheck
            return { evaluationError: true };
        }
        const debug = [`${tool.getId()} "${tool.getName()}"`];
        const summary = {
            controlSelected: undefined,
            controlReason: undefined,
            failedRuleKind: undefined,
            failedRuleId: undefined,
            failedRuleLog: '',
            manualStatus: '',
        };
        if (!this.rulesEvaluator) {
            this.rulesEvaluator = new RulesEvaluator(this.getRules(), this.container);
        }
        const { pass, logs, failedRules, errors, } = await this.rulesEvaluator.evaluate(tool);
        const rulesFailure = !pass;
        // Early exit
        if (errors.length) {
            errors.forEach((error) => {
                this.logger.warn('checkTool()', 'Error on rules evaluation: ', error);
                this.container.errorMonitor.addError(error);
            });
            return {
                evaluationError: true,
            };
        }
        debug.push(...RulesEvaluator.formatLogs(logs, 'Condition'));
        if (rulesFailure) {
            summary.failedRuleLog = RulesEvaluator.formatFailedLogs(logs);
            const firstFailedRule = failedRules[0];
            if (firstFailedRule) {
                const effectiveFailedRule = Array.isArray(firstFailedRule)
                    ? firstFailedRule[firstFailedRule.length - 1]
                    : firstFailedRule;
                summary.failedRuleKind = effectiveFailedRule.kind;
                summary.failedRuleId = effectiveFailedRule.id;
            }
            const toolState = tool.getState();
            // Check if this is the same rule failure as before
            if (toolState.failedRuleId === summary.failedRuleId) {
                // Early exit to avoid logging the same rule error again
                return { evaluationSkipped: true };
            }
        }
        if (!rulesFailure) {
            const toolIsAbTesting = tool.isAbTesting();
            const widgetIsAbTesting = !!this.getData().abTest;
            const abTestActive = toolIsAbTesting || widgetIsAbTesting;
            summary.controlSelected = this.isControlUser({
                abTestActive,
                abTestPercentage: tool.getAbTestPercentage(),
            });
            if (summary.controlSelected) {
                summary.controlReason = toolIsAbTesting ? 'tool' : 'widget';
            }
        }
        debug.push('', `Result: ${rulesFailure ? RULES_FAIL_MSG : RULES_PASS_MSG} ${summary.controlReason ? `HIDDEN by AB test (${summary.controlReason})` : ''}`, '==================================================');
        return {
            rulesFailure,
            summary: summary,
            debug,
        };
    }
    /**
     * Tool closed hook / side-effects.
     * @param {object} tool
     */
    // eslint-disable-next-line class-methods-use-this
    onToolHide(tool) {
        // Change state to closed
        tool.updateState({ closed: true });
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call
        this.remove?.();
        return Promise$1.resolve(true);
    }
    /**
     * Tool opened hook / side-effects.
     * @param {object} tool
     */
    // eslint-disable-next-line class-methods-use-this
    onToolShow(tool) {
        // update the state to mark the tool as visually opened
        tool.updateState({ opened: true });
        return Promise$1.resolve(true);
    }
    /**
     * Resets the widget data, and reinitializes all tools state.
     * @memberof module:widgets.Widget#
     */
    reboot() {
        this.reset();
        this.resetTools();
        this.bubble({
            action: `reboot_${this.data.name}widget`,
        });
    }
    /**
     * Process the list of tools and show those that fullfil the rules.
     *
     * @memberof module:widgets.Widget#
     * @param {array} tools - A list of tools.
     * @return {Promise<void>}
     */
    process(tools = this.data.tools) {
        const debugPrefix = 'process()';
        this.logger.trace(debugPrefix, 'Call');
        if (!Array.isArray(tools) || tools.length === 0) {
            this.logger.trace(debugPrefix, 'No tools present');
            return Promise$1.resolve();
        }
        // Cancel any previous queued processing (abort all per-execution tasks)
        this.onProcessAbort();
        // generate a unique process id and set as current
        const processId = this.container.ulid();
        this.currentProcessId = processId;
        const initialPromise = AbortablePromise.from(this.init());
        // check and show each tool
        return tools.reduce((previousCheckAndShowWork, tool) => {
            const commonToolMsg = `checkAndShow for tool ${tool.getId()}`;
            this.logger.trace(debugPrefix, `scheduled ${commonToolMsg}`);
            // Ensure this execution is aborted on new process runs
            this.onProcessAbort(() => {
                previousCheckAndShowWork.abort();
            });
            // Must be blocking because tool checking keeps order
            const eventualCheckAndShow = previousCheckAndShowWork
                .then(() => tool.onReady())
                .then(() => {
                this.logger.trace(debugPrefix, `running ${commonToolMsg}`);
                return this.checkAndShow(tool, processId);
            })
                .then(({ status }) => {
                if (status === 'skipped') {
                    this.logger.trace(debugPrefix, `early exit on ${commonToolMsg}`);
                }
                else {
                    this.logger.trace(debugPrefix, `end ${commonToolMsg}`);
                }
            })
                .catch((reason) => {
                if (!(reason instanceof AbortError)) {
                    this.logger.trace(debugPrefix, `error on ${commonToolMsg}`, reason);
                    throw reason;
                }
                this.logger.trace(debugPrefix, `aborted ${commonToolMsg}`);
            });
            return eventualCheckAndShow;
        }, initialPromise);
    }
    /**
     * Check a tool rules and show it.
     *
     * @memberof module:widgets.Widget#
     * @param {Tool} tool - The tool.
     */
    async checkAndShow(tool, processId) {
        const debugPrefix = 'checkAndShow()';
        const result = await this.checkTool({ tool });
        // Early exit if a newer process() run started while checking
        if (processId !== this.currentProcessId) {
            return { status: 'expired' };
        }
        if (result.evaluationError) {
            return { status: 'error' };
        }
        if (result.evaluationSkipped) {
            return { status: 'skipped' };
        }
        const { debug, rulesFailure, summary, } = result;
        const printLogs = () => {
            const manualPrefix = `[thn]${isIframed() ? '[iframe]' : ''}[${this.data.name}]`;
            this.logger.info(`${debug[0].replace(' details:', ': ')} ${!rulesFailure ? RULES_PASS_MSG : RULES_FAIL_MSG} ${(!rulesFailure && tool.getState().controlSelected) ? 'HIDDEN by AB test' : ''}`);
            this.logger.openDebugGroup?.(`${manualPrefix} ${debug.shift() || ''}`);
            this.logger.debug(debugPrefix, `\n\n${debug.join('\n')}`);
            this.logger.closeDebugGroup?.();
        };
        tool.updateState({
            // Consider the tool as "checked"
            checked: true,
            // Tool should be shown if all rules fulfilled
            toBeShown: !rulesFailure,
            // Incorporate the result "summary" props to the tool state
            ...summary,
        });
        printLogs();
        const toolState = tool.getState();
        if (rulesFailure) {
            if (toolState.failedRuleKind === RuleKind.Targeting || tool.isExperiment()) {
                this.sendStatus(tool);
                return { status: toolState.toBeShown ? 'passed' : 'failed' };
            }
        }
        // Show!
        if (toolState.toBeShown) {
            await this.load({ tool });
        }
        return { status: toolState.toBeShown ? 'passed' : 'failed' };
    }
    /**
     * Creates a handler that will transmit the action
     * from the delegatee agent to the original agent.
     *
     * TODO: currently this handlers will transmit the action
     * without waiting for a result. Thus they always resolve to true.
     */
    createDelegateeHandler(actionKind, tool, action) {
        return async (data) => {
            this.logger.trace(`Transmit ${actionKind} to companion (toolId: ${tool.getId()})`);
            this.transmit({
                action: actionKind,
                payload: {
                    data,
                    moduleId: action?.moduleId,
                    toolId: tool.getId(),
                    widgetName: tool.getContext().widgetName,
                },
            });
            // TODO: currently this handlers will transmit the action
            // without waiting for a result. Thus they always resolve to true.
            return true;
        };
    }
    /**
     * Make an object that bundles all the data needed to
     * delegate the handling to the parent agent.
     * @memberof module:widgets.Widget#
     */
    bundleForDelegation({ tool }) {
        const { createSearchReplay } = this.container;
        const canApplyDiscount = !!tool.getActions().reduce((result, action) => {
            let updatedResult = result;
            if (action.kind === AgentActionKind.ApplyDiscount) {
                updatedResult = result && !!(createSearchReplay({ discount: action.discountCode })?.replayMethod);
            }
            return updatedResult;
        }, true);
        tool.updateContext({
            isDelegated: true,
            canApplyDiscount,
        });
        return JSON.parse(stringify(tool));
    }
    async onCompanionMessageActionHandler(event) {
        const expectedActionHandler = this.actionToHandler[event?.data?.action];
        // Return if we can't map the received action
        if (!expectedActionHandler) {
            return undefined; // unlogged to avoid noise
        }
        const { action, payload, } = event.data;
        // Origin of the message needs to be from this widget
        if (payload.widgetName !== this.data.name) {
            return undefined; // unlogged to avoid noise
        }
        const log = (msg) => {
            if (msg) {
                this.logger.trace(`Received companion request for action "${action}"`);
                this.logger.trace('Payload:', payload);
                this.logger.trace(`Result: ${msg}`);
            }
        };
        // Get the tool
        const tool = this.data.tools.find((t) => t.getId() === payload.toolId);
        if (!tool) {
            return log('KO, unknown tool');
        }
        if (isFunction(expectedActionHandler)) {
            try {
                const hydratedTool = await new Tool({ ...payload.data, container: this.container }).onReady();
                hydratedTool.updateContext({ isDelegated: false });
                expectedActionHandler(hydratedTool, payload.details);
            }
            catch {
                expectedActionHandler(payload.data, payload.details);
            }
            return log('OK');
        }
        // At this point the note is no longer delegated as we've acting from
        // a parent action request given a previous child script delegation.
        tool.updateContext({ isDelegated: false });
        // Get a bundle for that tool
        const bundle = await this.bundleForUi({ tool });
        // Reset delegated context flag
        tool.updateContext({ isDelegated: true });
        // Locate the bundle action to execute its handler
        const bundleAction = bundle.actions.find((a) => a.kind === expectedActionHandler && (!payload.moduleId || a.moduleId === payload.moduleId));
        if (!(bundleAction && 'handler' in bundleAction)) {
            return log('KO, handler missing from bundle');
        }
        // execute
        const result = await bundleAction.handler?.(payload.data);
        // TODO: communicate back to the companion script the result, not just log it
        return log(stringify(result));
    }
    remove() {
        const debugPrefix = 'remove()';
        this.logger.trace(debugPrefix, 'Not implemented');
    }
}

/**
 * A base generic Popup widget.
 */
class Popup extends WidgetWithTools {
    get __default() {
        return {
            ...super.__default,
            viewCategory: 'popup',
        };
    }
    get __computed() {
        return {
            ...super.__computed,
            formatFamily: {
                get: () => this.container.getSetting(`${this.data.viewCategory || this.data.name}_view_adapter`),
            },
        };
    }
    get __preserved() {
        return [
            ...super.__preserved,
            'delegated',
        ];
    }
    onDestroy = generateCallbackQueue();
    /**
     * Get the list of rules to fulfill before showing a tool.
     */
    getRules() {
        const { rulesCollection } = this;
        return [
            rulesCollection.allPreviousChecked,
            rulesCollection.onlyOneToolSet,
            [
                rulesCollection.ignoreOnlyOneToolShown,
                rulesCollection.onlyOneToolShown,
            ],
            ...super.getRules(),
        ];
    }
    shouldBubble(tool) {
        const toolWithLogin = !!(tool?.getActions().find((action) => action.kind === AgentActionKind.Login));
        // Note tools with login are not prepared for delegation, they can't bubble
        return !toolWithLogin && super.shouldBubble();
    }
    /**
     * Deletes the DOM Node elements used by the {exit,layer} widget.
     *
     * Removes the event listeners added by the widget (<exit,layer>.unlisten).
     */
    destroy({ avoidPropagation = false } = {}) {
        const debugPrefix = 'destroy()';
        // Exec the view's implementation of "destroy"
        this.callView('destroy', { debugPrefix });
        this.onDestroy();
        // reset data
        this.reset();
        if (!avoidPropagation) {
            const payload = {
                action: 'destroy_widget',
                widgetName: this.data.name,
                args: [{ avoidPropagation: true }],
            };
            this.transmit(payload);
        }
        return this;
    }
    /**
     * Hides the DOM Node elements.
     *
     * Does nothing if the widget is offline.
     */
    hide() {
        const debugPrefix = 'hide()';
        // early exit
        if (!this.isOnline()) {
            return this;
        }
        // Exec the view's implementation of "hide"
        this.callView('hide', { debugPrefix });
        return this;
    }
    /**
     * Tool closed hook / side-effects.
     */
    onToolHide(tool) {
        // TO DO: Once the p-components logic is adjusted to call onToolHide once the tool closing animation is complete, we can remove this delay
        const destroyTimer = setTimeout(() => {
            // Change state to closed
            tool.updateState({ closed: true });
            // recheck to see if another tool should be shown
            this.process().catch(() => { });
        }, 500);
        this.container.bus.once('thn:page.unload', () => {
            clearTimeout(destroyTimer);
        });
        return Promise$1.resolve(true);
    }
    /**
     * Hides the DOM Node elements and removes listeners.
     *
     * Does not apply if the widget is offline.
     */
    remove(reset = true) {
        const debugPrefix = 'remove()';
        // early exit
        if (!this.isOnline()) {
            return this;
        }
        // Exec the view's implementation of "destroy"
        this.callView('destroy', { debugPrefix });
        // hide
        this.hide();
        // unset
        if (reset) {
            this.reset();
        }
        return this;
    }
}

/**
 * The Exit widget.
 */
class Exit extends Popup {
    get __default() {
        return {
            ...super.__default,
            id: 'eighty_close_exit_widget',
            name: 'exit',
            ready: false,
            online: 0,
            abTest: 0,
            bubbles: false,
            delegated: null,
            desktopDefaultZIndex: 999999999,
            mobileDefaultZIndex: 999999998,
            widgetTypeId: WidgetTypeId.Exit,
        };
    }
    /**
     * Get the list of rules to fulfill before showing a tool.
     */
    getRules() {
        const { rulesCollection } = this;
        return [
            rulesCollection.exitTrigger,
            ...super.getRules(),
        ];
    }
    /**
     * Reset the exit widget data.
     */
    reset() {
        Object.assign(this.data, {
            ready: false,
            delegated: null,
        });
        return this;
    }
    /**
     * Load the exit popup widget.
     *
     * Does not apply if the widget is offline.
     * and loads the exit widget contents.
     */
    async load({ tool: toolInstance }) {
        const debugPrefix = 'load()';
        this.logger.debug(debugPrefix, 'Call');
        const tool = await toolInstance.onReady();
        const toolState = tool.getState();
        // Early exit
        if (toolState.processed || !toolState.toBeShown) {
            return false;
        }
        // Message the parent to show the exit widget
        // please, use the var "bubbles" to avoid messaging the
        // parent even when the script is iframed
        if (this.shouldBubble(tool)) {
            this.bubble({
                action: 'load_delegated_tool',
                tool: this.bundleForDelegation({ tool }),
                widgetName: this.data.name,
            });
            // End of Exit Widget load on the child script
            tool.updateState({ processed: true });
            return this;
        }
        let context;
        const show = cancellable(() => {
            if (!context) {
                throw new Error('Unable to show without a context');
            }
            // Early exit:
            // 1 - Widget is already visible
            // 2 - Layer widget is visible and blocking
            if (this.isVisible() || this.container.layer.isBlocking()) {
                return false;
            }
            // Show only if it's not A/B test control user
            if (!toolState.controlSelected) {
                // Logs
                this.logger.debug(debugPrefix, 'Showing:', tool);
                // Exec the view's implementation of "show"
                this.callView('show', {
                    ...context,
                    debugPrefix,
                });
                // Update the tool state
                tool.updateState({ showed: true });
            }
            // Send the definitive beacon
            this.sendStatus(tool);
            // Call site google analytics
            this.container.sendSiteAnalytics(stringCapitalize(this.data.name), { messageId: tool.getId() });
            if (toolState.controlSelected) {
                // Trigger the onHide hook as if the tool had been shown and closed
                context.bundle.actions.find((action) => action.kind === AgentActionKind.Hide)?.handler?.().catch(() => { });
            }
            return true;
        });
        this.onDestroy(() => { show.cancel(); });
        tool.updateState({ processed: true });
        await this.loadView();
        context = {
            bundle: await this.bundleForUi({ tool }),
        };
        show();
        this.logger.debug(debugPrefix, 'Tool:', tool);
        return this;
    }
}

/**
 * The Inliner widget.
 *
 * @class
 * @extends module:widgets.Widget
 */
class Inliner extends WidgetWithTools {
    get __default() {
        return {
            ...super.__default,
            desktopDefaultZIndex: 99999,
            mobileDefaultZIndex: 99999,
            id: 'thn_inlines_widget',
            name: 'inliner',
            abTest: 0,
            online: 0,
            widgetTypeId: WidgetTypeId.Inliner,
        };
    }
    get __computed() {
        return {
            ...super.__computed,
            formatFamily: {
                get: () => this.container.getSetting(`${this.data.viewCategory || this.data.name}_view_adapter` /* as 'view_adapter' */),
            },
        };
    }
    onDestroy = generateCallbackQueue();
    /**
     * Initialization of the widget.
     *
     * Intended to be called before lifecycle usual methods.
     *
     * Will load the initial view.
     *
     * @memberof module:widgets.Inliner#
     * @return {Promise<Inliner>}
     */
    init() {
        return this.loadView().then(() => this);
    }
    /**
     * Get the list of rules to fulfill before showing a tool.
     */
    getRules() {
        const { rulesCollection } = this;
        return [
            [rulesCollection.isNativeApp, rulesCollection.selectorUniqueElement],
            ...super.getRules(),
        ];
    }
    /**
     * Load an inliner tool.
     *
     * @memberof module:widgets.Inliner#
     * @param {object} tool - The tool data.
     *
     * @return {Promise<bool>} - The tool should be shown.
     */
    async load({ tool }) {
        const debugPrefix = 'load()';
        const toolState = tool.getState();
        let context;
        // Early exit
        if (toolState.processed || !toolState.toBeShown) {
            return false;
        }
        const show = cancellable(() => {
            if (!context) {
                throw new Error('Unable to show without a context');
            }
            // Show only if it's not A/B test control user
            if (!toolState.controlSelected) {
                // Logs
                this.logger.debug(debugPrefix, 'Showing:', tool);
                // Exec the view's implementation of "show"
                this.callView('show', context);
                // update tool state
                tool.updateState({ showed: true });
            }
            // Send the definitive beacon
            this.sendStatus(tool);
            // Call site google analytics
            this.container.sendSiteAnalytics(stringCapitalize(this.data.name) /* as typeof this.data.name */, { messageId: tool.getId() });
            if (toolState.controlSelected) {
                // Trigger the onHide hook as if the tool had been shown and closed
                context.bundle.actions.find((action) => action.kind === AgentActionKind.Hide)?.handler?.();
            }
        });
        this.onDestroy(() => { show.cancel(); });
        tool.updateState({ processed: true });
        await this.loadView();
        context = {
            bundle: await this.bundleForUi({ tool }),
        };
        show();
        return toolState.toBeShown;
    }
    /**
       * Deletes the DOM node elements used by the inliner widget.
       *
       * @memberof module:widgets.Inliner#
       * @param {bool} [reset=true] - Reset the inliner widget data.
       *
       * @return {module:widgets.Inliner}
       */
    destroy(reset = true) {
        this.onDestroy();
        // reset data
        if (reset) {
            this.reset();
        }
        return this;
    }
    /**
       * Reset the widget data.
       *
       * @memberof module:widgets.Inliner#
       * @return {module:widgets.Inliner}
       */
    reset() {
        // Reset state object
        this.resetTools();
        return this;
    }
}

/**
 * The KITT widget.
 */
let Kitt = /* #__PURE__ */ (() => {
    let _classSuper = WidgetWithView;
    let _instanceExtraInitializers = [];
    let _bundleForUi_decorators;
    let _destroy_decorators;
    let _load_decorators;
    let _minimize_decorators;
    let _sendActivity_decorators;
    return class Kitt extends _classSuper {
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _bundleForUi_decorators = [loggedMethod];
            _destroy_decorators = [loggedMethod];
            _load_decorators = [loggedMethod];
            _minimize_decorators = [loggedMethod];
            _sendActivity_decorators = [loggedMethod];
            __esDecorate(this, null, _bundleForUi_decorators, { kind: "method", name: "bundleForUi", static: false, private: false, access: { has: obj => "bundleForUi" in obj, get: obj => obj.bundleForUi }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _destroy_decorators, { kind: "method", name: "destroy", static: false, private: false, access: { has: obj => "destroy" in obj, get: obj => obj.destroy }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _load_decorators, { kind: "method", name: "load", static: false, private: false, access: { has: obj => "load" in obj, get: obj => obj.load }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _minimize_decorators, { kind: "method", name: "minimize", static: false, private: false, access: { has: obj => "minimize" in obj, get: obj => obj.minimize }, metadata: _metadata }, null, _instanceExtraInitializers);
            __esDecorate(this, null, _sendActivity_decorators, { kind: "method", name: "sendActivity", static: false, private: false, access: { has: obj => "sendActivity" in obj, get: obj => obj.sendActivity }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(this, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        }
        get __default() {
            return {
                ...super.__default,
                desktopDefaultZIndex: 999999996, // Important: less than notes, layers, exit
                mobileDefaultZIndex: 999999999, // Important: greater than notes, layers, exit
                id: 'thn_kitt_widget',
                name: WidgetsList.Kitt,
                online: 0,
                desktopOnline: 0,
                mobileOnline: 0,
                pages: [],
            };
        }
        get __computed() {
            return {
                ...super.__computed,
                formatFamily: {
                    get: () => this.container.getSetting(`${this.data.viewCategory || this.data.name}_view_adapter`),
                },
            };
        }
        /**
         * Register any application services/requirements.
         */
        register() {
            // Typically registration should happen just once
            if (this.data.registered) {
                return this;
            }
            // Super function flags registered=true
            super.register();
            // Register a listener for "visitor visit data" set,
            // which is the event triggered once a page changes and
            // the minimum visitor data has been set for that page.
            this.container.bus.on(['thn:visitor-visit-data.set'], () => {
                if (!this.isOnline()) {
                    return;
                }
                if (this.isTargetPage()) {
                    this.logger?.debug?.('Is target page');
                    this.load().catch((reason) => this.logger?.debug?.(reason));
                }
                else {
                    this.logger?.debug?.('Is not target page');
                    this.destroy();
                }
            });
            return this;
        }
        async bundleForUi() {
            const { fingerprint, hostname, hostnameReal, language = 'en', media, propertyId, siteId, visitor, } = this.container.globalState;
            const target = { kittId: visitor?.lastKittId || null };
            const bundle = {
                actions: [],
                country: visitor?.geolocation?.country?.code ?? '',
                device: media.name,
                // TODO: remove `deviceStyleConfig`, since it has been renamed to `customConfig`
                // This can be safely done once @thehotelsnetwork/kittchat is > 1.161.6
                deviceStyleConfig: this.data.styleConfig,
                customConfig: this.data.styleConfig,
                endpoint: `wss://${hostnameReal || hostname}/${this.data.name}/llm-chat-websocket/agentKITT/site/${siteId}/${language}`,
                fingerprint,
                isRightAlign: this.data.isRightAlign,
                kittId: target.kittId,
                language,
                logger: this.container.Logger.get(`${this.data.name}-view`),
                propertyId,
                siteId,
                widgetName: this.data.name,
                zIndex: this.container.getSetting?.(`${this.data.name}_z_index`)
                    || this.data.defaultZIndex
                    || '',
            };
            let hasEngaged = false;
            let hasDismissed = false;
            const dismissHandler = async () => {
                if (hasEngaged || hasDismissed) {
                    return hasDismissed;
                }
                hasDismissed = this.sendActivity(target, { kind: AgentActionKind.Dismiss });
                return hasDismissed;
            };
            const engageHandler = async () => {
                if (hasEngaged || hasDismissed) {
                    return hasEngaged;
                }
                hasEngaged = this.sendActivity(target, { kind: AgentActionKind.Engage });
                return hasEngaged;
            };
            bundle.actions = this.getActions().map((action) => {
                let handler;
                switch (action.kind) {
                    case AgentActionKind.Dismiss:
                        handler = dismissHandler;
                        break;
                    case AgentActionKind.Engage:
                        handler = engageHandler;
                        break;
                }
                return { ...action, handler };
            });
            return bundle;
        }
        destroy() {
            this.callView('destroy');
        }
        async load() {
            const debugPrefix = 'load()';
            if (this.isVisible(false)) {
                return this;
            }
            const [, bundle] = await Promise$1.all([
                this.loadView(),
                this.bundleForUi(),
            ]);
            const context = {
                bundle,
                debugPrefix,
            };
            await this.callView('show', context);
            this.container.sendSiteAnalytics(stringCapitalize(this.data.name));
            return this;
        }
        minimize() {
            this.callView('minimize');
        }
        sendActivity(target, details) {
            const payload = {
                kittId: target.kittId,
                eventName: ActivityKind$1.Action,
                eventDetails: details,
            };
            const analyticsPayload = {
                kittId: payload.kittId,
                nonInteraction: false,
                siteId: this.container.globalState.siteId,
                type: this.data.name,
                details,
            };
            this.container.sendSiteAnalytics(AnalyticsEventName.Activity, JSON.parse(stringify(analyticsPayload)));
            return this.sendBeacon('/agent/ack/activity', payload);
        }
        // eslint-disable-next-line class-methods-use-this
        getActions() {
            const actions = [{
                    kind: AgentActionKind.Dismiss,
                }, {
                    kind: AgentActionKind.Engage,
                }];
            return actions;
        }
        constructor() {
            super(...arguments);
            __runInitializers(this, _instanceExtraInitializers);
        }
    };
})();

/**
 * The Note widget.
 */
class Note extends WidgetWithTools {
    get __default() {
        return {
            ...super.__default,
            id: 'thn_notes_widget',
            name: 'note',
            online: 0,
            delay: 1500,
            onLoadNotesShown: 0,
            abTest: 0,
            desktopDefaultZIndex: 999999997, // Important: less than the {Layer, Exit} z-index
            mobileDefaultZIndex: 999999996, // Important: less than the {Kit, Layer, Exit} z-index
            bubbles: false,
            widgetTypeId: WidgetTypeId.Note,
        };
    }
    get __computed() {
        return {
            ...super.__computed,
            formatFamily: {
                get: () => this.container.getSetting(`${this.data.viewCategory || this.data.name}_view_adapter`),
            },
        };
    }
    onDestroy = generateCallbackQueue();
    /**
     * Get the list of rules to fulfill before showing a tool.
     */
    getRules() {
        const { rulesCollection } = this;
        return [
            rulesCollection.allPreviousChecked,
            rulesCollection.noteType,
            rulesCollection.canOpenBarLayout,
            ...super.getRules(),
        ];
    }
    /**
     * Loads a note.
     */
    async load({ tool: toolInstance }) {
        // Always ensure that tool instance is ready (if the tool
        // is given as delegated we just receive the Tool object).
        const tool = await toolInstance.onReady();
        const debugPrefix = 'load()';
        const toolState = tool.getState();
        let context;
        // Early exit
        if (toolState.processed || !toolState.toBeShown) {
            return false;
        }
        const show = cancellable(() => {
            if (!context) {
                throw new Error('Unable to show without a context');
            }
            // Show only if it's not A/B test control user
            if (!toolState.controlSelected) {
                // Logs
                this.logger.debug(debugPrefix, 'Showing:', tool);
                // Call the view
                this.callView('show', context);
                // Update the tool state
                tool.updateState({ showed: true });
            }
            // send the definitive beacon
            this.sendStatus(tool);
            // call site google analytics
            this.container.sendSiteAnalytics(stringCapitalize(this.data.name), { messageId: tool.getId() });
            if (toolState.controlSelected) {
                // Trigger the onHide hook as if the tool had been shown and closed
                context.bundle.actions.find((action) => action.kind === AgentActionKind.Hide)?.handler?.().catch(() => { });
            }
        });
        this.onDestroy(() => { show.cancel(); });
        const toolTrigger = tool.getTrigger();
        // maintain slight delay to display notes in steps
        const noteComputedDelay = this.data.delay * this.data.onLoadNotesShown;
        const lastComparison = this.container.getVisitorLastComparison({ acceptWithoutAvailability: false })?.data?.actual?.search;
        tool.updateContext({ lastComparison });
        // Message the parent to show the note
        // Please, use the var "bubbles" to avoid messaging the
        // parent even when the script is iframed
        if (this.shouldBubble()) {
            const delegationPayload = {
                action: 'load_delegated_tool',
                tool: this.bundleForDelegation({ tool }),
                widgetName: this.data.name,
            };
            this.bubble(delegationPayload);
            // End of show note for the child script
            tool.updateState({ processed: true });
            return tool.getState().toBeShown;
        }
        // Special actions on mobile devices
        if (this.container.globalState.media.name === 'mobile' && tool.getLayout() !== 'bar') {
            // On mobile devices, notes with non-bar layout block other notes
            const notesOnScreen = this.data.tools.filter((note) => note.getLayout() !== 'bar' && note.getState().toBeShown === true
                && note.getState().closed === false && note.getState().processed === true);
            // No further processing while we have a note on the screen
            if (notesOnScreen.length) {
                return false;
            }
        }
        // Update note
        // On mobile devices we need to know if the note "is shown" before actually showing it
        tool.updateState({ processed: true });
        if (toolTrigger.kind === TriggerKind$1.Load && tool.getLayout() !== 'bar') {
            // Increment global counter
            this.data.onLoadNotesShown += 1;
        }
        await this.loadView();
        context = {
            bundle: await this.bundleForUi({ tool }),
        };
        if (TriggerKind$1.Load === toolTrigger.kind) {
            // Setup note timer (minimum delay 60ms)
            const timer = setTimeout(show, noteComputedDelay + 60);
            this.onDestroy(() => { clearTimeout(timer); });
        }
        else {
            show();
        }
        return tool.getState().toBeShown;
    }
    async onToolHide(tool) {
        if (tool.getTrigger().kind === TriggerKind$1.Load && tool.getLayout() !== 'bar') {
            // Decrement global counter
            this.data.onLoadNotesShown -= 1;
        }
        // show the next note
        const startProcess = () => {
            // Change state to closed
            tool.updateState({ closed: true });
            // recheck to see if another tool should be shown
            this.process().catch(() => { });
        };
        // TO DO: Once the p-components logic is adjusted to call onToolHide once the tool closing animation is complete, we can remove this delay
        const id = setTimeout(startProcess, this.data.delay);
        this.onDestroy(() => clearTimeout(id));
        return true;
    }
    /**
     * Deletes the DOM node elements used by the note widget.
     */
    destroy({ reset = true } = {}) {
        this.onDestroy();
        // reset data
        if (reset) {
            this.reset();
        }
        // if iframed then message the parent
        if (this.shouldBubble()) {
            this.bubble({ action: 'destroy_note_widget' });
        }
        return this;
    }
    /**
     * Reset the Note widget data.
     */
    reset() {
        Object.assign(this.data, {
            onLoadNotesShown: 0,
        });
        this.resetTools();
        // if iframed then message the parent
        if (this.shouldBubble()) {
            this.bubble({ action: 'reset_note_widget' });
        }
        return this;
    }
}

function createSendSiteContactHandler(services) {
    const { fetch, globalState } = services;
    return (data) => {
        const payload = {
            contextToken: globalState.contextToken,
            email: data.email,
            message: data.message,
        };
        if (!isEmail(payload.email)) {
            return Promise$1.reject(new Error('Invalid email'));
        }
        return fetch('/agent/send-contact-email', { body: payload })
            .then((res) => res.ok)
            .catch((_reason) => false);
    };
}

/**
 * Decides if search entry is of type pages, and subtype last_search.
 */
function isPagesLastSearchEntry(entry) {
    return entry.data?.actual?.metadata?.custom === false;
}

/**
 * Reverse the position (UR -> UL, UL -> UR, and so on).
 */
function mirrorPosition(position = '') {
    let result = position;
    let newPosition;
    if (position && position.length >= 2) {
        newPosition = position.substring(1, 2);
        if (newPosition === 'L') {
            newPosition = 'R';
        }
        else if (newPosition === 'R') {
            newPosition = 'L';
        }
        result = position.substring(0, 1) + newPosition + position.substring(2);
    }
    return result || '';
}

const sendSdkDeprecationError = (errorMonitorService) => {
    const sdkError = new Error('[Deprecation] Direct usage of the THN SDK is not allowed. Please use the DataLayer API instead. See https://docsend.com/view/p2ycdnbpq8rh424r');
    console.warn(sdkError.message);
    errorMonitorService.addError(sdkError);
};
/**
 * The Comparison widget, mostly the PW.
 */
let Comparison = /* #__PURE__ */ (() => {
    let _classSuper = WidgetWithView;
    let _instanceExtraInitializers = [];
    let _shouldPreventShow_decorators;
    return class Comparison extends _classSuper {
        static {
            const _metadata = typeof Symbol === "function" && Symbol.metadata ? Object.create(_classSuper[Symbol.metadata] ?? null) : void 0;
            _shouldPreventShow_decorators = [loggedMethod];
            __esDecorate(this, null, _shouldPreventShow_decorators, { kind: "method", name: "shouldPreventShow", static: false, private: false, access: { has: obj => "shouldPreventShow" in obj, get: obj => obj.shouldPreventShow }, metadata: _metadata }, null, _instanceExtraInitializers);
            if (_metadata) Object.defineProperty(this, Symbol.metadata, { enumerable: true, configurable: true, writable: true, value: _metadata });
        }
        actionToHandler = (__runInitializers(this, _instanceExtraInitializers), {
            [MESSAGE_ACTION_APPLY_DISCOUNT]: AgentActionKind.ApplyDiscount,
            [MESSAGE_ACTION_OPEN_BE]: AgentActionKind.OpenBookingEngine,
            [MESSAGE_ACTION_SEND_SAVE_SEARCH]: AgentActionKind.SendSaveSearch,
            [MESSAGE_ACTION_SEND_SITE_CONTACT]: AgentActionKind.SendSiteContact,
        });
        get __default() {
            return {
                ...super.__default,
                abTest: false,
                bubbles: false,
                cssSelector: '',
                desktopDefaultZIndex: 99999999,
                mobileDefaultZIndex: 99999999,
                defaultFormat: 11,
                formats: {
                    11: { name: 'box', family: 'pcomponents' },
                    12: { name: 'landscape', family: 'pcomponents' },
                    13: { name: 'inliner', family: 'ipcomponents' },
                    14: { name: 'fixedbar', family: 'pcomponents' },
                    15: { name: 'sidetab', family: 'pcomponents' },
                },
                gotoengine: 0,
                gotoengineBtnText: 1,
                id: 'eighty_hotel_price_check_widget',
                initialized: false,
                mobileCssSelector: '',
                mobileOnline: 0,
                mobilePosition: 'BT',
                mobileStyleConfig: null,
                mode: 'auto',
                name: 'price',
                otaAnonym: false,
                otaAnonymTexts: {},
                /** Configuration set by PW pages config */
                configPages: {},
                position: 'UR',
                prefix: 'prc_',
                priceNight: 1,
                ssCustomUrl: '',
                ssJsUrl: '',
                ssUrlOption: 0,
                styleConfig: null,
                terms: false,
            };
        }
        get __computed() {
            function generatePropertyDescriptorForCurrentEntry(path) {
                return decoratePropertyDescriptor({
                    get() {
                        const entry = this.searches.getCurrentEntry();
                        const widgetName = entry?.data?.actual?.context?.widgetName;
                        if (widgetName !== this.name) {
                            return undefined;
                        }
                        return entry ? get(entry, path) : undefined;
                    },
                });
            }
            const isMobile = () => this.container.globalState.media?.name === 'mobile';
            const resolvePropName = (propName) => camelCase(`${isMobile() ? 'mobile_' : ''}${propName}`);
            const resolveValue = (path) => {
                const isPages = !!(this.data.mode === 'pages' && this.data.configPages);
                const [primary, secondary] = isPages
                    ? [this.data.configPages, this.data]
                    : [this.data, this.data];
                return has(primary, path)
                    ? get(primary, path)
                    : get(secondary, path);
            };
            const resolve = (propName) => resolveValue(resolvePropName(propName));
            return {
                ...super.__computed,
                ...([
                    'adults', 'babies', 'children', 'currency',
                    'dateBegin', 'dateEnd', 'flightOrigin',
                    'flightDestination', 'guests', 'noRooms',
                    'price', 'priceSpecial', 'priceType', 'pricematchId',
                    'roomDetails', 'rooms', 'roomsDispo',
                ].map((p) => `data.actual.search.${p}`)
                    .concat([
                    'status', 'showed',
                ].map((p) => `state.${p}`))
                    .reduce((acc, curr) => {
                    const value = curr.split('.').pop();
                    acc[value] = generatePropertyDescriptorForCurrentEntry(curr);
                    return acc;
                }, {})),
                debugUrl: decoratePropertyDescriptor({
                    get() {
                        const entry = this.searches.getCurrentEntry();
                        if (!entry) {
                            return undefined;
                        }
                        const widgetName = entry.data?.actual?.context?.widgetName;
                        if (widgetName !== this.name) {
                            return undefined;
                        }
                        return entry?.debugUrl;
                    },
                }),
                ddUrl: decoratePropertyDescriptor({
                    get() {
                        const entry = this.searches.getCurrentEntry();
                        if (!entry) {
                            return undefined;
                        }
                        const widgetName = entry.data?.actual?.context?.widgetName;
                        if (widgetName !== this.name) {
                            return undefined;
                        }
                        const traceId = entry.data?.request?.metadata?.trace_id;
                        return traceId
                            ? `https://app.datadoghq.eu/logs?query=%40traceparent_trace_id%3A${traceId}`
                            : '';
                    },
                }),
                deviceCssSelector: decoratePropertyDescriptor({
                    get: () => resolve('cssSelector'),
                }),
                deviceFormat: decoratePropertyDescriptor({
                    get: () => {
                        const selectedFormatName = this.data.deviceStyleConfig?.template;
                        const found = Object.entries(this.data.formats)
                            .find(([_key, value]) => value.name === selectedFormatName);
                        return (found && Number(found[0])) || this.data.defaultFormat;
                    },
                }),
                deviceMargin: decoratePropertyDescriptor({
                    get: () => resolve('margin'),
                }),
                devicePosition: decoratePropertyDescriptor({
                    get: () => {
                        const position = resolve('position');
                        return this.data.isRightAlign ? mirrorPosition(position) : position;
                    },
                }),
                deviceStyleConfig: decoratePropertyDescriptor({
                    get: () => resolve('styleConfig'),
                }),
                formatName: decoratePropertyDescriptor({
                    get() {
                        return this.formats[this.deviceFormat]?.name;
                    },
                }),
                formatFamily: decoratePropertyDescriptor({
                    get() {
                        return this.formats[this.deviceFormat]?.family;
                    },
                }),
            };
        }
        setConfigBlacklist = [
            'language', 'guests', 'adults', 'children', 'rooms', 'noRooms',
            'roomsDispo', 'price', 'currency', 'dateBegin', 'dateEnd', 'promocode',
            'showed', 'status', 'url', 'set',
        ];
        getPromocode = getPromocode.bind(this);
        onDestroy = generateCallbackQueue();
        setup(...args) {
            super.setup(...args);
            // "link" the searches service
            // note: two references, one directly in the widget
            // and one inside the data object (to allow access from computed data props)
            if (!this.container.$has('searches')) {
                throw new Error('Missing "searches" service');
            }
            if (!has(this, 'searches')) {
                // Let's define a "searches" shortcut, similar to:
                //  this.searches = this.data.searches = this.container.searches;
                // But using a getter, so that if "searches" service is redefined
                // widget.searches and widget.data.searches reflect it too
                const defineArgs = ['searches', decoratePropertyDescriptor({
                        // Warn: It is important to keep "searches" non enumerable
                        // to avoid its cloning when we bulk clone thn.widgets.price.data
                        enumerable: false,
                        get: () => this.container.searches,
                    })];
                [this, this.data].forEach((o) => Object.defineProperty(o, ...defineArgs));
            }
            if (!this.container.$has('pricematch')) {
                throw new Error('Missing "pricematch" service');
            }
            return this;
        }
        /**
        * Register any application services/requirements.
        */
        register() {
            // Typically registration should happen just once
            if (this.data.registered) {
                return this;
            }
            // Super function flags registered=true
            super.register();
            // When the show process is completely finished
            this.container.bus.on(`thn:${this.data.name}.show#end`, ({ entry } = {}) => {
                // Given that we have an entry
                // not delegated, and processed
                if (entry
                    && !entry.state.delegated
                    && has(entry.state, 'showed')
                    && has(entry.state, 'status')) {
                    // Send the visit registry
                    this.sendStatus({ entry }).catch(() => { });
                    // Call the Google Analytics fn
                    if (entry.state.showed === true) {
                        this.container.sendSiteAnalytics(stringCapitalize(entry.data.actual.context.widgetName));
                    }
                }
            });
            // Register a listener for "visitor visit data" set,
            // which is the event triggered once a page changes and
            // the minimum visitor data has been set for that page.
            this.container.bus.on(['thn:visitor-visit-data.set'], () => {
                if (this.isTargetPage()) {
                    this.init().catch((reason) => this.logger.debug(reason));
                }
            });
            this.container.bus.on('window:message', (event) => {
                const debugPrefix = 'register()';
                const eventAction = event?.data?.action;
                if (!eventAction) {
                    return;
                }
                if (!eventAction?.match(/(after)?show_(price|package)_widget/)) {
                    return;
                }
                const [action, widgetName] = eventAction.split('_');
                if (widgetName !== this.data.name) {
                    return;
                }
                const eventEntry = event.data.entry;
                if (!eventEntry) {
                    this.logger.warn(debugPrefix, 'Cannot do work without an entry');
                    return;
                }
                this.logger.trace(debugPrefix, 'Handled event', event);
                if (action === 'show') {
                    // This message comes from a child script
                    // in order to delegate on us (the parent)
                    // the visualization of the widget
                    // Revive and incorporate the entry
                    const entry = this.searches.getEntry(event.data.entry || {});
                    this.searches.clearCurrentEntry();
                    // Update the entry to mark as "delegated"
                    entry?.update({ current: true, delegated: true });
                    // Proceed to visualization
                    this.setData({ entry }).show().catch(() => { });
                }
                else if (action === 'aftershow') {
                    // This message comes from a parent script
                    // in order to propagate the results of
                    // the visualization made in the parent
                    // Revive and reincorporate the entry
                    const entry = this.searches.getEntry(event.data.entry || {});
                    // Update the entry to "undelegate" it.
                    // Important: NEVER update the "current" state of this entry.
                    // The definitive source of truth for the "current" state is the "child" script.
                    entry?.update({ delegated: false });
                    // Finally trigger the side-effects as if
                    // show execution were made in this script.
                    // If the visualization was shown, emit
                    if (entry?.state.showed === true) {
                        // #default function execution hook
                        this.emit('show', { entry });
                    }
                    // In any case, end of show
                    // #end of function execution hook
                    this.emit('show#end', { entry });
                }
            });
            this.container.bus.on('window:message', this.onCompanionMessageActionHandler.bind(this));
            // register page unload action
            this.container.bus.on('thn:page.unload', () => this.destroy());
            return this;
        }
        /**
         * Initialize the widget.
         */
        async init(params) {
            const debugPrefix = 'init()';
            if (params) {
                sendSdkDeprecationError(this.container.errorMonitor);
                return this;
            }
            if (!this.container.globalState.initialized) {
                this.logger.warn(debugPrefix, 'Not allowed to execute before Agent start()');
                return this;
            }
            // log
            this.logger.info(`Initializing${this.data.initialized ? ' (again)' : ''}`);
            // Default to "reset=true" in general
            // only to "reset=false" for pages mode
            const shouldReset = this.data.mode !== 'pages';
            // initialize only the first time or if forced
            if (!this.data.initialized && shouldReset) {
                this.reset();
            }
            // mark as initialized
            this.data.initialized = true;
            // if mode is automatic
            if (this.data.mode === 'auto') {
                // observe
                this.observeDom();
            }
            // set data
            this.setData().show().catch(() => { });
            return this;
        }
        /**
         * Denotes if the widget data is set.
         */
        isSet(options = { acceptWithoutAvailability: false }) {
            if (options.acceptWithoutAvailability === true
                && this.data.noRooms === true) {
                return true;
            }
            const entry = this.searches.getCurrentEntry();
            return !!(entry
                && ((this.data.guests
                    && 'price' in this.data
                    && this.data.price
                    && this.data.dateBegin
                    && this.data.dateEnd) || isPagesLastSearchEntry(entry)));
        }
        /**
           * Denote if the object passed can be considered
           * an external params valid object.
           */
        // eslint-disable-next-line class-methods-use-this
        isValidParams(object) {
            // For now we just make a simple check
            return isPlainObject(object)
                && !empty(object)
                && !has(object, 'entry');
        }
        /**
           * Denote if the object passed can be considered
           * a "pw pages" global-tokens/data object.
           */
        // eslint-disable-next-line class-methods-use-this
        isPagesParams(object) {
            // For now we just make a simple check
            return has(object, 'prcPagesCache');
        }
        isSetAndLoaded(options = { acceptWithoutAvailability: true }) {
            // If no data is set, we are done
            if (!this.isSet(options)) {
                return false;
            }
            // Check if the current search entry
            // has successfully get a SSE response
            const entry = this.searches.getCurrentEntry();
            return !!(entry && entry.state.getOk);
        }
        reset({ onlyData = false, onlyUi = false, } = {}) {
            const debugPrefix = 'reset()';
            this.logger.debug(debugPrefix, 'Call');
            if (!onlyData) { // UI
                this.callView('reset', { debugPrefix });
            }
            if (!onlyUi) { // data
                this.searches.clearCurrentEntry();
                super.reset();
            }
            return this;
        }
        /**
           * Initialize/reset, set data and show the price widget.
           *
           * Does not apply if the widget is offline.
           */
        async update(params) {
            const debugPrefix = 'update()';
            this.logger.debug(debugPrefix, 'Call');
            if (params) {
                sendSdkDeprecationError(this.container.errorMonitor);
                return this;
            }
            if (!this.data.initialized) { // when not initialized, init will call setData, show, etc.
                // init
                await this.init().catch((e) => { throw e; });
                // otherwise:
                // 1 - remove (hides, resets data)
                // 2 - setData, show (shows only when set)
            }
            else {
                await this.destroy().setData().show();
            }
            return this;
        }
        /**
        * Sets the data when running in Price Widget Pages mode.
        */
        setPagesData(data) {
            // eslint-disable-next-line no-unused-vars
            const { entry, ...noEntryParams } = data;
            if (this.isValidParams(noEntryParams) && this.isPagesParams(noEntryParams)) {
                // In "pages" mode, "mode" is the only direct config
                // that we touch, all other config properties will
                // go in this.data.configPages (in the "delegation" way).
                // Note we want to allow reset() to go back to the "auto" mode.
                this.data.mode = 'pages';
            }
            this.setData(data).show().catch(() => { });
            return this;
        }
        /**
         * Set data and show the price widget only if data has changed.
         *
         * Fallsback to price.update if the widget is not visible.
         * @param [params] - The price widget data.
         */
        async refresh(params) {
            const debugPrefix = 'refresh()';
            this.logger.debug(debugPrefix, 'Call');
            try {
                const candidateSearch = this.getComposedData(params);
                const entry = this.searches.create(candidateSearch);
                const createdEntrySearch = entry.data.actual.search;
                const current = this.searches.getCurrentEntry();
                const currentEntrySearch = current?.data.actual.search;
                const hasChanged = current?.id !== entry.id
                    || (currentEntrySearch && 'price' in currentEntrySearch
                        && createdEntrySearch && 'price' in createdEntrySearch
                        && currentEntrySearch.price !== createdEntrySearch.price);
                if (!hasChanged) {
                    this.logger.debug(debugPrefix, 'Same data detected: aborted request');
                }
                else {
                    await this.reset().setData(candidateSearch).show();
                }
            }
            catch (e) {
                this.logger.debug(debugPrefix, 'No new valid data');
            }
            return this;
        }
        /**
        * Hides the DOM Node elements and resets data of the price widget.
        *
        * If the widget is iframed, messages the parent this call.
        * To delete the DOM elements use {@link module:widgets.Comparison#destroy}.
        *
        * @param reset - Reset the price widget data.
        */
        remove(reset = true) {
            const debugPrefix = 'remove()';
            this.logger.debug(debugPrefix, 'Call');
            // hide
            this.hide();
            // unset
            if (reset) {
                this.reset();
            }
            this.bubble({ action: `remove_${this.data.name}_widget` });
            return this;
        }
        /**
        * Deletes the DOM Node elements used by the widget.
        *
        * Removes the event listeners added by the widget {@link module:widgets.Comparison#unlisten}.
        *
        * Important Warning: this method doesn't call {@link module:widgets.Comparison#reset}
        * to avoid losing the PW data on SPA pages.
        */
        destroy() {
            const debugPrefix = 'destroy()';
            this.logger.debug(debugPrefix, 'Call');
            this.onDestroy();
            // Reset
            this.reset();
            // Exec the view's implementation of "destroy"
            this.callView('destroy', { debugPrefix });
            this.bubble({ action: `destroy_${this.data.name}_widget` });
            return this;
        }
        /**
        * Hides the DOM Node elements used by the widget.
        */
        hide() {
            const debugPrefix = 'hide()';
            // Exec the view's implementation of "hide"
            this.callView('hide', { debugPrefix });
            return this;
        }
        /**
        * Denotes if the PW should "bubble" to the parent window.
        */
        shouldBubble() {
            const viewFailure = this.callView('hasFailed');
            // By default "inliner" formats do not bubble, but can do it on errors
            return isIframed() && !!this.data.bubbles
                && (this.data.formatFamily?.substr(0, 1) !== 'i'
                    || viewFailure);
        }
        async processPricematch(entry) {
            const debugPrefix = 'processPricematch()';
            const metadata = entry.data?.actual?.metadata;
            const isPages = metadata && has(metadata, 'custom');
            if (isPages) {
                this.logger.debug(debugPrefix, 'Unsupported for "pages" mode');
                return undefined;
            }
            await this.container.pricematch
                .reset()
                .withSearch(entry.data.actual.search)
                .process(this.container.pricematch.data.tools);
            // Once the pricematch has been processed,
            // get the search results for the current search
            // including the calculated pricematches
            const pricematches = this.container.pricematch.data.tools
                .map((tool) => (tool.getState().toBeShown ? Number(tool.getId()) : undefined))
                .filter((value) => value && value !== undefined);
            return pricematches;
        }
        /**
        * Shows the price widget.
        *
        * Does not "display" if the widget is offline, but still makes de processing.
        * Creates the widget DOM elements if they don't exist ({@link module:widgets.Comparison#create}).
        * If the widget is iframed, messages the parent this call.
        */
        async show() {
            const debugPrefix = 'show()';
            const controller = new AbortController();
            const { signal } = controller;
            this.onDestroy(() => {
                controller.abort();
                this.logger.debug(debugPrefix, 'Aborted by destroy');
            });
            // #start of function execution hook
            this.emit('show#start');
            this.logger.debug(debugPrefix, 'Call');
            let entry;
            const end = ({ clean = true } = {}) => {
                if (entry && clean) {
                    entry.update({ showing: false });
                }
                // #end of function execution hook
                this.emit('show#end', { entry });
                return this;
            };
            if (!this.isSet({ acceptWithoutAvailability: true })) {
                this.logger.debug(debugPrefix, 'No data set');
                return end({ clean: false });
            }
            entry = this.searches.getCurrentEntry();
            // Not possible to execute show without an entry set
            if (!entry) {
                this.logger.debug(debugPrefix, 'No current entry');
                return end({ clean: false });
            }
            if (entry.state.showing) {
                this.logger.debug(debugPrefix, 'The same entry is already in process of showing');
                // Bubble the "show" operation **again**
                if (this.shouldBubble()) {
                    this.bubble({
                        action: `show_${this.data.name}_widget`,
                        // Avoid "The object could not be cloned" error
                        entry: JSON.parse(stringify(entry)),
                    });
                }
                return end({ clean: false });
            }
            if (has(entry.state, 'shown')) {
                this.logger.warn(debugPrefix, 'Show has already been called for this entry');
            }
            entry.update({ showing: true });
            // The normal flow to get the results
            // will be avoided when this entry has been
            // delegated by a child script
            // (because this section of work has been done already in the child)
            if (!entry.state.delegated) {
                // We MUST process the pricematch
                // here split from setData/getData in order to
                // not break the current synchronous PW API.
                // Note we are breaking the `show()` API now by returning a Promise,
                // but that is better that breaking ALL the other public methods :-Z
                const pricematchId = await this.processPricematch(entry);
                const originalWithPm = {
                    ...entry.data.original,
                    pricematchId,
                };
                // This is the heavy lifting: perform the search
                const getSearchResultsPromise = AbortablePromise.from(this.searches.get(originalWithPm));
                this.container.pageUnload(() => { getSearchResultsPromise.abort(); });
                try {
                    await getSearchResultsPromise;
                }
                catch (reason) {
                    if (reason instanceof AbortError) {
                        // When aborted: just end all, avoid processing status
                        return end();
                    }
                    // If the exception reason is another let's register it
                    this.container.errorMonitor.addError(reason);
                }
                // Once the search results resolve
                // If it went wrong, log it
                if (entry.state.getOk !== true) {
                    this.logger.warn(debugPrefix, `Error executing the Search: ${entry.debugId || 'Unknown debug id'}`);
                }
                if (signal.aborted) {
                    return end();
                }
                // Calculate the final status and shown prop
                this.processStatus(entry);
                this.logger.info(`PW debug: ${this.data.debugUrl || 'Unknown debug Url'}`);
                if (this.data.ddUrl) {
                    this.logger.debug(`Datadog: ${this.data.ddUrl}`);
                }
                // After processing:
                //
                // If it has been decided that PW should NOT be displayed, then depending on the
                // reason we end the processing, or continue.
                //
                // If the reason to not show was by "status != Ok", OR by
                // "the entry not being the current entry anymore", we can end.
                //
                // Otherwise we have to proceed to load the "views" etc _as if_ the PW
                // were going to be shown.
                // The reason to do that is to align the sendStatus call for control and variant cases.
                // Note this implies that the views **MUST** check the value of `entry.state.showed`
                // and early exit (do not mount components) if showed is false.
                const isOk = entry.state.status === PriceStatus.Ok;
                const isCurrent = entry.state.current === true;
                const couldShow = isOk && isCurrent;
                if (entry.state.showed !== true && !couldShow) {
                    return end();
                }
                // Obviously it has been decided that PW should be displayed, then we continue to load the view too.
            }
            entry.timer.time('show');
            const [, bundle] = await Promise$1.all([
                this.loadView(entry.data.actual.config.formatFamily), // load the view
                this.bundleForUi(entry),
            ]);
            const context = {
                bundle,
                debugPrefix,
                entry,
            };
            // If the visualization has to be done in the parent window
            if (this.shouldBubble()) {
                this.logger.debug(debugPrefix, 'Delegate visualization to parent');
                entry.update({ delegated: true, showing: false });
                this.bubble({
                    action: `show_${this.data.name}_widget`,
                    // Avoid "The object could not be cloned" error
                    entry: JSON.parse(stringify(entry)),
                });
                return end();
            }
            // And, Let's show!
            await this.callView('show', context);
            if (!entry.state.delegated) {
                // #default function execution hook
                this.emit('show', { entry });
            }
            else {
                // Pass the entry to the child
                this.transmit({
                    action: `aftershow_${this.data.name}_widget`,
                    // Avoid "The object could not be cloned" error
                    entry: JSON.parse(stringify(entry)),
                });
            }
            return end();
        }
        getActions(entry = this.searches.getCurrentEntry()) {
            const actions = [{
                    kind: AgentActionKind.Dismiss,
                }, {
                    kind: AgentActionKind.Engage,
                }];
            // For this searchEntry there is the possibility to apply a discount
            if (entry?.data.response?.priceMatch
                && 'vars' in entry.data.response.priceMatch
                && entry?.data.response?.priceMatch?.vars?.code) {
                actions.push({
                    kind: AgentActionKind.ApplyDiscount,
                    discountCode: entry.data.response.priceMatch.vars.code,
                    shouldSendActivity: true,
                });
            }
            // For this searchEntry the "gotoengine" button is active
            if (entry?.data.actual.config.gotoengine) {
                actions.push({
                    kind: AgentActionKind.OpenBookingEngine,
                    replayData: {
                        discount: {
                            id: null,
                            value: '',
                            kind: DiscountCodeKind$1.Default,
                        },
                    },
                    shouldSendActivity: true,
                });
            }
            // For this searchEntry the "save-your-search" feature is active
            if (entry?.data.actual.config.showSaveSearch) {
                actions.push({
                    kind: AgentActionKind.SendSaveSearch,
                    shouldSendActivity: true,
                });
            }
            // For this searchEntry the "contact us" feature is active
            if (entry?.data.actual.config.showContact) {
                actions.push({
                    kind: AgentActionKind.SendSiteContact,
                    shouldSendActivity: true,
                });
            }
            return actions;
        }
        async bundleForUi(entry) {
            const perks = await this.container.getPropertyPerks({
                propertyId: entry.data.actual.context.propertyId,
                ...pick(entry.data.actual.context, [
                    'language', 'country', 'logged',
                ]),
            });
            const bundle = {
                // Data
                ...pick(this.container.globalState, [
                    'prefix',
                    'host',
                ]),
                ...pick(entry.data.actual.context, [
                    'bookingSystem',
                    'country',
                    'language',
                    'widgetName',
                ]),
                ...pick(entry.data.actual.config, [
                    'closeTime',
                    'color',
                    'deviceCssSelector',
                    'deviceFormat',
                    'deviceMargin',
                    'devicePosition',
                    'deviceStyleConfig',
                    'formatFamily',
                    'formatName',
                    'gotoengine',
                    'gotoengineBtnText',
                    'mirrorRtlLang',
                    'showContact',
                    'showSaveSearch',
                    'showClosed',
                    'zIndex',
                ]),
                actions: [],
                browser: this.container.parseUserAgent?.()?.browser || 'Unknown',
                custom: entry.data.actual.metadata.custom,
                device: entry.data.actual.context.media,
                isRightAlign: !!(!empty(entry.data.actual.config.mirrorRtlLang)
                    && this.container.globalState.rightAlignLanguages?.includes(entry.data.actual.context.language)),
                logger: this.logger,
                overrides: collectionClone(entry.data.actual.context.overrides || {}),
                payload: collectionClone(entry.data.response || {}),
                perks,
                prcPagesCache: entry.data.actual.metadata.custom === false,
                numPerks: perks.length,
                terms: undefined,
            };
            let hasEngaged = false;
            let hasDismissed = false;
            const dismissHandler = async () => {
                if (hasEngaged || hasDismissed) {
                    return hasDismissed;
                }
                hasDismissed = await (entry.state.delegated
                    ? this.createDelegateeHandler(MESSAGE_ACTION_DISMISS, entry)()
                    : this.sendActivity(entry, { kind: AgentActionKind.Dismiss }));
                return hasDismissed;
            };
            const engageHandler = async () => {
                if (hasEngaged || hasDismissed) {
                    return hasEngaged;
                }
                hasEngaged = await (entry.state.delegated
                    ? this.createDelegateeHandler(MESSAGE_ACTION_ENGAGE, entry)()
                    : this.sendActivity(entry, { kind: AgentActionKind.Engage }));
                return hasEngaged;
            };
            const withExtraHandlers = (mainHandler, ...extraHandlers) => (async (...args) => {
                for (const extraHandler of extraHandlers) {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,no-await-in-loop
                    await extraHandler(...args);
                }
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-return
                return mainHandler(...args);
            });
            bundle.actions = this.getActions(entry).map((action) => {
                let handler;
                switch (action.kind) {
                    case AgentActionKind.ApplyDiscount:
                        if (entry.state.delegated) {
                            // If delegated, we inspect the context to see if application is possible
                            if (entry.data.actual.context.canApplyDiscount) {
                                // The parent script always commands the child to apply the discount
                                const applyDiscountHandler = this.createDelegateeHandler(MESSAGE_ACTION_APPLY_DISCOUNT, entry);
                                // The definitive handler simulates that Engage has been done
                                handler = withExtraHandlers(applyDiscountHandler, () => { hasEngaged = true; });
                            }
                        }
                        else {
                            // We only create a handler if we are sure we can apply
                            try {
                                const services = {
                                    createSearchReplay: this.container.createSearchReplay,
                                    logger: this.logger,
                                };
                                const applyDiscountHandler = once(createApplyDiscountHandler(action, services));
                                // The definitive handler includes a call to the next-gen Engage
                                handler = withExtraHandlers(applyDiscountHandler, engageHandler);
                            }
                            catch { /* empty */ }
                        }
                        break;
                    case AgentActionKind.Dismiss:
                        // Note: dismissHandler is aware of delegation state
                        handler = dismissHandler;
                        break;
                    case AgentActionKind.Engage:
                        // Note: engageHandler is aware of delegation state
                        handler = engageHandler;
                        break;
                    case AgentActionKind.OpenBookingEngine: {
                        if (entry.state.delegated) {
                            const openBookingEngineHandler = this.createDelegateeHandler(MESSAGE_ACTION_OPEN_BE, entry);
                            // The definitive handler simulates that Engage has been done
                            handler = withExtraHandlers(openBookingEngineHandler, () => { hasEngaged = true; });
                        }
                        else {
                            const services = {
                                createSearchReplay: this.container.createSearchReplay,
                                logger: this.logger,
                            };
                            const openBookingEngineHandler = createOpenBookingEngineHandler({
                                searchEntry: entry,
                                replayData: action.replayData,
                            }, services);
                            if (openBookingEngineHandler) {
                                // The definitive handler includes a call to the next-gen Engage
                                handler = withExtraHandlers(openBookingEngineHandler, engageHandler);
                            }
                        }
                        break;
                    }
                    case AgentActionKind.SendSaveSearch: {
                        if (entry.state.delegated) {
                            const sendSaveSearchHandler = this.createDelegateeHandler(MESSAGE_ACTION_SEND_SAVE_SEARCH, entry);
                            // The definitive handler simulates that Engage has been done
                            handler = withExtraHandlers(sendSaveSearchHandler, () => { hasEngaged = true; });
                        }
                        else {
                            const services = {
                                fetch: this.container.fetch,
                                logger: this.logger,
                                createSearchReplay: this.container.createSearchReplay,
                            };
                            const sendSaveSearchHandler = createSendSaveSearchHandler({
                                contextToken: entry.data.actual.context.contextToken,
                                searchEntry: entry,
                            }, services);
                            // The definitive handler includes a call to the next-gen Engage
                            handler = withExtraHandlers(sendSaveSearchHandler, engageHandler);
                        }
                        break;
                    }
                    case AgentActionKind.SendSiteContact: {
                        if (entry.state.delegated) {
                            const sendSiteContactHandler = this.createDelegateeHandler(MESSAGE_ACTION_SEND_SITE_CONTACT, entry);
                            // The definitive handler simulates that Engage has been done
                            handler = withExtraHandlers(sendSiteContactHandler, () => { hasEngaged = true; });
                        }
                        else {
                            const sendSiteContactHandler = createSendSiteContactHandler(this.container);
                            // The definitive handler includes a call to the next-gen Engage
                            handler = withExtraHandlers(sendSiteContactHandler, engageHandler);
                        }
                        break;
                    }
                }
                if (handler && !entry.state.delegated && action.shouldSendActivity) {
                    handler = this.withSendActivity(handler, action, entry);
                }
                return { ...action, handler };
            });
            // Validate price match
            if (entry?.data.response?.priceMatch
                && !(entry.data.response.priceMatch.message || ('vars' in entry.data.response.priceMatch && entry.data.response.priceMatch.vars))) {
                // register error
                this.logger.warn('bundleForUi()', 'priceMatch without vars or message');
                this.container.errorMonitor.addError(new Error('priceMatch without vars or message on Comparison.bundleForUi()'));
                // remove priceMatch so no other part of the app tries to use it
                // eslint-disable-next-line no-param-reassign
                delete entry.data.response.priceMatch;
            }
            if (entry.data.response?.priceMatch) {
                // Only on "inliner" formats
                if (bundle.formatFamily.substr(0, 1) !== 'i' && bundle.payload.hotel) {
                    // Reorder to bring the priceMatch original OTA to the first position
                    bundle.payload.hotel.prices = bundle.payload.hotel.prices.reduce((prices, price) => {
                        const method = price.id && price.id === bundle.payload.priceMatch?.priceId
                            ? 'unshift' : 'push';
                        prices[method]?.(price);
                        return prices;
                    }, []);
                }
            }
            // OTA prices mangling
            if (entry.data.actual.config.otaAnonym && bundle.payload.hotel?.prices) {
                bundle.payload.hotel.prices = bundle.payload.hotel.prices
                    .slice(0, 1);
                if (bundle.payload.hotel.prices.length) {
                    bundle.payload.hotel.prices[0].sourceAdvertiser = entry.data.actual.config.otaAnonymTexts?.[entry.data.actual.context.language]
                        || entry.data.actual.config.otaAnonymTexts?.en
                        || 'Other websites';
                }
            }
            // Terms and conditions
            if (entry.data.actual.config.termsActive
                && entry.data.actual.context.terms?.[entry.data.actual.context.language]) {
                bundle.terms = collectionClone(entry.data.actual.context.terms[entry.data.actual.context.language]);
                bundle.terms.isUrl = isUrl(bundle.terms.prcSsTermsText);
            }
            return bundle;
        }
        processStatus(entry) {
            // #start of function execution hook
            this.emit('process-status#start');
            const debugPrefix = 'processStatus()';
            this.logger.debug(debugPrefix, 'Call');
            const end = () => {
                // #end of function execution hook
                this.emit('process-status#end', { entry });
                return this;
            };
            if (entry.state.processed) {
                return end();
            }
            // Keep this event for backwards compatibility
            trigger(`thn_widgets_${this.data.name}_process_status`, {});
            // #default of function execution hook
            this.emit('process-status', { entry });
            if (this.shouldPreventShow()) {
                entry.update({ status: 'excluded-other' });
            }
            // IMPORTANT: the status will be forced to "price-offline"
            // by the backend, we don't do it anymore here
            if (entry.state.status === '') {
                entry.update({ status: 'widget-ok' });
            }
            else if (!entry.state.status) {
                // TODO: agree on a status for this situation
                entry.update({ status: 'error' });
            }
            // Note other "normal" status will be already placed
            // into `entry.state.status`, no need to update status
            // Mark as "showed" (this is conceptually a equivalent to toBeShown) if:
            // 1 - getting the search results went ok
            // 2 - the widget is online
            // 3 - the visitor is not selected for control when AB testing
            // 4 - backend status is exactly "widget-ok"
            // Note still the PW may not show if the UI module fails
            entry.update({
                processed: true,
                showed: entry.state.current === true
                    && entry.state.getOk === true
                    && this.isOnline()
                    && !entry.data.actual.context.isAbTestControlUser
                    && entry.state.status === 'widget-ok',
            });
            return end();
        }
        /**
        * Minimizes the price widget.
        *
        * If the widget is iframed, messages the parent this call.
        */
        minimize() {
            const debugPrefix = 'minimize()';
            const bubbled = this.bubble({ action: `minimize_${this.data.name}_widget` });
            if (!bubbled) {
                this.callView('minimize', { debugPrefix });
            }
            return this;
        }
        /**
        * Setup DOM observers needed for the price widget.
        *
        * Should not be called directly, its called by {@link module:widgets.Comparison#init}.
        * Each booking system has its own independent actions.
        * This function might do nothing.
        *
        * Notice: when using callbacks, remember NOT to use `this` to reference
        * the price widget. Instead use the full namespace `thn.widgets.price`
        * or you may use the `widget` alias.
        */
        observeDom() {
            const debugPrefix = 'observeDom()';
            const method = `${this.data.name}ObserveDom`;
            // Engine
            const context = {
                debugPrefix,
                widget: this,
            };
            this.logger.debug(debugPrefix, 'Call');
            this.container.callEngine.call(this, method, context);
            return this;
        }
        assertValid(data) {
            return this.searches.create({
                ...this.getIndirectDataForValidation(),
                ...data,
            });
        }
        isEnough(params, { acceptWithoutAvailability = true } = {}) {
            let enough = false;
            try {
                const entry = this.searches.create({
                    contextToken: this.container.globalState.contextToken,
                    hotelId: this.container.globalState.hotelId,
                    fingerprint: this.container.globalState.fingerprint,
                    propertyId: this.container.globalState.propertyId,
                    visitDate: this.container.globalState.pageLoadTime,
                    ...params,
                });
                const unacceptableStatus = [undefined];
                if (acceptWithoutAvailability === false) {
                    unacceptableStatus.push(PriceStatus.WithoutAvailability);
                }
                // If the creation doesn't throw and
                // has price or is an (acceptable) direct status
                // this should be enough
                enough = !!('price' in entry.data.actual.search && entry.data.actual.search.price)
                    || !unacceptableStatus.includes(entry.state.status);
            }
            catch (e) { /* empty */ }
            return enough;
        }
        /**
        * Set price widget configuration.
        *
        * @param params - Config data to be set.
        */
        setConfig(params) {
            if (this.isValidParams(params)) {
                if (this.isPagesParams(params)) {
                    // In "pages" mode, "mode" is the only direct config
                    // that we touch, all other config properties will
                    // go in this.data.pages (in the "delegation" way).
                    // Note we want to allow reset() to go back to the "auto" mode.
                    this.data.mode = 'pages';
                }
                else {
                    this.setup({
                        container: this.container,
                        extend: true,
                        source: {
                            initData: { ...this.__init, ...params },
                        },
                    });
                }
            }
            return this;
        }
        getDetectedData() {
            if (this.data.mode === 'datalayer') {
                return this.getDetectedDatalayerData();
            }
            if (this.data.mode === 'pages') {
                return this.getDetectedPagesData();
            }
            return this.getDetectedEngineData();
        }
        getDetectedPagesData() {
            const debugPrefix = 'getDetectedPagesData()';
            this.logger.debug(debugPrefix, 'Call');
            const { search } = comparisonStandardModel.transform(this.data.configPages);
            return search;
        }
        getDetectedDatalayerData() {
            const debugPrefix = 'getDetectedDatalayerData()';
            this.logger.debug(debugPrefix, 'Call');
            const thnDatalayerData = this.container.dataLayerHelper.get('thn') || {};
            return datalayerEventSearchModel.transform(thnDatalayerData, { strict: true });
        }
        /**
        * Gets the search data detected via Engine.
        */
        getDetectedEngineData() {
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            const widget = this;
            const debugPrefix = 'getDetectedEngineData()';
            // Not possible to proceed without an engine
            if (!this.container.$has('engine')) {
                return {};
            }
            const context = {
                widget,
                debugPrefix,
            };
            const end = (data) => {
                let strippedData = data;
                if (data.roomsDispo && (data.adults || data.babies || data.children || data.guests || data.rooms)) {
                    this.logger.debug(context.debugPrefix, 'Warn: roomsDispo and plain guests/rooms props are mutually exclusive.');
                    this.logger.debug(context.debugPrefix, 'Stripping the plain props from:', data);
                    strippedData = omit(data, [
                        'adults',
                        'babies',
                        'children',
                        'guests',
                        'rooms',
                    ]);
                    this.logger.debug(context.debugPrefix, 'Stripped result:', strippedData);
                }
                return strippedData;
            };
            const method = `${this.data.name}ParseData`;
            // This is the classical engine with only one
            // "priceParseData" or "packageParseData" function
            if (has(this.container.engine, method)) {
                const detectedData = this.callEngine(method, context) || {};
                Object.assign(detectedData, { priceVersion: '0' });
                return end(detectedData);
            }
            // This engine doesn't implement the classical function
            // but it might implement "multiple" versions of the function
            // in the form or "priceParseData_v1", "priceParseData_v2", ...
            // Those are "candidate" functions. We'll execute them
            // until one delivers a valid result
            const compatible = new RegExp(`^${method}_v\\d+$`);
            const candidates = Object.keys(this.container.engine).filter((key) => compatible.test(key) && isFunction(widget.container.engine[key]));
            let detectedData;
            // Try the candidates until the first one succeeds
            const success = candidates.some((candidate) => {
                // All candidate functions end with digits that identify them uniquely
                const candidateVersion = candidate.match(/\d+$/)?.[0];
                // Do the execution as if it where the classical "only one"
                const candidateDetectedData = widget.container.callEngine.call(widget, candidate, context);
                // If it produced some good results, set detectedData, set version, and end
                // Note: explicit strict set=false is a signal of bad result,
                // any other value or absence of value is OK
                if (isPlainObject(candidateDetectedData)
                    && candidateDetectedData.set !== false
                    && widget.isEnough(candidateDetectedData)) {
                    detectedData = candidateDetectedData;
                    detectedData.priceVersion = candidateVersion;
                    return true;
                }
                return false;
            });
            if (!success && !empty(candidates)) {
                this.logger.warn(context.debugPrefix, 'All engine versions failed:', candidates);
            }
            return end(detectedData || {});
        }
        /**
        * Obtains the relevant data to make a search.
        *
        * The relevant data is composed of "indirect" or
        * more general/contextual information, plus the
        * "detected" data that is indeed the search itself
        * detected by the engine.
        *
        * Notable exception not included in this composed
        * data is the pricematchId(s), because that is
        * async data (momentjs dependant).
        *
        * @param params- Search data. If the
        *  argument is not present, engine parsing is triggered.
        */
        getComposedData(params) {
            // Only when params are not passed
            // we detect them automatically
            if (!this.isValidParams(params)) {
                // eslint-disable-next-line no-param-reassign
                params = this.getDetectedData();
            }
            const composed = {
                ...this.getIndirectData(),
                ...params,
            };
            // Special handling for `priceSpecial` **double special** ;-)
            //
            // If "priceSpecial" is not set by the engine:
            // - and "shouldPreventShow" returns true, then by convention we set a "priceSpecial=1"
            // - and some discount code exists, then by convention we set a "priceSpecial=2"
            //
            // The engines can set a "priceSpecial" value, even to 0. In that
            // case this default behaviour will not be triggered. This way
            // engines keep control of the situation.
            if (composed.priceSpecial === undefined) {
                if (this.shouldPreventShow()) {
                    composed.priceSpecial = 1;
                }
                if (composed.promocode) {
                    composed.priceSpecial = 2;
                }
            }
            return composed;
        }
        /**
        * Try to register a search.
        *
        * @param params - The search data.
        */
        attemptAddSearch(params) {
            let search;
            try {
                // Try to add the search
                if (params && params.entry && this.searches.isEntry(params.entry)) {
                    // Special case when an entry has been passed
                    search = params.entry;
                }
                else {
                    // Regular behaviour to "build" the search (using any optional param)
                    search = this.getComposedData(params);
                }
                this.searches.add(search).catch(() => { });
            }
            catch (error) {
                if (!error || (error instanceof Error && error.message !== 'invalid-data')) {
                    throw error; // Unexpected
                }
                // Expected invalid data
                search = undefined;
            }
            return search;
        }
        setData(params) {
            const debugPrefix = 'setData()';
            this.logger.debug(debugPrefix, 'Call');
            const previousEntryExists = !!this.searches.getLatestEntry((entry) => !!(
            // Must have search data
            entry?.data?.actual?.search
                // Must belong to the current Site
                && entry.data.actual.context?.propertyId === this.container.globalState.propertyId
                // Must not be of "pages" type
                && !('custom' in entry.data.actual.metadata)));
            const initialEntry = this.searches.getCurrentEntry();
            let search;
            if (params && this.isPagesParams(params) && this.data.mode === 'pages') {
                // Set the data in a "delegation" way
                this.data.configPages = comparisonPagesModel.transform(params);
            }
            else if (this.data.mode !== 'pages') {
                // Regular behaviour is to try to add the search using params
                search = this.attemptAddSearch(params || {});
            }
            let detectedData;
            // If the search data has been already set
            // do not execute the booking system detection
            if (!search && this.data.mode !== 'manual') {
                detectedData = this.getDetectedData();
                this.logger.debug(debugPrefix, 'Detected data:', detectedData);
                if (detectedData.set === false) {
                    // No need to try to add the search
                    search = false;
                }
                else {
                    // Try to add the search
                    search = this.attemptAddSearch(detectedData);
                }
            }
            // Exit
            if (search === false) {
                this.logger.debug(debugPrefix, 'Not setting. Reason: engine');
                return this;
            }
            // Exit
            if (search === undefined) {
                this.logger.debug(debugPrefix, 'Not setting. Reason: no enough valid data');
                return this;
            }
            // At this point, a search was set successfully
            this.printSearch();
            const currentEntry = this.searches.getCurrentEntry();
            // Emit the good news
            this.emit('set', {
                // @ts-ignore - At this point TS cannot differ if Price, Package or Booking widget data is seted
                changed: !!(previousEntryExists && (!initialEntry || initialEntry.id !== currentEntry?.id)),
                data: currentEntry?.data.actual.search,
                entry: currentEntry,
                firstTime: !initialEntry,
                firstTimeEver: !previousEntryExists,
            });
            return this;
        }
        /**
        * Get the non-search data in the current execution context.
        */
        getIndirectData(disregardMode = false) {
            // Try to generate a replaySearch with a fake code and a fake search
            const fakeSearch = {
                dateBegin: '1970/01/01',
                dateEnd: '1970/01/02',
                adults: 2,
                children: 0,
                currency: 'EUR',
                rooms: 1,
                roomsDispo: [{ adults: 1, children: 0, childrenAges: [] }],
            };
            const replayResult = this.container.createSearchReplay({ search: fakeSearch, discount: { id: null, value: 'FAKECODE', kind: DiscountCodeKind$1.Default } });
            const promocodeData = this.getPromocode();
            const widget = this.container.price || this;
            let saveSearchBaseUrl;
            switch (widget.data?.ssUrlOption) {
                case 1:
                    // SS Option 1: Homepage
                    saveSearchBaseUrl = this.container.globalState.hotelUrl;
                    break;
                case 2:
                    // SS Option 2: Custom URL
                    // "ssCustomUrl" will contain literally the URL to be used
                    saveSearchBaseUrl = widget.data.ssCustomUrl;
                    break;
                case 3: {
                    // SS Option 3: JavaScript variable
                    // "ssJsUrl" will contain the name of the variable to
                    // be evaluated in order to obtain the final URL to be used
                    const unkownToken = get(this.container.globalThis, widget.data.ssJsUrl);
                    if (isFunction(unkownToken)) {
                        saveSearchBaseUrl = unkownToken();
                    }
                    else if (unkownToken) {
                        saveSearchBaseUrl = String(unkownToken);
                    }
                    break;
                }
            }
            const { globalState } = this.container;
            const data = {
                abTest: this.data.abTest,
                // Assume we can apply a discount code if a replayFn/replayMethod exists
                canApplyDiscount: !!replayResult?.replayMethod,
                closeTime: this.data.closeTime,
                cssSelector: this.data.cssSelector,
                deviceCssSelector: this.data.deviceCssSelector, // influenced by pages
                deviceFormat: this.data.deviceFormat, // influenced by pages
                deviceMargin: this.data.deviceMargin, // influenced by pages
                devicePosition: this.data.devicePosition, // influenced by pages
                deviceStyleConfig: this.data.deviceStyleConfig, // influenced by pages
                ip: globalState.visitor?.ip,
                isAbTestControlUser: this.isControlUser(),
                formatFamily: this.data.formatFamily,
                formatName: this.data.formatName,
                geolocationId: globalState.visitor?.geolocation?.geolocationId,
                gotoengineBtnText: this.data.gotoengineBtnText,
                hotelId: globalState.hotelId,
                location: this.container.globalThis.location.href,
                logged: !!this.container.isUserLogged(),
                media: globalState.media?.name,
                mirrorRtlLang: this.data.mirrorRtlLang,
                mobileCssSelector: this.data.mobileCssSelector,
                mobileMargin: this.data.mobileMargin,
                // Note online props are NOT the direct config value
                // instead we collect the effective "online" final value
                mobileOnline: this.isOnline(), // influenced by pages
                mobilePosition: this.data.mobilePosition,
                mobileStyleConfig: this.data.mobileStyleConfig,
                nolog: this.container.isNolog(),
                // Note online props are NOT the direct config value
                // instead we collect the effective "online" final value
                online: this.isOnline(), // influenced by pages
                origin: globalState.visitor?.tracker?.isSessionFirstVisit,
                otaAnonym: this.data.otaAnonym,
                otaAnonymTexts: this.data.otaAnonymTexts,
                pageId: globalState.pageId, // replaced by pages
                pageName: globalState.pageName,
                priceNight: this.data.priceNight,
                priceRoom: this.data.priceRoom,
                promocode: promocodeData?.promocode,
                promocodeType: promocodeData?.promocodeType,
                propertyId: this.container.globalState.propertyId, // replaced by pages
                referrer: this.container.globalThis.document.referrer,
                searchUrl: this.container.getSetting('search_url'),
                scriptVersion: globalState.versionReal,
                saveSearchBaseUrl,
                showClosed: this.data.showClosed,
                showContact: this.data.showContact,
                showSaveSearch: this.data.showSaveSearch,
                styleConfig: this.data.styleConfig,
                termsActive: this.data.termsActive,
                visitDate: globalState.pageLoadTime,
                visitorLastComparison: globalState.visitor?.lastComparison,
                widgetName: this.data.name,
                zIndex: this.data.formatFamily?.substr(0, 1) !== 'i'
                    ? (this.container.getSetting(`${this.data.name}_z_index`) || this.data.defaultZIndex)
                    : (this.container.getSetting(`${this.data.name}_inliner_z_index`) || 'auto'),
                ...pick(globalState, [
                    'accountKey',
                    'bookingSystem',
                    'contextToken',
                    'country',
                    'fingerprint',
                    'hotelCurrency',
                    'language',
                    'overrides',
                    'promocodeVars',
                    'terms',
                ]),
                ...pick(this.data, [
                    'gotoengine',
                    'margin',
                    'position',
                ]),
            };
            // When the PW widget is in "pages" mode, It must override some of its configs
            // with the ones configured in the "pages" object.
            // Although PW might be on "pages" mode, we still might want to get the "general"
            // config on our entry. For those cases we use the `disregardMode = true` parameter.
            const pagesData = this.data.mode === 'pages' && this.data.configPages && disregardMode === false
                ? {
                    ...pick(this.data.configPages, [
                        'closeTime',
                        'cssSelector',
                        'custom', // indicates the "pages" internal mode
                        'gotoengine',
                        'gotoengineBtnText',
                        'margin',
                        'mobileCssSelector',
                        'mobileMargin',
                        'mobilePosition',
                        'mobileStyleConfig',
                        'noCheapest', // non-existing in "auto" mode
                        'pageId', // Context
                        'position',
                        'priceNight',
                        'propertyId', // Context
                        'showClosed',
                        'showContact',
                        'showSaveSearch',
                        'styleConfig',
                    ]),
                    // Stuff that doesn't make sense on "pages"
                    abTest: undefined,
                    isAbTestControlUser: undefined,
                    promocode: undefined,
                    promocodeType: undefined,
                } : {};
            return {
                ...data,
                ...pagesData,
            };
        }
        /**
        * Get the required minimal non-search data in the current execution context.
        */
        getIndirectDataForValidation() {
            return this.getIndirectData(true);
        }
        printSearch() {
            const data = this.data;
            // Build the regular info msg
            let infoMsg = `
   Price   : ${data.price ?? ''} ${data.currency} ${data.priceType ? `(${data.priceType})` : ''}${data.priceSpecial ? ` *special* ${data.priceSpecial}` : ''}
   Dates   : ${data.dateBegin} - ${data.dateEnd}
   Guests  : ${data.guests ?? ''} (${data.adults ?? ''} adults, ${data.children ?? ''} children)
   Rooms   : ${(data.rooms || (data.roomsDispo && data.roomsDispo.length)) ?? ''}
   Lang    : ${('language' in data && data.language) || this.container.globalState.language}
   Is set  : ${this.isSet({ acceptWithoutAvailability: true }) ? 'Yes' : 'No'}
   No rooms: ${data.noRooms ? 'Yes' : 'No'}`;
            // Add flight info for PWP
            if (data.name === WidgetsList.Package) {
                infoMsg += `
   Origin  : ${('flightOrigin' in data && data.flightOrigin) || ''}
   Destinat: ${('flightDestination' in data && data.flightDestination) || ''}`;
            }
            // Special case for "pages" in "last-search" mode
            if (this.data.mode === 'pages'
                && this.data.configPages
                && this.data.configPages.custom === false) {
                infoMsg = `
   Last search: Yes (automatic data)`;
            }
            this.logger.info('Data actually set:', infoMsg);
            if (data.roomsDispo) {
                this.logger.info(' Ages by room: ', data.roomsDispo);
            }
            if (data.roomDetails) {
                this.logger.info(' Prices by room: ', data.roomDetails);
            }
        }
        /**
        * Send the result of the search evaluation (using the Searches class).
        * AKA: add-visit, tool-ack
        */
        async sendStatus({ entry } = {}) {
            const debugPrefix = 'sendStatus()';
            this.logger.debug(debugPrefix, 'Call');
            // "just in case" call the main visit always
            this.container.sendPageVisit();
            if (!entry) {
                this.logger.warn(debugPrefix, 'Error: missing required entry');
                return this;
            }
            if (entry.state.visit) {
                this.logger.debug(debugPrefix, 'Entry already visiting');
                return this;
            }
            if (entry.state.visited) {
                this.logger.debug(debugPrefix, 'Entry already visited');
                return this;
            }
            // eslint-disable-next-line no-param-reassign
            entry.times.show = entry.timer.timeEnd('show');
            // eslint-disable-next-line no-param-reassign
            entry.times['total (ex visit)'] = entry.timer.timeLog('total');
            this.logger.info(`Search ${entry.debugId || 'Unknown debug id'}`);
            this.logger.info(`Showed: ${entry.state.showed ? 'Yes' : 'No'} - Status: ${entry.state.status || 'Unknown status'} - ABTest: ${entry.data.actual.context.isAbTestControlUser ? 'Yes' : 'No'}`);
            await this.searches.visit(entry);
            const timeDetail = Object.keys(entry.times)
                .map((key) => {
                const milliseconds = entry.times[key];
                if (empty(milliseconds)) {
                    return '';
                }
                const seconds = milliseconds / 1000;
                const percent = (milliseconds / entry.times.total) * 100;
                return `\t* ${key}: ${milliseconds}ms ${seconds.toFixed(2)}s (${percent.toFixed(1)}%)`;
            }).filter((d) => d).join('\n');
            this.logger.debug(debugPrefix, `Search ${entry.debugId || '-'} timing: \n${timeDetail}`);
            const logDetail = entry.logger.get().map(([date, msg]) => ` ${(new Date(date)).toISOString().split('T')[1]}: ${msg}`).join('\n');
            // TODO: correct this manual definition of the log prefix
            this.logger.openDebugGroup?.(`[thn][${this.data.name}] Search ${entry.debugId || '-'} details:`);
            this.logger.debug(logDetail);
            this.logger.closeDebugGroup?.();
            // Sending the status to GA: simulate the data as seen in Admin
            const analyticsPayload = {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                property_id: entry.data.actual.context.propertyId, // backwards compat
                propertyId: entry.data.actual.context.propertyId,
                status: this.isOnline() ? entry.state.status : 'price-offline',
                shown: entry.state.showed,
            };
            // Note: only visitors who would see the PW are part of test/control groups,
            // otherwise we don't attach an "ab_test" field.
            if (analyticsPayload.status === 'widget-ok') {
                const abTest = !!entry.data.actual.context.isAbTestControlUser;
                analyticsPayload.abTest = abTest;
                // Send the param also in snake_case format to be compatible with the legacy format values that we were sending to GA
                analyticsPayload.ab_test = abTest;
            }
            this.container.sendSiteAnalytics(`${stringCapitalize(entry.data.actual.context.widgetName)}Status`, analyticsPayload);
            return this;
        }
        /**
        * Record a widget event.
        */
        sendActivity(entry, details = {}) {
            const payload = {
                contextToken: entry.data.actual.context.contextToken,
                eventName: ActivityKind$1.Action,
                eventDetails: details,
                searchId: entry.data?.request?.data?.params?.search_id,
                widgetName: entry.data.actual.context.widgetName,
            };
            const analyticsPayload = {
                searchId: payload.searchId,
                nonInteraction: false,
                propertyId: entry.data.actual?.context?.propertyId,
                type: payload.widgetName,
                details,
            };
            this.container.sendSiteAnalytics(AnalyticsEventName.Activity, JSON.parse(stringify(analyticsPayload)));
            return this.sendBeacon('/agent/ack/activity', JSON.parse(stringify(payload)));
        }
        /**
        * Creates a handler that will transmit the action
        * from the delegatee agent to the original agent.
        *
        * TODO: currently this handlers will transmit the action
        * without waiting for a result. Thus they always resolve to true.
        */
        createDelegateeHandler(action, searchEntry) {
            return async (data) => {
                this.logger.debug(`Transmit ${action} to companion (searchEntryId: ${searchEntry.id || '-'})`);
                this.transmit({
                    action,
                    payload: {
                        data,
                        searchEntryId: searchEntry.id,
                        widgetName: searchEntry.data.actual.context.widgetName,
                    },
                });
                return true;
            };
        }
        async onCompanionMessageActionHandler(event) {
            if (!event?.data?.action) {
                return;
            }
            const expectedActionHandler = this.actionToHandler[event?.data?.action];
            // Return if we can't map the received action
            if (!expectedActionHandler) {
                return; // unlogged to avoid noise
            }
            const { action, payload, } = event.data;
            // Origin of the message needs to be from this widget
            if (payload.widgetName !== this.data.name) {
                return; // unlogged to avoid noise
            }
            const log = (msg) => {
                if (msg) {
                    this.logger.debug(`Received companion request for action "${action}"`);
                    this.logger.debug('Payload:', payload);
                    this.logger.debug(`Result: ${msg}`);
                }
            };
            // Get the search entry
            const searchEntry = this.searches.getLatestEntry((entry) => entry.id === payload.searchEntryId);
            if (!searchEntry) {
                return log('KO, unknown search entry');
            }
            // Get a bundle for that entry
            const bundle = await this.bundleForUi(searchEntry);
            // Locate the bundle action to execute its handler
            const bundleAction = bundle.actions.find((a) => a.kind === expectedActionHandler);
            if (!(bundleAction && 'handler' in bundleAction)) {
                return log('KO, handler missing from bundle');
            }
            // execute
            bundleAction.handler?.(payload.data);
            return log('OK');
        }
        getData() {
            // "pages" mode acts similar to "delegation"
            // the source for the "online"/"mobileOnline" props
            // is not any more the the widget.data but the
            // widget.data.pages object
            if (this.data.mode === 'pages' && this.data.configPages) {
                return this.data.configPages;
            }
            return super.getData();
        }
        shouldPreventShow() {
            return !!this.container.getSetting(`${this.data.name}_location_forbidden`)?.exec(this.container.globalThis.location.href);
        }
    };
})();

/**
 * The Package widget (PWP).
 */
class Package extends Comparison {
    get __default() {
        return {
            ...super.__default,
            name: 'package',
            // This property is used to override the widget name
            // when retrieving a view. That is the first
            // part in the tuple `widgetName-formatFamily`
            // Example of view file name: "price-landscape.js"
            viewCategory: 'price',
            prefix: 'pwp_',
            id: 'eighty_hotel_package_check_widget',
            pages: [PageName.Packages],
        };
    }
    /**
     * Denotes if the widget data is set.
     */
    isSet(options) {
        // Call "super"
        const result = super.isSet(options);
        return !!(result
            && 'flightOrigin' in this.data && this.data.flightOrigin
            && 'flightDestination' in this.data && this.data.flightDestination);
    }
    /**
     * Denotes if the package widget data is sufficient to be set.
     */
    isEnough(params) {
        const data = params || this.data;
        // Call "super"
        const result = super.isEnough(params);
        return !!(result
            && data.flightOrigin && data.flightDestination);
    }
}

/**
 * The Price widget.
 *
 * @class
 * @extends module:widgets.Comparison
 */
class Price extends Comparison {
    get __default() {
        return {
            ...super.__default,
            pages: [PageName.RoomsAndRates],
        };
    }
    /**
     * Register any application services/requirements.
     */
    register() {
        const debugPrefix = 'register()';
        // Typically registration should happen just once
        if (this.data.registered) {
            return this;
        }
        // Super function flags registered=true
        super.register();
        this.container.bus.on(['thn:visitor-visit-data.set'], () => {
            const pageName = this.container.globalState?.pageName;
            const fixedPage = pageName && this.data.fixedPages?.find((p) => p.pageName === pageName);
            if (!empty(fixedPage)) {
                this.logger.debug(debugPrefix, `Page configured with PW pages of type: "${empty(fixedPage.prcPagesCache) ? 'custom' : 'last-search'}"`);
                this.setPagesData(fixedPage);
            }
        });
        return this;
    }
}

/* eslint-disable no-underscore-dangle */
/**
 * Pricematch widget.
 */
class Pricematch extends WidgetWithTools {
    get __default() {
        return {
            ...super.__default,
            abTest: false,
            name: WidgetsList.PriceMatch,
            online: 1,
        };
    }
    /**
     * Get the list of rules to fulfill to show a "Price Match".
     */
    getRules() {
        const { rulesCollection } = this;
        return [
            rulesCollection.scheduledDates,
            rulesCollection.scheduledDays,
            rulesCollection.scheduledTime,
            rulesCollection.originMatch,
            rulesCollection.retargeting,
            rulesCollection.visitorRegistrationStatus,
            rulesCollection.geolocation,
            rulesCollection.urlVariables,
            rulesCollection.datalayerVariables,
            rulesCollection.soldout,
            rulesCollection.priceRange,
            rulesCollection.occupancyAdults,
            rulesCollection.occupancyChildren,
            rulesCollection.occupancyRooms,
            rulesCollection.daysSinceLastVisit,
            rulesCollection.daysUntilCheckin,
            rulesCollection.lengthOfStay,
            rulesCollection.searchDates,
            rulesCollection.searchDays,
            rulesCollection.userPastVisits,
        ];
    }
    reset() {
        const debugPrefix = 'reset()';
        this.logger.debug(debugPrefix, 'Call');
        // Call super
        super.reset();
        // Reset tools
        this.setTools(this.data.tools);
        // Reset manually set PW data
        this.withSearch();
        return this;
    }
    setup(...args) {
        const debugPrefix = 'setup()';
        this.logger.debug(debugPrefix, 'Call');
        super.setup(...args);
        this.reset();
        return this;
    }
    async show() {
        const debugPrefix = 'show()';
        this.logger.debug(debugPrefix, 'Not implemented');
    }
    sendStatus() {
        const debugPrefix = 'sendStatus()';
        this.logger.debug(debugPrefix, 'Not implemented');
        return false;
    }
    withSearch(data) {
        const isReplaced = has(this, '__container');
        // Option 1: restore container
        if (empty(data)) {
            if (isReplaced) {
                this.container = this.__container;
                delete this.__container;
            }
            return this;
        }
        // Option 2: replace the original container
        if (!isReplaced) {
            this.__container = this.container;
        }
        this.container = Object.create(this.__container || null);
        Object.defineProperty(this.container, 'price', {
            value: {
                data,
                getData() {
                    return this.data;
                },
                isSet() {
                    return true;
                },
                validate() {
                    return this.data;
                },
            },
        });
        return this;
    }
    process(tools) {
        const debugPrefix = 'process()';
        if (!Array.isArray(tools) || tools.length === 0) {
            this.logger.trace(debugPrefix, 'Abort: you must pass tools explicitly');
            return Promise$1.resolve();
        }
        return super.process(tools);
    }
}

/**
 * The Review widget.
 */
class Review extends WidgetWithView {
    get __default() {
        return {
            ...super.__default,
            abTest: 0,
            bubbles: false,
            closeTime: 0,
            cssSelector: '',
            desktopDefaultZIndex: 99999,
            mobileDefaultZIndex: 99999,
            defaultFormat: 11,
            formats: {
                11: { name: 'box', family: 'pcomponents' },
                13: { name: 'inliner', family: 'ipcomponents' },
                14: { name: 'fixedbar', family: 'pcomponents' },
                15: { name: 'sidetab', family: 'pcomponents' },
            },
            id: 'eighty_hotel_reviews_widget',
            initialized: false,
            mobileCssSelector: '',
            mobileOnline: 0,
            mobilePosition: 'BT',
            mobileStyleConfig: null,
            name: 'review',
            online: 0,
            pages: undefined,
            position: 'LL',
            showClosed: 0,
            showSummarized: 0,
            showReviews: 0,
            showed: undefined,
            status: undefined,
            styleConfig: null,
        };
    }
    get __computed() {
        const isMobile = () => this.container.globalState.media?.name === 'mobile';
        const resolvePropName = (propName) => camelCase(`${isMobile() ? 'mobile_' : ''}${propName}`);
        const resolve = (propName) => this.data[resolvePropName(propName)];
        return {
            ...super.__computed,
            // Not bound: "this" refers to the widget "data" property
            formatName: decoratePropertyDescriptor({
                get() {
                    return this.formats[this.deviceFormat]?.name;
                },
            }),
            formatFamily: decoratePropertyDescriptor({
                get() {
                    return this.formats[this.deviceFormat]?.family;
                },
            }),
            // Bound: "this" refers to the widget instance
            deviceCssSelector: decoratePropertyDescriptor({
                get: () => resolve('cssSelector'),
            }),
            deviceFormat: decoratePropertyDescriptor({
                get: () => {
                    const selectedFormatName = this.data.deviceStyleConfig?.template;
                    const found = Object.entries(this.data.formats)
                        .find(([_key, value]) => value.name === selectedFormatName);
                    return (found && Number(found[0])) || this.data.defaultFormat;
                },
            }),
            deviceMargin: decoratePropertyDescriptor({
                get: () => resolve('margin'),
            }),
            devicePosition: decoratePropertyDescriptor({
                get: () => {
                    const position = resolve('position');
                    return this.data.isRightAlign ? mirrorPosition(position) : position;
                },
            }),
            deviceStyleConfig: decoratePropertyDescriptor({
                get: () => resolve('styleConfig'),
            }),
        };
    }
    /**
     * Register any services, requirements or listeners.
     */
    register() {
        const debugPrefix = 'register()';
        // Typically registration should happen just once
        if (this.data.registered) {
            return this;
        }
        // Register a listener for "visitor visit data" set,
        // which is the event triggered once a page changes and
        // the minimum visitor data has been set for that page.
        this.container.bus?.on(['thn:visitor-visit-data.set'], () => {
            if (!this.isTargetPage()) {
                this.logger?.debug?.('Is not target page');
                return;
            }
            if (!this.isOnline()) {
                this.logger?.debug?.('Is not online');
                return;
            }
            if (empty(this.data.reviewersCount)) {
                this.logger?.debug?.('No reviewers');
                return;
            }
            this.show().catch((reason) => {
                this.logger?.error?.(reason);
            });
        });
        this.container.bus?.on('window:message', (event) => {
            const action = event?.data?.action;
            if (!action) {
                return;
            }
            if (action === 'show_review_widget') {
                this.logger.trace(debugPrefix, 'Handled event', event);
                Object.assign(this.data, event.data);
                this.show().catch(() => { });
            }
        });
        this.container.bus?.on('thn:page.unload', () => {
            this.destroy();
        });
        // Super function flags registered=true
        super.register();
        return this;
    }
    /**
     * Shows the review widget.
     *
     * Does not apply if the widget is offline.
     */
    async show() {
        const debugPrefix = 'show()';
        this.logger.debug(debugPrefix, 'Call');
        // nothing to be done when this is a control user
        if (this.isControlUser()) {
            this.data.showed = false;
            this.data.status = 'widget-ok';
            this.sendStatus();
            return this;
        }
        // Fill `this.view` with the appropiate module
        await this.loadView();
        const { globalState } = this.container;
        const bundle = await this.bundleForUi();
        // message the parent to show the price widget
        // please, use the var "bubbles" to avoid messaging the
        // parent even when the script is iframed
        if (this.shouldBubble()) {
            const parentParams = {
                action: 'show_review_widget',
                abTest: this.data.abTest,
                online: this.data.online,
                mobileOnline: this.data.mobileOnline,
                language: globalState.language,
                pageId: globalState.pageId,
                position: this.data.position,
                mobilePosition: this.data.mobilePosition,
            };
            // message
            this.transmit({ ...bundle.params, ...parentParams });
            // register page unload action here
            // eslint-disable-next-line @typescript-eslint/unbound-method
            this.container.pageUnload(this.destroy);
            // end of RW show for the child script
            return this;
        }
        const context = { bundle, debugPrefix };
        // Recheck existance of DOM Elements
        try {
            await this.callView('show', context);
        }
        catch (error) {
            this.logger.warn(debugPrefix, 'Error executing the view\'s create method:', error);
            const status = error?.status || 'component-error';
            // destroy
            this.destroy();
            // update status
            this.data.status = status;
            this.data.showed = false;
            this.sendStatus();
            return this;
        }
        if (this.data.status) {
            // Only when we have a status proceed to send the beacons
            this.sendStatus();
            this.container.sendSiteAnalytics(stringCapitalize(this.data.name));
        }
        return this;
    }
    /**
     * Make an object that bundles RW  config, data, and
     * additionally functions that will be needed in the
     * UI module.
     */
    async bundleForUi() {
        const { globalState } = this.container;
        const language = this.data.language || globalState.language;
        const params = {
            // eslint-disable-next-line @typescript-eslint/naming-convention
            hotel_id: globalState.hotelId,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            property_id: globalState.propertyId,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            page_id: this.data.pageId || globalState.pageId,
            lang: language,
            mobile: globalState.media.name === 'mobile' ? 1 : 0,
        };
        const response = await this.container.fetch('/get_hotel_review_monitor_widget', { body: params });
        const payload = response.ok ? await response.json() : null;
        const bundle = {
            // General
            params,
            payload,
            // This widget data
            ...pick(this.data, [
                'closeTime',
                'deviceCssSelector',
                'deviceFormat',
                'deviceMargin',
                'devicePosition',
                'deviceStyleConfig',
                'formatFamily',
                'formatName',
                'isRightAlign',
                'mirrorRtlLang',
                'position',
                'showClosed',
                'showReviews',
                'showSummarized',
                'topPercent',
                'topPercentType',
            ]),
            // global data
            ...pick(globalState, [
                'bookingSystem',
                'hotelGeoname',
                'hotelLocation',
                'hotelType',
                'prefix',
                'rightAlignLanguages',
            ]),
            // Others / mixed
            browser: this.container.parseUserAgent?.()?.browser || 'Unknown',
            country: globalState.country,
            device: globalState.media.name,
            host: `https://${globalState.hostnameReal || globalState.hostname}`,
            language,
            logger: this.logger,
            orLocName: globalState.overrides?.orLocName,
            widgetName: this.data.name,
            zIndex: this.data.formatFamily?.substr(0, 1) !== 'i'
                ? (this.container.getSetting(`${this.data.name}_z_index`) || this.data.defaultZIndex)
                : (this.container.getSetting(`${this.data.name}_inliner_z_index`) || 'auto'),
        };
        return bundle;
    }
    /**
     * Minimizes the review widget.
     *
     * Does not apply if the widget is offline.
     */
    minimize() {
        // early exit
        if (!this.isOnline()) {
            return this;
        }
        this.callView('minimize');
        return this;
    }
    /**
     * Deletes the DOM Node elements used by the review widget.
     */
    destroy() {
        this.callView('destroy');
        // if iframed mesage the parent
        if (this.shouldBubble()) {
            this.transmit({ action: 'destroy_review_widget' });
        }
        this.reset();
    }
    /**
     * Hides the DOM Node elements used by the review widget.
     *
     * Does nothing if the widget is offline.
     */
    hide() {
        // early exit
        if (!this.isOnline()) {
            return this;
        }
        this.callView('hide');
        return this;
    }
    /**
     * Hides the DOM Node elements of the review widget.
     *
     * Does not apply if the widget is offline.
     * To delete the DOM elements use: widgests.review.destroy
     */
    remove() {
        // early exit
        if (!this.isOnline()) {
            return this;
        }
        this.callView('destroy');
        this.hide();
        // if iframed then message the parent
        if (this.shouldBubble()) {
            this.transmit({ action: 'remove_review_widget' });
        }
        return this;
    }
    sendStatus() {
        const debugPrefix = 'sendStatus()';
        this.logger.debug(debugPrefix, 'Call');
        // "just in case" call the main visit always
        this.container.sendPageVisit();
        const endpoint = '/agent/ack-review';
        this.sendBeacon(endpoint, {
            isAbTestControlUser: this.isControlUser(),
            showed: this.data.showed,
            status: this.data.status || '',
        });
        return this;
    }
}

/**
 * Extract the PW status from a plain PW data.
 *
 * @param original - PW data as originally detected (plain object)
 */
function getStatusFromPriceData(original) {
    const prop = camelCase(PriceStatus.WithoutAvailability);
    if (has(original, prop) && !empty(original[prop])) {
        return PriceStatus.WithoutAvailability;
    }
    return undefined;
}

class Journal {
    registry;
    constructor(data = {}) {
        this.registry = [];
        if (data?.registry && isArray(data.registry)) {
            data.registry.forEach((entry) => {
                this.registry.push(collectionClone(entry));
            });
        }
    }
    push(payload) {
        this.registry.push([Date.now(), payload]);
        return this;
    }
    add = this.push.bind(this);
    get() {
        return this.registry;
    }
}

/**
 * Get a custom enum categorization from a PW data in canonical format.
 * @param actual - PW data canonical
 */
function getSubtypeFromPriceData(actual) {
    if (getStatusFromPriceData(actual.search)) {
        return 'withStatus';
    }
    if (actual.metadata.custom === true) {
        return 'pagesCustom';
    }
    if (actual.metadata.custom === false) {
        return 'pagesLastSearch';
    }
    return 'regular';
}

const DEFAULT_WIDGET_NAME = 'price';
// Relevant data for the identification
const relevantOn = {
    regular: {
        price: {
            config: ['noCheapest', 'priceNight', 'priceRoom'],
            context: ['hotelId', 'language', 'logged', 'propertyId'],
            metadata: [
                // Have or not having the "custom" prop
                // makes a difference, it indicates "pages" modes
                'custom',
            ],
            search: [
                'currency',
                'dateBegin',
                'dateEnd',
                'priceSpecial',
                'priceType',
                // Note: pricematchId is excluded from the relevant data so it can be added later.
                // Although pricematch presence influences the PW results. Given a page context,
                // pricematch rules results should keep quite constant.
                // 'pricematchId',
                'promocode',
                'roomsDispo',
                camelCase(PriceStatus.WithoutAvailability),
            ],
        },
    },
};
relevantOn.regular.package = /* #__PURE__ */ collectionClone(relevantOn.regular.price);
// Relevant data for the identification in "pagesCustom"
relevantOn.pagesCustom = /* #__PURE__ */ collectionClone(relevantOn.regular);
// Relevant data for the identification in "pagesLastSearch"
relevantOn.pagesLastSearch = /* #__PURE__ */ collectionClone(relevantOn.pagesCustom);
// Minimum required data for the identification.
// Without this ones, identification can't be done.
const requiredOn = {
    regular: {
        price: {
            config: [],
            context: ['contextToken', 'fingerprint', 'hotelId', 'propertyId', 'visitDate'],
            metadata: [],
            search: ['currency', 'dateBegin', 'dateEnd', 'roomsDispo'],
        },
    },
};
requiredOn.regular.package = /* #__PURE__ */ collectionClone(requiredOn.regular.price);
// Minimum required data for searches "with status"
requiredOn.withStatus = {
    price: {
        config: [],
        context: [
            'contextToken',
            'fingerprint',
            'hotelId',
            'propertyId',
            'visitDate',
        ],
        metadata: [],
        search: [],
    },
};
requiredOn.withStatus.package = /* #__PURE__ */ collectionClone(requiredOn.withStatus.price);
// Minimum required data for searches "pagesCustom"
requiredOn.pagesCustom = /* #__PURE__ */ collectionClone(requiredOn.regular);
// Minimum required data for searches "pagesLastSearch"
requiredOn.pagesLastSearch = /* #__PURE__ */ collectionClone(requiredOn.withStatus);
/**
 * Identify uniquely a given PW data.
 *
 * @param {object} actual - The PW data in canonical format.
 * @return {string}
 */
function priceIdentify(actual) {
    const widgetName = actual?.context?.widgetName || DEFAULT_WIDGET_NAME;
    const subtype = getSubtypeFromPriceData(actual);
    const relevant = relevantOn[subtype]?.[widgetName]
        || relevantOn.regular[widgetName];
    const fields = Object.keys(relevant);
    const required = requiredOn[subtype]?.[widgetName]
        || requiredOn.regular[widgetName];
    // Guard: no identification possible without required
    if (!fields.every((key) => has(actual[key], required[key]))) {
        throw new Error('invalid-data');
    }
    // Copy, sort arrays, and pick the relevant
    const data = collectionClone(actual);
    if (data.search.roomsDispo) {
        data.search.roomsDispo.forEach((room) => {
            room.childrenAges?.sort();
        });
    }
    fields.forEach((key) => {
        data[key] = pick(data[key], relevant[key]);
    });
    // Flat, sort and identify
    const flat = flattenObject(data);
    const hasheable = Object.keys(flat)
        .map((key) => [key, flat[key]])
        .sort();
    const stringified = stringify(hasheable);
    return md5(stringified);
}

const update = function update(props = {}) {
    Object.assign(this.state, props);
    this.state.updatedAt = Date.now();
    this.logger.add(`updated ${stringify(props)}`);
    return this;
};
class Searches {
    Logger;
    Timer;
    registry;
    adapter;
    transform;
    identify;
    normalize;
    scheduler;
    constructor({ adapter, transform = comparisonStandardModel.transform, identify = priceIdentify, normalize = identity, Logger = Journal, Timer = Recorder, scheduler, }) {
        this.registry = new Map();
        this.adapter = adapter;
        this.transform = transform;
        this.identify = identify;
        this.normalize = normalize;
        this.Logger = Logger;
        this.Timer = Timer;
        this.scheduler = scheduler;
    }
    // eslint-disable-next-line class-methods-use-this
    isEntry(object) {
        return !!(object && object._isSearch);
    }
    entryFactory(original) {
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const searches = this;
        let entry;
        if (this.isEntry(original)) {
            // When input is already an entry
            // eslint-disable-next-line @typescript-eslint/unbound-method
            if (isFunction(original.update)) {
                // If no need to revive, keep it "as is"
                entry = original;
            }
            else {
                // Revive it because at this point we now that it is a serialized object
                // that we want to "revive" in order to have a new instance of Recorder.
                entry = {
                    ...original,
                    timer: new this.Timer(original.timer),
                    logger: new this.Logger(original.logger),
                    update,
                };
                // Warning: defining the getter directly in the object
                // makes that property enummerable, contrary to what docs say:
                // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get
                Object.defineProperty(entry, '_searches', {
                    // Must be non-enumerable
                    get() {
                        return searches;
                    },
                });
                const entryPromise = Promise$1.resolve(entry);
                entry.state.init = entryPromise;
                entry.state.get = entryPromise;
                entry.logger.add('revive');
                entry.update();
            }
            return entry;
        }
        // Create a brand new entry
        entry = {
            _isSearch: true,
            data: {
                original,
                actual: this.transform(original),
                request: this.adapter.transform(original),
                response: {},
            },
            get debugId() {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                return isFunction(searches.adapter.debugId)
                    ? searches.adapter.debugId(this) : this.id;
            },
            get debugUrl() {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                return isFunction(searches.adapter.debugUrl)
                    ? searches.adapter.debugUrl(this) : '';
            },
            state: {
                createdAt: Date.now(),
                current: true,
            },
            timer: new this.Timer(),
            logger: new this.Logger(),
            times: {},
            update,
        };
        // Warning: defining the getter directly in the object
        // makes that property enummerable, contrary to what docs say:
        // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get
        Object.defineProperty(entry, '_searches', {
            // Must be non-enumerable
            get() {
                return searches;
            },
        });
        return entry;
    }
    create(original) {
        const entry = this.entryFactory(original);
        entry.timer.time('total');
        entry.id = this.identify(entry.data.actual);
        entry.logger.add('create');
        const status = getStatusFromPriceData(original);
        // If an status is inferred from the original data
        // everything is resolved immediately here
        if (status) {
            entry.data.response = {
                _isSynthetic: true,
                status,
            };
            Object.assign(entry.state, {
                init: Promise$1.resolve(entry),
                initOk: true,
                get: Promise$1.resolve(entry),
                getOk: true,
                status,
            });
        }
        entry.update();
        return entry;
    }
    getCurrentEntry() {
        let found;
        this.registry.forEach((entry) => {
            if (entry.state.current === true) {
                found = entry;
            }
        });
        return found;
    }
    getLatestEntry(predicate = identity) {
        let found;
        let max = 0;
        this.registry.forEach((entry) => {
            if (entry.state.updatedAt && entry.state.updatedAt > max && predicate(entry)) {
                max = entry.state.updatedAt;
                found = entry;
            }
        });
        return found;
    }
    clearCurrentEntry() {
        this.registry.forEach((entry) => {
            if (entry.state.current === true) {
                // Note that unseting the current entry implies stop "showing" (if it was)
                entry.update({
                    current: false,
                    showing: false,
                });
            }
        });
    }
    getEntry(original) {
        let entry;
        // If we are adding an entry,
        // revive it, set as current and return
        if (this.isEntry(original)) {
            entry = this.entryFactory(original);
            if (!entry.id) {
                return entry;
            }
            // Note we don't check existence,
            // this would overwrite
            this.registry.set(entry.id, entry);
            return entry;
        }
        // If we are adding plain data, try to identify it
        const transformed = this.transform(original);
        const id = this.identify(transformed);
        if (this.registry.has(id)) {
            // If we have it, just update the data
            // WARNING: only *new* data may be incorporated, existing props prevail
            entry = this.registry.get(id);
            if (entry) {
                merge(entry.data.original, original, collectionClone(entry.data.original));
                merge(entry.data.actual, transformed, collectionClone(entry.data.actual));
                merge(entry.data.request, this.adapter.transform(original), collectionClone(entry.data.request));
                entry.update();
            }
        }
        else {
            // If it is new data, create an entry and store
            entry = this.create(original);
            this.clearCurrentEntry();
            if (entry?.id) {
                this.registry.set(entry.id, entry);
            }
        }
        return entry;
    }
    add(original) {
        const op = 'init';
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const searches = this;
        const entry = this.getEntry(original);
        if (entry.state.init) {
            this.clearCurrentEntry();
            entry.update({ current: true });
            return entry.state.init;
        }
        entry.timer.time(op);
        entry.logger.add(`${op} start`);
        const lastly = () => {
            entry.times.init = entry.timer.timeEnd(op);
            entry?.update();
            return entry;
        };
        entry.state.init = this.scheduler?.yield()
            .then(() => this.adapter.init?.(entry))
            .then((response) => {
            entry.update({ initOk: true });
            entry.logger.add(`${op} resolved`);
            if (response && entry.data.response) {
                Object.assign(entry.data.response, searches.normalize(searches.adapter.normalize(response)));
            }
            return lastly();
        }, (error) => {
            entry.update({ initOk: false, status: entry.state.status ?? 'error-http' });
            entry.logger.add(`${op} rejected${error ? `: ${error.message}` : ''}`);
            return lastly();
        });
        return entry.state.init;
    }
    async visit(original) {
        const op = 'visit';
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const searches = this;
        const entry = this.getEntry(original);
        if (entry.state.visit) {
            return entry.state.visit;
        }
        entry.logger.add(`${op} call`);
        const lastly = () => {
            entry.times.visit = entry.timer.timeEnd(op);
            entry.times.total = entry.timer.timeEnd('total');
            entry.update({ visited: true });
            return entry;
        };
        try {
            await this.get(entry);
            entry.timer.time(op);
            entry.logger.add(`${op} start`);
            await searches.adapter.visit(entry);
            entry.update({ visitOk: true });
            entry.logger.add(`${op} resolved`);
            return lastly();
        }
        catch (error) {
            entry.update({ visitOk: false });
            if (error instanceof Error) {
                entry.logger.add(`${op} rejected${error ? `: ${error.message}` : ''}`);
            }
            return lastly();
        }
    }
    // This method returns a Promise, but it may throw synchronously before the Promise is created.
    // Ensure to handle both synchronous and asynchronous errors.
    get(original) {
        const op = 'get';
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const searches = this;
        const entry = this.getEntry(original);
        if (entry.state.get) {
            return entry.state.get;
        }
        entry.logger.add(`${op} call`);
        const lastly = () => {
            entry.times.get = entry.timer.timeEnd(op);
            if (!entry.state.status) { // If not already set ...
                entry.update({ status: entry.data.response?.status });
            }
            entry.update();
            return entry;
        };
        entry.state.get = this.add(original)?.then(() => {
            entry.timer.time(op);
            entry.logger.add(`${op} start`);
            return entry.state.initOk
                ? searches.adapter.get(entry) : entry;
        }).then((response) => {
            if (!entry.state.initOk) {
                throw new Error();
            }
            entry.update({ getOk: true });
            if (entry.data.response) {
                Object.assign(entry.data.response, searches.normalize(searches.adapter.normalize(response)));
            }
            entry.logger.add(`${op} resolved`);
            return lastly();
        }).catch((error) => {
            entry.update({ getOk: false });
            if (!entry.state.status) { // If not already set ...
                entry.update({
                    status: (error && error.message === 'timeout') ? 'error-client-timeout' : 'error-client',
                });
            }
            entry.logger.add(`${op} rejected${error ? `: ${error.message}` : ''}`);
            return lastly();
        });
        return entry.state.get;
    }
}

class Snippet extends WidgetWithTools {
    get __default() {
        return {
            ...super.__default,
            id: 'snippet-widget',
            name: 'snippet',
            online: 1,
            timeoutMs: 10000,
        };
    }
    async load({ tool }) {
        const debugPrefix = 'load()';
        this.logger?.debug(debugPrefix, 'Call', tool);
        tool.updateState({ processed: true });
        let workError;
        const toolActions = tool.getActions();
        try {
            const workPromises = toolActions.map((action) => {
                if (action.kind === AgentActionKind.LoadScript) {
                    return AbortablePromise.from(this.container.loadScript(action.source), { timeout: { milliseconds: this.data.timeoutMs } });
                }
                if (action.kind === AgentActionKind.PredictiveAudience) {
                    return this.container.sendSiteAnalytics(AnalyticsEventName.Audience, {
                        predictiveAudienceId: action.predictiveAudienceId,
                        // Send the param also in snake_case format to be compatible with the legacy format values that we were sending to GA
                        predictive_audience_id: action.predictiveAudienceId,
                    }, true);
                }
                return true;
            });
            await Promise$1.all(workPromises);
        }
        catch (error) {
            workError = error;
        }
        tool.updateState({
            showed: !workError,
            manualStatus: workError ? 'error' : '',
        });
        this.sendStatus(tool);
        if (toolActions.every((action) => action.kind !== AgentActionKind.PredictiveAudience)) {
            this.container.sendSiteAnalytics(stringCapitalize(this.data.name) /* as typeof this.data.name */, { messageId: tool.getId() });
        }
        return this;
    }
}

/* eslint-disable @typescript-eslint/naming-convention */
class SearchesSseAdapter {
    container;
    host;
    routePrefix;
    normalize;
    timeout;
    Timer;
    transform;
    debug;
    constructor({ container, host = '', routePrefix = '', normalize = identity, timeout = 30000, Timer = Recorder, transform = comparisonSseModel.transform, debug = false, }) {
        this.container = container;
        this.host = host;
        this.routePrefix = routePrefix;
        this.normalize = normalize;
        this.timeout = timeout;
        this.Timer = Timer;
        this.transform = transform;
        this.debug = debug;
    }
    traceparent(entry) {
        const versionFormat = '00';
        const parentId = `000000000000000${entry.data.request.metadata.parent_id}`.slice(-16);
        const traceFlags = this.debug ? '01' : '00';
        // eslint-disable-next-line no-param-reassign
        entry.data.request.metadata.parent_id += 1;
        return `${versionFormat}-${entry.data.request.metadata.trace_id}-${parentId}-${traceFlags}`;
    }
    // eslint-disable-next-line class-methods-use-this
    preparePayload(data, { entry, warm = true } = {}) {
        const payload = collectionClone(data);
        // If this is a "normal" init call (i.e. a warm call)
        // then we void the price and generate a fake search_id
        // because we are not expecting any response
        if (warm && payload?.data?.params) {
            delete payload.data.params.price;
            delete payload.data.params.price_special;
            payload.data.params.search_id = ulid();
        }
        // TODO: remove this once backend handles metadata.page_id
        const pageId = payload?.metadata?.page_id;
        if (pageId) {
            set(payload, 'data.params.page_id', pageId);
        }
        return {
            contextToken: entry?.data?.request?.contextToken,
            ...payload,
            metadata: payload.metadata && omit(payload.metadata, ['parent_id', 'trace_id']),
        };
    }
    async visit(entry) {
        // Exception for "pagesLastSearch" subtype
        if (isPagesLastSearchEntry(entry)) {
            return false;
        }
        if (entry.state.status === 'error-forbidden') {
            return false;
        }
        const action = (entry.data?.response?._isSynthetic || entry.state?.status?.match(/^error-/))
            ? 'direct-visit'
            : 'visit';
        const url = `${this.routePrefix}/comparison/${entry.data.actual.context.widgetName}/${entry.data.request.data.params.search_id}/${action}`;
        entry.logger.add(`adapter visit: ${url}`);
        const traceparent = this.traceparent(entry);
        // In case this entry response has been generated
        // in the client (is not a real backend response)
        // then we need to incorporate all the "init" data
        const payload = action === 'direct-visit'
            ? collectionClone(entry.data.request)
            : { data: {}, metadata: {} };
        Object.assign(payload.data, {
            // Alternatively search_id may be found on path
            // "entry.data.response.search.id"
            search_id: entry.data.request.data.params.search_id,
            showed: entry.state.showed,
            status: entry.state.status,
            version: entry.data.response?.search?.version,
        });
        const body = this.preparePayload(payload, { entry, warm: false });
        entry.logger.add(`adapter payload: ${stringify(body)}`);
        entry.logger.add(`adapter traceparent: ${traceparent}`);
        const res = await this.container.fetch(`${url}?traceparent=${traceparent}`, {
            body,
            timeout: {
                milliseconds: this.timeout,
            },
        });
        if (!res.ok) {
            throw new Error('error');
        }
        return res.ok;
    }
    async init(entry, { warm = true } = {}) {
        // subtype "pagesLastSearch" is the only one that doesn't need warming
        const isPagesLastSearch = isPagesLastSearchEntry(entry);
        if (isPagesLastSearch && warm === true) {
            entry.logger.add('adapter init: avoided warm call for "pagesLastSearch"');
            return Promise$1.resolve(false);
        }
        const url = `${this.routePrefix}/comparison/${isPagesLastSearch ? 'last-shown' : entry.data.actual.context.widgetName}`;
        entry.logger.add(`adapter init: ${url} (${warm ? 'warm' : 'internal'})`);
        const traceparent = this.traceparent(entry);
        const body = this.preparePayload(entry.data.request, { entry, warm });
        entry.logger.add(`adapter payload: ${stringify(body)}`);
        entry.logger.add(`adapter traceparent: ${traceparent}`);
        const res = await this.container.fetch(`${url}?traceparent=${traceparent}`, {
            body,
            timeout: {
                milliseconds: this.timeout,
            },
        });
        if (!res.ok) {
            entry.update({ status: res.status === 100 ? 'error-forbidden' : 'error-http' });
            throw new Error('error');
        }
        return res.ok;
    }
    async get(entry) {
        const capture = (error) => {
            if (!this.container || !this.container.$has('errorMonitor')) {
                return;
            }
            this.container.errorMonitor.addError(error, {
                'eventSource.readyState': error.original?.target?.readyState || error.target?.readyState,
                search_id: entry.data?.request?.data?.params?.search_id,
                trace_id: entry.data?.request?.metadata?.trace_id,
            });
        };
        if (!has(entry.data.request.data.params, 'price') && !isPagesLastSearchEntry(entry)) {
            // eslint-disable-next-line no-param-reassign
            entry.data.response = {};
            throw new Error('invalid-data');
        }
        entry.logger.add('adapter get');
        const url = `${this.host}/sse`;
        const topic = `/comparison/${entry.data.actual.context.widgetName}/${entry.data.request.data.params.search_id}/{event_type}`;
        const sseEndpoint = `${url}?topic=${topic}`;
        const sseResponsePromise = new Promise$1((resolve, reject) => {
            let eventSource;
            let eventSourceTimer;
            const closeEventSource = () => {
                try {
                    entry.logger.add('adapter sse close');
                    eventSource?.close();
                    eventSource = undefined;
                }
                catch (_) { /* empty */ }
            };
            const closeEventSourceAndClearTimer = () => {
                if (eventSourceTimer) {
                    clearTimeout(eventSourceTimer);
                    eventSourceTimer = undefined;
                }
                closeEventSource();
            };
            eventSourceTimer = setTimeout(() => {
                entry.logger.add('adapter sse timeout');
                reject(new Error('timeout'));
                closeEventSource();
            }, this.timeout);
            try {
                // EventSource request should be credentialized to avoid multiple HTTP2 conns
                eventSource = new this.container.globalThis.EventSource(sseEndpoint, { withCredentials: true });
            }
            catch (error) {
                capture(error);
                entry.update({ status: 'error-sse' });
                if (error instanceof Error) {
                    entry.logger.add(`adapter sse intantiation error: ${error.message}`);
                }
                reject(new Error('error'));
                closeEventSourceAndClearTimer();
                return;
            }
            eventSource.onerror = (event) => {
                // ref: https://developer.mozilla.org/en-US/docs/Web/API/EventSource/readyState
                // A number representing the state of the connection. Possible values are:
                // 0 — connecting
                // 1 — open
                // 2 — closed
                const readyState = event.target?.readyState;
                if (readyState !== undefined) {
                    entry.logger.add(`adapter sse: onerror callback invoked (readyState: ${readyState})`);
                }
                if (readyState === 0 || readyState === 2) {
                    // If the EventSource is "connecting" or "closed" let's ignore the onerror call as the browser should retry.
                    return;
                }
                // Otherwise...
                // 1 — open: if the connection is open, what causes an "onerror" invokation? log
                const synthetic = new Error('EventSource');
                synthetic.original = event;
                capture(synthetic);
                entry.update({ status: 'error-sse' });
                reject(new Error('error'));
                closeEventSourceAndClearTimer();
            };
            eventSource.onmessage = (event) => {
                if (!event || !event.data) {
                    entry.logger.add('warn! adapter sse event empty');
                    return;
                }
                entry.logger.add(`adapter sse event: ${stringify(event)}`);
                try {
                    const data = JSON.parse(event.data);
                    resolve(data);
                }
                catch (error) {
                    capture(error);
                    entry.update({ status: 'error-sse-json' });
                    if (error instanceof Error) {
                        entry.logger.add(`adapter sse error: ${error.message}`);
                    }
                    reject(new Error('error'));
                }
                closeEventSourceAndClearTimer();
            };
        });
        const [sseResponse] = await Promise$1.all([
            sseResponsePromise,
            this.init(entry, { warm: false }),
        ]);
        entry.logger.add(`adapter get success: ${stringify(sseResponse)}`);
        return sseResponse;
    }
    // eslint-disable-next-line class-methods-use-this
    debugId(entry) {
        const searchId = entry.data?.request?.data?.params?.search_id;
        const traceId = entry.data?.request?.metadata?.trace_id;
        if (!searchId && !traceId) {
            return '';
        }
        return `${searchId || '--'} [trace-id: ${traceId || '--'}]`;
    }
    // eslint-disable-next-line class-methods-use-this
    debugUrl(entry) {
        const searchId = entry.data?.request?.data?.params?.search_id;
        return `https://comparison-debug.thehotelsnetwork.com/?search_id=${searchId}`;
    }
}

class SwapsToolLike {
    rulesConfig;
    devices;
    toolPages;
    sites;
    constructor(config, devices, pages, sites) {
        this.rulesConfig = new RulesConfig(toCamelCase$1(config));
        this.devices = [];
        if (devices.desktop) {
            this.devices.push(Device.Desktop);
        }
        if (devices.mobile) {
            this.devices.push(Device.Mobile);
        }
        this.toolPages = pages.map((page) => ({ name: page }));
        this.sites = sites;
    }
    getRulesConfig() {
        return this.rulesConfig;
    }
    getPages() {
        return this.toolPages;
    }
    getSites() {
        return this.sites;
    }
    getDevices() {
        return this.devices;
    }
}

const extraRules = [
    'current_page',
    'scheduled_dates',
    'scheduled_days',
    'scheduled_time',
    'site',
];
class RuleChecker {
    container;
    logger;
    rulesEvaluator;
    constructor(container, logger) {
        this.container = container;
        this.logger = logger;
        const swapsRules = Object.values(index).filter((rule) => rule.kind === RuleKind.Targeting || extraRules.includes(rule.id));
        this.rulesEvaluator = new RulesEvaluator(swapsRules, this.container);
    }
    async checkRules(config, devices, pages, sites) {
        const swapTool = new SwapsToolLike(config, devices, pages, sites);
        const result = await this.rulesEvaluator.evaluate(swapTool);
        return result;
    }
}

/**
 * The Layer widget.
 */
class Layer extends Popup {
    get __default() {
        return {
            ...super.__default,
            id: 'eighty_close_welcome_widget',
            name: 'layer',
            online: 0,
            abTest: 0,
            showed: false,
            windowHasScrolled: false,
            desktopDefaultZIndex: 999999998, // Important: less than the Exit z-index
            mobileDefaultZIndex: 999999997, // Important: less than Kitt and Exit z-index
            bubbles: false,
            delegated: null,
            widgetTypeId: WidgetTypeId.Layer,
        };
    }
    get __preserved() {
        return [
            ...super.__preserved,
            'window_has_scrolled',
        ];
    }
    /**
     * Reset the layer widget data.
     */
    reset() {
        Object.assign(this.data, {
            windowHasScrolled: false,
        });
        return this;
    }
    /**
     * Load the layer popup widget.
     *
     * Does not apply if the widget is offline.
     * Loads the layer widget contents.
     *
     * For the layer popups that requires a non-100% width div
     * some properties need to wait until the user focus the screen.
     * Otherwise the width is not "valid" an weird values are set.
     * This is a peculiar behaviour (not sure why) but it is hard
     * to reproduce because depends on load times (network) :/
     */
    async load({ tool: toolInstance }) {
        const debugPrefix = 'load()';
        // ------------------------------
        // Special Layer load postposed
        // ------------------------------
        // If the browser tab is not focused AND
        // the delayed load checker is not setup
        if (this.container.globalThis.document.hidden && !this.data.delayedLoad) {
            // Setup the delayed load checker:
            // Each 500ms check if browser tab has obtained focus
            // Once this happens, shut down the checker and
            // execute layer.load() as usual
            this.logger.debug(debugPrefix, 'Loading delayed until tab gains focus, setting up a checker');
            const load = () => this.load({ tool: toolInstance });
            this.data.delayedLoad = setInterval(() => {
                if (!this.container.globalThis.document.hidden) {
                    this.logger.debug(debugPrefix, 'Focus detected, shutting down checker, proceed to loading');
                    clearInterval(this.data.delayedLoad);
                    delete this.data.delayedLoad;
                    load().catch(() => { });
                }
            }, 500);
            // early exit
            return this;
        }
        // -------------------------------
        // Regular Layer load processing
        // -------------------------------
        this.logger.debug(debugPrefix, 'Call');
        const tool = await toolInstance.onReady();
        const toolState = tool.getState();
        // Early exit
        if (toolState.processed || !toolState.toBeShown) {
            return false;
        }
        let context;
        const show = cancellable(() => {
            if (!context) {
                throw new Error('Unable to show without a context');
            }
            // Early exit:
            // - Exit widget is visible and the Layer format is blocking
            if (this.container.exit.isVisible() && this.isBlocking(false)) {
                return false;
            }
            // Show only if it's not A/B test control user
            if (!toolState.controlSelected) {
                // Logs
                this.logger.debug(debugPrefix, 'Showing:', tool);
                // Exec the view's implementation of "show"
                this.callView('show', {
                    ...context,
                    debugPrefix,
                });
                // Update the tool state
                tool.updateState({ showed: true });
            }
            // Send the definitive beacon
            this.sendStatus(tool);
            // Call site google analytics
            this.container.sendSiteAnalytics(stringCapitalize(this.data.name), { messageId: tool.getId() });
            if (toolState.controlSelected) {
                // Trigger the onHide hook as if the tool had been shown and closed
                context.bundle.actions.find((action) => action.kind === AgentActionKind.Hide)?.handler?.().catch(() => { });
            }
            return true;
        });
        this.onDestroy(() => { show.cancel(); });
        // message the parent to show the layer widget
        // please, use the var "bubbles" to avoid messaging the
        // parent even when the script is iframed
        if (this.shouldBubble(tool)) {
            // and show the tool on parent
            this.bubble({
                action: 'load_delegated_tool',
                tool: this.bundleForDelegation({ tool }),
                widgetName: this.data.name,
            });
            // end of Layer Widget load on the child script
            tool.updateState({ processed: true });
            return this;
        }
        tool.updateState({ processed: true });
        await this.loadView();
        context = {
            bundle: await this.bundleForUi({ tool }),
        };
        show();
        return !!tool.getState().toBeShown;
    }
    /**
     * Denotes if the widget is blocking the screen.
     *
     * This is used to avoid showing other "full screen" popups.
     */
    isBlocking(checkVisibility = true) {
        const currentTool = this.getData().tools?.find((tool) => tool.getState().toBeShown && !tool.getState().closed);
        return !!(
        // either we do not check visibility, or this is visible
        (!checkVisibility || this.isVisible())
            && currentTool?.isModal());
    }
}

export { Booking, BookingDraft, CSS_PREFIX, Chat, Exit, Inliner, Kitt, Layer, MESSAGE_ACTION_APPLY_DISCOUNT, MESSAGE_ACTION_DISMISS, MESSAGE_ACTION_ENGAGE, MESSAGE_ACTION_GENERIC_LINK_CLICK, MESSAGE_ACTION_LOGIN, MESSAGE_ACTION_NATIVE_DESTROY_INLINER, MESSAGE_ACTION_NATIVE_SHOW_INLINER, MESSAGE_ACTION_NO_ACTION, MESSAGE_ACTION_OPEN_BE, MESSAGE_ACTION_OPEN_URI, MESSAGE_ACTION_SEND_ACTIVITY, MESSAGE_ACTION_SEND_FORM, MESSAGE_ACTION_SEND_SAVE_SEARCH, MESSAGE_ACTION_SEND_SITE_CONTACT, MESSAGE_ACTION_SEND_STATUS, MESSAGE_ACTION_SEND_SUBSCRIBE, NO_CHILD_ELEMENTS, Note, Package, Price, Pricematch, RULES_FAIL_ICON, RULES_FAIL_MSG, RULES_FAIL_TEXT, RULES_PASS_ICON, RULES_PASS_MSG, RULES_PASS_TEXT, Review, RuleChecker, Searches, SearchesSseAdapter, Snippet, Widget };
